import { Component, OnInit, ViewChild, TemplateRef, ChangeDetectorRef, Input, ElementRef, Output, EventEmitter, HostBinding } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { AjaxService } from "src/app/service/ajax.service";
import { API } from "src/environments/environment";
import { UtilService } from "src/app/service/util.service";
import '../../../../../node_modules/tinymce/tinymce.min.js';

interface IdValueItem {
  id: number;
  text: string;
}

interface ConsultaOrcamentoLookupItem {
  idConsulta: number;
  descricao: string;
}

interface MicroservicoLookupItem {
  idTabelaFin: number;
  itemMicroservico: string;
  descricaoMicroservico: string;
  nomeFornecedor: string;
  valor: number;
}

interface OrcamentoItemGrid {
  selecionado: boolean;
  idTabelaFin: number;
  item: string;
  descricao: string;
  parceiro: string;
  quantidade: number;
  valor: number;
  observacao: string;
}

interface OrcamentoConsultaItem {
  idOrcamento: number;
  idConsulta: number;
  titulo: string;
  data: string;
  observacao: string;
  clienteVer?: boolean;
  orcamentoAprovado?: boolean;
  financeiroGerado?: boolean;
  dataGeracaoFinanceiro?: string;
}

interface OrcamentoDetalheItemApi {
  idTabelaValor: number;
  quantidade: number;
  observacao: string;
}

interface TipoArquivoDocumentoItem {
  idTipoArquivo: number;
  descricao: string;
}

interface TipoRecebimentoOpcao {
  id: number;
  descricao: string;
}

interface StatusGeralServicoOpcao {
  idStatusGeral: number;
  titulo: string;
}

interface TipoDocumentoServicoOpcao {
  idTipoDocumento: number;
  titulo: string;
}

interface TipoDocumentoBuscaBrasilAdmin {
  idTipoDocumento: number;
  titulo: string;
  descricao: string;
}

interface BuscaBrasilItemLinha {
  idDocumentosProvidenciado: number;
  idTipoDocumento: number | null;
  titular: string;
  estado: string;
  cidade: string;
  quantidade: number;
  solicitado: string;
  recebido: string;
  tradutor: string;
  revisor: string;
  /** Aba Tradução: apostilar documento (por linha). */
  apostilarDocumento: boolean;
  /** Aba Tradução: apostilar tradução (por linha). */
  apostilarTraducao: boolean;
}

/** Grid da aba Responsável: catálogo CAD_RESPONSAVEL + vínculo USU_RESPONSAVEL do cliente. */
interface ResponsavelClienteLinha {
  idUsuResponsavel: number;
  idCadResponsavel: number;
  responsavel: string;
  sigla: string;
  ordem: number;
  /** yyyy-MM-dd para input type="date" */
  data: string;
  setar: boolean;
}


@Component({
  selector: "app-cadastro-cliente",
  templateUrl: "./cadastro-cliente.component.html",
  styleUrls: ["./cadastro-cliente.component.scss"],
})
export class CadastroClienteComponent implements OnInit {
  private static readonly REGEX_CPF = /^\d{3}\.\d{3}\.\d{3}-\d{2}$/;
  private static readonly REGEX_CNPJ = /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/;

  tipoPessoa: 'PF' | 'PJ' = 'PF';
  @Input() somenteAbaCliente: boolean = false;
  /** Quando true, o componente é embutido em modal (ex.: home-gestao) e não lê query params da rota. */
  @Input() modoModal = false;
  @Input() clienteIdModal: number | null = null;
  @Input() clienteDataModal: any = null;
  @Output() fecharModalSolicitado = new EventEmitter<void>();
  @Output() clienteSalvo = new EventEmitter<{ idPaciente: number; idUsuario: number | null }>();
  @HostBinding('class.modo-modal') get hostModoModal(): boolean {
    return this.modoModal;
  }

  idPacienteEdicao: number = 0;
  private idEmpresaEdicao: number = 1;
  private idUsuarioEdicao: number | null = null;
  private idCidadeEdicao: number | null = null;
  private idEstadoEdicao: number | null = null;
  private idPaisEdicao: number | null = null;
  private idPaisPendente: number | null = null;
  private estadoEdicaoNome: string = '';
  private isCarregandoEstados: boolean = false;
  private isCarregandoCidades: boolean = false;
  paisesDisponiveis: string[] = ['Brasil', 'Italia'];
  readonly estadosPorPais: { [key: string]: string[] } = {
    Brasil: ['AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'],
    Italia: ['Piemonte', 'Lombardia', 'Veneto', 'Liguria', 'Emilia-Romagna', 'Toscana', 'Lazio', 'Campania', 'Sicilia', 'Sardegna', 'Puglia', 'Calabria', 'Abruzzo', 'Molise', 'Marche', 'Umbria', 'Basilicata', 'Friuli-Venezia Giulia', 'Trentino-Alto Adige', "Valle d'Aosta"]
  };
  estadosDisponiveis: IdValueItem[] = [];
  cidadesDisponiveis: IdValueItem[] = [];
  cidadesFiltradas: IdValueItem[] = [];
  cidadeBuscaTexto: string = '';
  mostrarListaCidades: boolean = false;

  // Propriedade para controlar a aba ativa
  abaAtiva: string = 'cliente';
  private abasValidas = ['cliente', 'comunicacao', 'servicos', 'documento', 'arvore', 'orcamentos', 'sharepoint', 'responsavel'];
  contextoGlobalExpandido: boolean = true;
  
  // Propriedade para controlar a sub-aba ativa
  subAbaAtiva: string = '';
  readonly opcoesSubAbasServicos: { id: string; label: string; icone: string }[] = [
    { id: 'naturalizacao', label: 'Naturalização', icone: 'fas fa-passport' },
    { id: 'jud-ita', label: 'Cidadania', icone: 'fas fa-gavel' },
    { id: 'aire', label: 'AIRE', icone: 'fas fa-id-card' },
    { id: 'fast-it', label: 'Fast-It', icone: 'fas fa-bolt' },
    { id: 'traducao', label: 'Tradução', icone: 'fas fa-language' },
    { id: 'busca-documentos', label: 'Busca de Documentos', icone: 'fas fa-search' }
  ];
  subAbasServicosSelecionadas: string[] = [];

  readonly statusAdministrativoOpcoes: { valor: string; rotulo: string }[] = [
    { valor: 'EM_PREPARO', rotulo: 'Em preparo' },
    { valor: 'EM_STAND_BY', rotulo: 'Em stand by' },
    { valor: 'CONCLUIDO', rotulo: 'Concluído' },
    { valor: 'NAO_FINALIZADO', rotulo: 'Não finalizado' },
  ];

  readonly tribunaisCidadaniaOpcoes: string[] = [
    'ROMA',
    'VENEZIA',
    'MILANO',
    'ANCONA',
    'AQUILA',
    'BARI',
    'BENEVENTO',
    'BRESCIA',
    'BOLOGNA',
    'BOLZANO',
    'CAGLIARI',
    'CAMPOBASSO',
    'CATALNISSETTA',
    'CATANIA',
    'CATANZARO',
    'FIRENZE',
    'GENOVA',
    'LECCE',
    'MESSINA',
    'NAPOLI',
    'PALERMO',
    'PERUGIA',
    'POTENZA',
    'REGGIO CALABRIA',
    'SALERNO',
    'SASSARI',
    'TARANTO',
    'TORINO',
    'TRENTO',
    'TRIESTE',
  ];
  
  // Propriedade para controlar qual sub-aba de busca está ativa
  subAbaBuscaAtiva: string = 'brasil';

  /** Tipos de arquivo (TIPO_ARQUIVO) — aba Documentos */
  tiposArquivoDocumentos: TipoArquivoDocumentoItem[] = [];
  carregandoTiposArquivoDocumentos = false;
  abaTipoArquivoAtivaId: number | null = null;

  /** STATUS_GERAL_SERVICOS onde TIPO = STATUS_SERVICO (naturalização, AIRE, Fast-It, …). */
  statusNaturalizacaoOpcoes: StatusGeralServicoOpcao[] = [];
  carregandoStatusNaturalizacao = false;

  /** STATUS_GERAL_SERVICOS — status por aba de serviço. */
  statusTraducaoOpcoes: StatusGeralServicoOpcao[] = [];
  carregandoStatusTraducao = false;
  statusBuscaBrasilOpcoes: StatusGeralServicoOpcao[] = [];
  carregandoStatusBuscaBrasil = false;
  statusBuscaItaliaOpcoes: StatusGeralServicoOpcao[] = [];
  carregandoStatusBuscaItalia = false;

  private readonly tipoStatusTraducao = 'STATUS_TRADUCAO';
  private readonly tipoStatusBuscaBrasil = 'STATUS_BUSCA_BRASIL';
  private readonly tipoStatusBuscaItalia = 'STATUS_BUSCA_ITALIA';
  /** Alterna texto/senha no campo Account Ministério (aba Naturalização). */
  naturalizacaoSenhaVisivel = false;
  /** Conta Portal — aba AIRE. */
  aireSenhaVisivel = false;
  /** Conta Portal — aba Fast-It. */
  fastItSenhaVisivel = false;
  /** Exibe/oculta a seção Apelo; espelha `HABILITAR_APELO` (USU_CIDADANIA) ao carregar/salvar. */
  judItaSecaoApeloVisivel = false;
  private naturalizacaoDadosPacienteCarregados: number = -1;

  /** USU_CIDADANIA já carregada para este idPaciente (-1 = nunca nesta sessão). */
  private cidadaniaDadosPacienteCarregados: number = -1;

  /** USU_AIRE já carregada para este idPaciente. */
  private aireDadosPacienteCarregados: number = -1;

  /** USU_FAST_IT já carregada para este idPaciente. */
  private fastItDadosPacienteCarregados: number = -1;

  /** USU_TRADUCAO já carregada para este idPaciente. */
  private traducaoDadosPacienteCarregados: number = -1;

  /** TIPO_DOCUMENTO e NOME_ABA com chave Traducao (aba Tradução). */
  tiposDocumentoTraducaoOpcoes: TipoDocumentoServicoOpcao[] = [];
  carregandoTiposDocumentoTraducao = false;
  modalTipoDocumentoTraducaoAberto = false;
  tiposDocumentoTraducaoModalLista: TipoDocumentoBuscaBrasilAdmin[] = [];
  carregandoTiposDocumentoTraducaoModal = false;
  salvandoTipoDocumentoTraducao = false;
  tipoDocumentoTraducaoEditando: TipoDocumentoBuscaBrasilAdmin | null = null;
  tipoDocumentoTraducaoFormTitulo = '';
  tipoDocumentoTraducaoFormDescricao = '';
  traducaoItens: BuscaBrasilItemLinha[] = [];
  private readonly chaveTraducao = 'Traducao';

  /** TIPO_DOCUMENTO onde TIPO = buscaBrasil (aba Busca documentos → Brasil). */
  tiposDocumentoBuscaBrasilOpcoes: TipoDocumentoServicoOpcao[] = [];
  carregandoTiposDocumentoBuscaBrasil = false;
  modalTipoDocumentoBuscaBrasilAberto = false;
  tiposDocumentoBuscaBrasilModalLista: TipoDocumentoBuscaBrasilAdmin[] = [];
  carregandoTiposDocumentoBuscaBrasilModal = false;
  salvandoTipoDocumentoBuscaBrasil = false;
  tipoDocumentoBuscaBrasilEditando: TipoDocumentoBuscaBrasilAdmin | null = null;
  tipoDocumentoBuscaBrasilFormTitulo = '';
  tipoDocumentoBuscaBrasilFormDescricao = '';
  buscaBrasilItens: BuscaBrasilItemLinha[] = [];

  /** TIPO_DOCUMENTO onde TIPO = buscaItalia (aba Busca documentos → Itália). */
  tiposDocumentoBuscaItaliaOpcoes: TipoDocumentoServicoOpcao[] = [];
  carregandoTiposDocumentoBuscaItalia = false;
  modalTipoDocumentoBuscaItaliaAberto = false;
  tiposDocumentoBuscaItaliaModalLista: TipoDocumentoBuscaBrasilAdmin[] = [];
  carregandoTiposDocumentoBuscaItaliaModal = false;
  salvandoTipoDocumentoBuscaItalia = false;
  tipoDocumentoBuscaItaliaEditando: TipoDocumentoBuscaBrasilAdmin | null = null;
  tipoDocumentoBuscaItaliaFormTitulo = '';
  tipoDocumentoBuscaItaliaFormDescricao = '';
  buscaItaliaItens: BuscaBrasilItemLinha[] = [];

  responsavelClienteLinhas: ResponsavelClienteLinha[] = [];
  carregandoResponsavelCliente = false;
  salvandoResponsavelCliente = false;
  private responsavelClienteCarregadoParaPaciente = -1;

  /** USU_BUSCA_DOCUMENTOS_ITALIA já carregada para este idPaciente. */
  private buscaItaliaDadosPacienteCarregados: number = -1;

  /** USU_BUSCA_DOCUMENTOS_BRASIL já carregada para este idPaciente. */
  private buscaBrasilDadosPacienteCarregados: number = -1;

  // FormGroup para o formulário de cliente
  formCliente: FormGroup;
  /** Atualizado junto com o formulário (inclui resolução de cidade e senha opcional na edição). */
  formClientePodeSalvar = false;
  /** Campos que ainda impedem salvar (para feedback na tela). */
  camposPendentesSalvarCliente: string[] = [];
  
  // FormGroup para o formulário de naturalização
  formNaturalizacao: FormGroup;
  
  // FormGroup para o formulário de Jud Ita
  formJudIta: FormGroup;
  
  // FormGroup para o formulário de AIRE
  formAire: FormGroup;
  
  // FormGroup para o formulário de Fast-It
  formFastIt: FormGroup;
  
  // FormGroup para o formulário de Tradução
  formTraducao: FormGroup;

  // FormGroup para o formulário de Busca Itália
  formBuscaItalia: FormGroup;
  
  // FormGroup para o formulário de Busca Brasil
  formBuscaBrasil: FormGroup;

  // Propriedades do Chat
  clienteSelecionado: any = null;
  clienteOnline: boolean = false;
  novaMensagem: string = '';
  mensagens: any[] = [];

  // Propriedades do Editor Sharepoint
  fonteAtual: string = 'Arial';
  tamanhoFonteAtual: number = 12;
  corTextoAtual: string = '#000000';
  conteudoEditor: string = '';

  // Propriedades do Modal de Cadastro de Cliente
  modalCadastroClienteVisible: boolean = false;
  clienteParaEdicao: any = null;

  // Propriedades da aba de Orçamentos (layout legado CadastroOrcamentoGeral)
  consultasOrcamento: ConsultaOrcamentoLookupItem[] = [];
  microservicosLookup: MicroservicoLookupItem[] = [];
  orcamentosConsulta: OrcamentoConsultaItem[] = [];
  orcamentoItensGrid: OrcamentoItemGrid[] = [];
  idConsultaOrcamentoSelecionada: number = 0;
  idTabelaPrecoSelecionada: number = 0;
  idOrcamentoEdicao: number = 0;
  tituloOrcamento: string = '';
  descontoOrcamento: number = 0;
  acrescimoOrcamento: number = 0;
  observacaoGeralOrcamento: string = '';
  observacaoImpressaoOrcamento: string = '';
  exibirParaCliente: boolean = false;
  orcamentoAprovado: boolean = false;
  financeiroGeradoOrcamento: boolean = false;
  dataGeracaoFinanceiroOrcamento: string = '';
  totalOrcamentoGrid: number = 0;
  carregandoOrcamento: boolean = false;
  modalCadastroOrcamentoAberto: boolean = false;
  modoVisualizacaoOrcamento: boolean = false;
  filtroTituloOrcamentoExistente: string = '';
  carregandoDetalheOrcamento: boolean = false;
  modalObservacaoContextoGlobalAberto: boolean = false;
  salvandoObservacaoContextoGlobal = false;
  modalObservacaoAberto: boolean = false;
  observacaoModalTexto: string = '';
  indiceObservacaoAtual: number = -1;
  modalGerarFinanceiroAberto: boolean = false;
  carregandoTiposRecebimentoFinanceiro: boolean = false;
  tiposRecebimentoFinanceiro: TipoRecebimentoOpcao[] = [];
  dataVencimentoFinanceiro: string = '';
  idTipoRecebimentoFinanceiro: number = 0;
  /** Quantidade de títulos a gerar no financeiro (valor total dividido igualmente). */
  qtdParcelasFinanceiro: number = 1;
  observacaoContextoGlobalHtml: string = '';
  @ViewChild('observacaoImpressaoEditor') observacaoImpressaoEditor?: ElementRef<HTMLElement>;
  @ViewChild('observacaoContextoGlobalEditor') observacaoContextoGlobalEditor?: ElementRef<HTMLElement>;

  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    private ajaxService: AjaxService,
    private util: UtilService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute
  ) {

  }

  ngOnInit(): void {
    this.inicializarFormulario();
    this.inicializarFormularioNaturalizacao();
    this.inicializarFormularioJudIta();
    this.inicializarFormularioAire();
    this.inicializarFormularioFastIt();
    this.inicializarFormularioTraducao();
    this.inicializarFormularioBuscaItalia();
    this.inicializarFormularioBuscaBrasil();
    
    // Inicializar chat
    this.inicializarChat();
    
    // Verificar se há dados de cliente para edição via query parameters
    const modalComCliente = this.modoModal
      && (Number(this.clienteIdModal || 0) > 0 || (!!this.clienteDataModal && typeof this.clienteDataModal === 'object'));
    if (modalComCliente) {
      this.aplicarDadosEdicaoModal();
    } else if (!this.modoModal) {
      this.verificarDadosEdicao();
    }

    if (this.somenteAbaCliente) {
      this.selecionarAba('cliente');
    }

    const modoEdicaoRota = !this.modoModal && this.toText(this.route.snapshot.queryParams['modo']).toLowerCase() === 'edicao';
    const modoEdicao = modalComCliente || modoEdicaoRota;
    if (!modoEdicao) {
      this.onPaisChange();
    }

    this.atualizarEstadoEdicaoContextoGlobal();
  }

  /** Carrega edição a partir dos @Input do modal (sem depender da URL). */
  private aplicarDadosEdicaoModal(): void {
    this.atualizarValidacaoSenha(true);
    const dados = this.clienteDataModal;
    const idInput = Number(this.clienteIdModal || 0);

    if (dados && typeof dados === 'object') {
      try {
        this.idPacienteEdicao = Number(
          dados.id_paciente_clinica || dados.idpacienteclinica || dados.id || idInput || 0
        );
        this.idEmpresaEdicao = Number(dados.id_empresa || dados.idempresa || 1);
        this.idUsuarioEdicao = Number(dados.id_usuario || dados.idusuario || 0) || null;
        this.idCidadeEdicao = Number(dados.id_cidade || dados.idcidade || 0) || null;
        this.idEstadoEdicao = Number(dados.id_estado || dados.idestado || 0) || null;
        this.idPaisEdicao = Number(dados.id_pais || dados.idpais || 0) || null;
        this.estadoEdicaoNome = this.toText(dados.estado);
        this.preencherFormularioComDadosCliente(dados);
        this.carregarClienteEdicaoPorId();
        this.selecionarAba('cliente');
        return;
      } catch (error) {
        console.error('Erro ao processar dados do cliente no modal:', error);
      }
    }

    this.idPacienteEdicao = idInput;
    if (this.idPacienteEdicao > 0) {
      this.carregarClienteEdicaoPorId();
      this.selecionarAba('cliente');
    }
  }

  solicitarFecharModal(): void {
    this.fecharModalSolicitado.emit();
  }

  // Método para inicializar o formulário
  inicializarFormulario(): void {
    this.tipoPessoa = 'PF';
    this.formCliente = this.fb.group({
      dante_causa: [''],
      carteira: [''],
      sobrenome: [''],
      nome: ['', [Validators.required, Validators.minLength(3)]],
      cpf: ['', [Validators.required, Validators.pattern(CadastroClienteComponent.REGEX_CPF)]],
      senha: ['', [Validators.required, Validators.minLength(6)]],
      email: ['', [Validators.required, this.validadorEmail.bind(this)]],
      telefone_celular: ['', [Validators.required]],
      telefone_adicional: [''],
      rua: ['', [Validators.required]],
      numero: ['', [Validators.required]],
      complemento: [''],
      bairro: ['', [Validators.required]],
      cep: ['', [Validators.required, Validators.pattern(/^\d{5}-\d{3}$/)]],
      pais: ['Brasil', [Validators.required]],
      estado: [null as number | null, [Validators.required]],
      cidade: [null as number | null, [Validators.required]],
      link_pasta: [''],
      apelido_pasta_virtual: [''],
      pasta_fisica: [false],
      observacoes: ['']
    });

    this.formCliente.statusChanges.subscribe(() => this.atualizarEstadoSalvarCliente());
    this.formCliente.valueChanges.subscribe(() => this.atualizarEstadoSalvarCliente());
    this.atualizarEstadoSalvarCliente();
  }

  // Método para inicializar o formulário de naturalização
  inicializarFormularioNaturalizacao(): void {
    this.formNaturalizacao = this.fb.group({
      idUsuNaturalizacao: [0],
      comuneTranscricao: [''],
      dadosTranscricao: [''],
      nomeConjugeItaliana: [''],
      idStatusGeral: [null as number | null, [Validators.required]],
      usuario: [''],
      senha: [''],
      invioDigitale: [''],
      accettazione: [''],
      praticaK10: [''],
      consegnaOriginali: [''],
      notificaDecreto: [''],
      giuramento: ['']
    });
  }

  // Método para inicializar o formulário de Jud Ita
  inicializarFormularioJudIta(): void {
    this.formJudIta = this.fb.group({
      idUsuCidadania: [0],
      modalidade: ['MINISTERIAL'],
      danteCausa: [''],
      comune: [''],
      statusAdministrativo: [''],
      ag: [''],
      agVfs: [''],
      dataAg: [''],
      dataConvocacao: [''],
      dataEntregaConsulado: [''],
      viaPaterna: [false],
      viaMaterna: [false],
      remessaOnline: [''],
      remessaFisica: [''],
      ajuizamento: [''],
      tribunal: [''],
      nrg: [''],
      audiencia: [''],
      sentenca: [''],
      richiesto: [''],
      ritirato: [''],
      invioDocAdemp: [''],
      transcritasRecebidas: [''],
      apeloNotificado: [''],
      primeiraAudiencia: [''],
      apeloInscrito: [''],
      segundaAudiencia: [''],
      sentencaApelo: ['']
    });
  }

  // Método para inicializar o formulário de AIRE
  inicializarFormularioAire(): void {
    this.formAire = this.fb.group({
      idUsuAire: [0],
      servicoPago: [''],
      idStatusGeral: [null as number | null, [Validators.required]],
      consulado: [''],
      comune: [''],
      usuario: [''],
      senha: [''],
      inscricaoSolicitada: [''],
      inscricaoAprovada: [''],
    });
  }

  // Método para inicializar o formulário de Fast-It
  inicializarFormularioFastIt(): void {
    this.formFastIt = this.fb.group({
      idUsuFastIt: [0],
      servicoPago: [''],
      consulado: [''],
      idStatusGeral: [null as number | null, [Validators.required]],
      comune: [''],
      usuario: [''],
      senha: [''],
    });
  }

  // Método para inicializar o formulário de Tradução
  inicializarFormularioTraducao(): void {
    this.formTraducao = this.fb.group({
      idUsuTraducao: [0],
      dataDemanda: [''],
      prazoLimite: [''],
      idStatusGeral: [null as number | null, [Validators.required]],
      enviarPara: [''],
      codigoRastreio: [''],
      necessidadeDobradura: [false],
      sedex: [false],
    });
  }

  // Método para inicializar o formulário de Busca Itália
  inicializarFormularioBuscaItalia(): void {
    this.formBuscaItalia = this.fb.group({
      idBuscaDocumentosItalia: [0],
      dataDemanda: [''],
      idStatusGeral: [null as number | null],
    });
  }

  // Método para inicializar o formulário de Busca Brasil
  inicializarFormularioBuscaBrasil(): void {
    this.formBuscaBrasil = this.fb.group({
      idBuscaDocumentosBrasil: [0],
      dataDemanda: [''],
      // Sem Validators.required no select: em Angular 9, required + [ngValue]="null" costuma manter invalid após seleção.
      idStatusGeral: [null as number | null],
    });
  }

  /** Compara IDs do select de status (evita discrepância string/número com a API). */
  compareStatusGeralId(a: unknown, b: unknown): boolean {
    if (a == null && b == null) {
      return true;
    }
    if (a == null || b == null) {
      return false;
    }
    return Number(a) === Number(b);
  }

  // Método para selecionar aba
  selecionarAba(aba: string): void {
    console.log('Selecionando aba:', aba);
    this.abaAtiva = aba;
    if (aba === 'orcamentos') {
      this.carregarDadosIniciaisOrcamento();
    }
    if (aba === 'documento') {
      this.carregarTiposArquivoDocumentos();
    }
    if (aba === 'servicos') {
      if (
        this.subAbaAtiva === 'naturalizacao' ||
        this.subAbaAtiva === 'aire' ||
        this.subAbaAtiva === 'fast-it'
      ) {
        this.carregarOpcoesStatusNaturalizacaoSeNecessario();
      }
      if (this.subAbaAtiva === 'traducao') {
        this.carregarOpcoesStatusTraducaoSeNecessario();
        this.carregarOpcoesTipoDocumentoTraducaoSeNecessario();
      }
      if (this.subAbaAtiva === 'busca-documentos') {
        this.garantirOpcoesStatusBuscaDocumentos();
      }
      if (this.subAbaAtiva === 'naturalizacao') {
        this.garantirDadosNaturalizacaoCarregados();
      }
      if (this.subAbaAtiva === 'jud-ita') {
        this.garantirDadosCidadaniaCarregados();
      }
      if (this.subAbaAtiva === 'aire') {
        this.garantirDadosAireCarregados();
      }
      if (this.subAbaAtiva === 'fast-it') {
        this.garantirDadosFastItCarregados();
      }
      if (this.subAbaAtiva === 'traducao') {
        this.garantirDadosTraducaoCarregados();
      }
      if (this.subAbaAtiva === 'busca-documentos') {
        this.garantirOpcoesEBuscaDocumentos();
      }
    }
    if (aba === 'responsavel') {
      this.garantirDadosResponsavelClienteCarregados();
    }
    console.log('Aba ativa agora:', this.abaAtiva);
    this.atualizarEstadoEdicaoContextoGlobal();
    if (this.modalObservacaoContextoGlobalAberto) {
      setTimeout(() => this.sincronizarObservacaoContextoGlobalEditor(), 0);
    }
    this.cdr.detectChanges();
  }

  toggleContextoGlobalExpandido(): void {
    this.contextoGlobalExpandido = !this.contextoGlobalExpandido;
  }

  private atualizarEstadoEdicaoContextoGlobal(): void {
    const controlPastaFisica = this.formCliente?.get('pasta_fisica');
    if (!controlPastaFisica) return;

    if (this.abaAtiva === 'cliente') {
      if (controlPastaFisica.disabled) {
        controlPastaFisica.enable({ emitEvent: false });
      }
      return;
    }

    if (controlPastaFisica.enabled) {
      controlPastaFisica.disable({ emitEvent: false });
    }
  }

  // Método para selecionar sub-aba
  selecionarSubAba(subAba: string): void {
    if (!this.isSubAbaServicoSelecionada(subAba)) {
      return;
    }

    console.log('Selecionando sub-aba:', subAba);
    console.log('Sub-aba anterior:', this.subAbaAtiva);
    this.subAbaAtiva = subAba;
    console.log('Sub-aba ativa agora:', this.subAbaAtiva);
    if (subAba === 'naturalizacao') {
      this.carregarOpcoesStatusNaturalizacaoSeNecessario();
      this.garantirDadosNaturalizacaoCarregados();
    }
    if (subAba === 'jud-ita') {
      this.garantirDadosCidadaniaCarregados();
    }
    if (subAba === 'aire') {
      this.carregarOpcoesStatusNaturalizacaoSeNecessario();
      this.garantirDadosAireCarregados();
    }
    if (subAba === 'fast-it') {
      this.carregarOpcoesStatusNaturalizacaoSeNecessario();
      this.garantirDadosFastItCarregados();
    }
    if (subAba === 'traducao') {
      this.carregarOpcoesStatusTraducaoSeNecessario();
      this.carregarOpcoesTipoDocumentoTraducaoSeNecessario();
      this.garantirDadosTraducaoCarregados();
    }
    if (subAba === 'busca-documentos') {
      this.garantirOpcoesStatusBuscaDocumentos();
      this.garantirOpcoesEBuscaDocumentos();
    }
    this.cdr.detectChanges();
  }

  isSubAbaServicoSelecionada(subAba: string): boolean {
    return this.subAbasServicosSelecionadas.includes(subAba);
  }

  onToggleSubAbaServico(subAba: string, selecionada: boolean): void {
    if (selecionada) {
      if (!this.subAbasServicosSelecionadas.includes(subAba)) {
        this.subAbasServicosSelecionadas = [...this.subAbasServicosSelecionadas, subAba];
      }
      this.selecionarSubAba(subAba);
    } else {
      this.subAbasServicosSelecionadas = this.subAbasServicosSelecionadas.filter((id) => id !== subAba);
      this.garantirSubAbaServicoAtivaVisivel();
    }

    this.salvarFlagsHabilitarSubAbasServicos();
    this.cdr.detectChanges();
  }

  /** Persiste só as colunas HABILITAR_* ao alterar os checkboxes (cliente já cadastrado). */
  private salvarFlagsHabilitarSubAbasServicos(): void {
    if (!this.idPacienteEdicao || this.idPacienteEdicao <= 0) {
      return;
    }
    const payload = {
      ID_PACIENTE_CLINICA: this.idPacienteEdicao,
      ...this.buildHabilitarServicosFields(),
    };
    const url = API + 'empresa/Paciente/HabilitarSubAbasServicos';
    this.ajaxService.post(url, payload).subscribe({
      next: (response) => {
        if (response?.hasErrors) {
          this.util.toasterShowError(
            'Erro',
            response?.message || 'Não foi possível salvar a habilitação das abas.'
          );
        }
      },
      error: () => {
        this.util.toasterShowError('Erro', 'Não foi possível salvar a habilitação das abas.');
      },
    });
  }

  private buildHabilitarServicosFields(): {
    HABILITAR_NATURALIZACAO: number;
    HABILITAR_CIDADANIA: number;
    HABILITAR_AIRE: number;
    HABILITAR_FAST_IT: number;
    HABILITAR_TRADUCAO: number;
    HABILITAR_BUSCA_DOCUMENTOS: number;
  } {
    return {
      HABILITAR_NATURALIZACAO: this.subAbasServicosSelecionadas.includes('naturalizacao') ? 1 : 0,
      HABILITAR_CIDADANIA: this.subAbasServicosSelecionadas.includes('jud-ita') ? 1 : 0,
      HABILITAR_AIRE: this.subAbasServicosSelecionadas.includes('aire') ? 1 : 0,
      HABILITAR_FAST_IT: this.subAbasServicosSelecionadas.includes('fast-it') ? 1 : 0,
      HABILITAR_TRADUCAO: this.subAbasServicosSelecionadas.includes('traducao') ? 1 : 0,
      HABILITAR_BUSCA_DOCUMENTOS: this.subAbasServicosSelecionadas.includes('busca-documentos')
        ? 1
        : 0,
    };
  }

  private garantirSubAbaServicoAtivaVisivel(): void {
    if (this.isSubAbaServicoSelecionada(this.subAbaAtiva)) {
      return;
    }

    this.subAbaAtiva = this.subAbasServicosSelecionadas[0] || '';
  }

  // Método para selecionar sub-aba de busca
  selecionarSubAbaBusca(subAba: string, event: Event): void {
    event.preventDefault();
    console.log('Selecionando sub-aba de busca:', subAba);
    console.log('Sub-aba de busca anterior:', this.subAbaBuscaAtiva);
    this.subAbaBuscaAtiva = subAba;
    console.log('Sub-aba de busca ativa agora:', this.subAbaBuscaAtiva);
    if (
      subAba === 'italia' &&
      this.abaAtiva === 'servicos' &&
      this.subAbaAtiva === 'busca-documentos'
    ) {
      this.carregarOpcoesStatusBuscaItaliaSeNecessario();
      this.carregarOpcoesTipoDocumentoBuscaItaliaSeNecessario();
      this.garantirDadosBuscaItaliaCarregados();
    }
    if (
      subAba === 'brasil' &&
      this.abaAtiva === 'servicos' &&
      this.subAbaAtiva === 'busca-documentos'
    ) {
      this.carregarOpcoesStatusBuscaBrasilSeNecessario();
      this.carregarOpcoesTipoDocumentoBuscaBrasilSeNecessario();
      this.garantirDadosBuscaBrasilCarregados();
    }
    this.cdr.detectChanges();
  }

  selecionarAbaTipoArquivo(id: number | null): void {
    this.abaTipoArquivoAtivaId = id;
    this.cdr.detectChanges();
  }

  carregarTiposArquivoDocumentos(): void {
    if (this.carregandoTiposArquivoDocumentos || this.tiposArquivoDocumentos.length > 0) {
      return;
    }
    this.carregandoTiposArquivoDocumentos = true;
    const url = `${API}empresa/TipoArquivo/ListarLookup`;
    this.ajaxService.get(url).subscribe({
      next: (response) => {
        this.carregandoTiposArquivoDocumentos = false;
        const payload = this.desempacotarResponse(response);
        const bruto = this.extrairListaResponse(payload);
        this.tiposArquivoDocumentos = bruto
          .map((item) => this.mapearTipoArquivoDocumento(item))
          .filter((t) => t.idTipoArquivo > 0 && !!t.descricao);
        if (this.tiposArquivoDocumentos.length > 0) {
          this.abaTipoArquivoAtivaId = this.tiposArquivoDocumentos[0].idTipoArquivo;
        }
        this.cdr.detectChanges();
      },
      error: () => {
        this.carregandoTiposArquivoDocumentos = false;
        this.util.toasterShowError('Erro', 'Não foi possível carregar os tipos de documento.');
        this.cdr.detectChanges();
      }
    });
  }

  private mapearTipoArquivoDocumento(raw: any): TipoArquivoDocumentoItem {
    const id = Number(
      raw?.idTipoArquivo ?? raw?.ID_TIPO_ARQUIVO ?? raw?.id_tipo_arquivo ?? 0
    );
    const desc = String(raw?.descricao ?? raw?.DESCRICAO ?? raw?.Descricao ?? '').trim();
    return { idTipoArquivo: id, descricao: desc };
  }

  // Método para salvar cliente
  salvarCliente(): void {
    this.atualizarEstadoSalvarCliente();

    const formValue = this.formCliente?.getRawValue?.() ?? this.formCliente.value;
    const senhaInformada = this.toText(formValue?.senha);
    const isEdicao = this.idPacienteEdicao > 0;

    if (senhaInformada && senhaInformada.length < 6) {
      this.util.toasterShowWarning('Atenção', 'Se informar nova senha, use pelo menos 6 caracteres.');
      this.formCliente?.get('senha')?.markAsTouched();
      return;
    }

    const validacao = this.validarCamposClienteParaSalvar();
    if (validacao.ok) {
      const idCidadeSelecionada = Number(this.toText(formValue.cidade));
      const idCidadePayload = idCidadeSelecionada > 0
        ? idCidadeSelecionada
        : (this.idCidadeEdicao && this.idCidadeEdicao > 0 ? this.idCidadeEdicao : null);

      const payload: any = {
        ID_PACIENTE_CLINICA: this.idPacienteEdicao > 0 ? this.idPacienteEdicao : 0,
        ID_EMPRESA: this.idEmpresaEdicao > 0 ? this.idEmpresaEdicao : 1,
        ID_USUARIO: this.idUsuarioEdicao && this.idUsuarioEdicao > 0 ? this.idUsuarioEdicao : null,
        ID_CIDADE: idCidadePayload,
        EMAIL: this.toText(formValue.email),
        SOBRENOME: this.toText(formValue.sobrenome),
        NOME: this.toText(formValue.nome),
        CPF: this.toText(formValue.cpf),
        TELEFONE_CELULAR: this.toText(formValue.telefone_celular),
        TELEFONE_ADICIONAL: this.toText(formValue.telefone_adicional),
        RUA: this.toText(formValue.rua),
        BAIRRO: this.toText(formValue.bairro),
        COMPLEMENTO: this.toText(formValue.complemento),
        CEP: this.toText(formValue.cep),
        NUMERO: this.toText(formValue.numero),
        CARTEIRA: this.toText(formValue.carteira),
        DANTE_CAUSA: this.toText(formValue.dante_causa),
        OBSERVACOES: this.toText(formValue.observacoes),
        LINK_PASTA: this.toText(formValue.link_pasta),
        APELIDO_PASTA_VIRTUAL: this.toText(formValue.apelido_pasta_virtual),
        PASTA_FISICA: !!formValue.pasta_fisica,
        ...this.buildHabilitarServicosFields(),
      };

      if (!isEdicao || !!senhaInformada) {
        payload.Senha = senhaInformada;
        payload.SenhaConfirmacao = senhaInformada;
      }

      const url = API + 'empresa/Paciente/Save';
      this.util.showLoading();
      this.ajaxService.post(url, payload).subscribe({
        next: (response) => {
          this.util.closeLoading();
          if (response?.hasErrors) {
            this.util.toasterShowError('Erro', response?.message || 'Não foi possível salvar o cliente.');
            return;
          }

          const idRetorno = Number(response?.data?.idDecrypted || payload.ID_PACIENTE_CLINICA || 0);
          if (idRetorno > 0) this.idPacienteEdicao = idRetorno;

          const idUsuarioRetorno = Number(
            response?.data?.idUsuario ?? response?.data?.id_usuario ?? 0
          );
          if (idUsuarioRetorno > 0) {
            this.idUsuarioEdicao = idUsuarioRetorno;
          }

          this.invalidarCacheNaturalizacaoPaciente();
          this.invalidarCacheCidadaniaPaciente();
          this.invalidarCacheAirePaciente();
          this.invalidarCacheFastItPaciente();
          this.invalidarCacheTraducaoPaciente();
          this.invalidarCacheBuscaItaliaPaciente();
          this.invalidarCacheBuscaBrasilPaciente();
          if (this.abaAtiva === 'servicos' && this.subAbaAtiva === 'naturalizacao') {
            this.carregarOpcoesStatusNaturalizacaoSeNecessario();
            this.garantirDadosNaturalizacaoCarregados(true);
          }
          if (this.abaAtiva === 'servicos' && this.subAbaAtiva === 'jud-ita') {
            this.garantirDadosCidadaniaCarregados(true);
          }
          if (this.abaAtiva === 'servicos' && this.subAbaAtiva === 'aire') {
            this.carregarOpcoesStatusNaturalizacaoSeNecessario();
            this.garantirDadosAireCarregados(true);
          }
          if (this.abaAtiva === 'servicos' && this.subAbaAtiva === 'fast-it') {
            this.carregarOpcoesStatusNaturalizacaoSeNecessario();
            this.garantirDadosFastItCarregados(true);
          }
          if (this.abaAtiva === 'servicos' && this.subAbaAtiva === 'traducao') {
            this.carregarOpcoesStatusTraducaoSeNecessario();
            this.carregarOpcoesTipoDocumentoTraducaoSeNecessario();
            this.garantirDadosTraducaoCarregados(true);
          }
          if (this.abaAtiva === 'servicos' && this.subAbaAtiva === 'busca-documentos') {
            this.garantirOpcoesStatusBuscaDocumentos();
            if (this.subAbaBuscaAtiva === 'italia') {
              this.carregarOpcoesTipoDocumentoBuscaItaliaSeNecessario();
              this.garantirDadosBuscaItaliaCarregados(true);
            }
            if (this.subAbaBuscaAtiva === 'brasil') {
              this.carregarOpcoesTipoDocumentoBuscaBrasilSeNecessario();
              this.garantirDadosBuscaBrasilCarregados(true);
            }
          }

          if (this.abaAtiva === 'orcamentos') {
            this.carregarDadosIniciaisOrcamento();
          }

          this.util.toasterShowSuccess('Sucesso', 'Cliente salvo com sucesso!');
          this.clienteSalvo.emit({ idPaciente: this.idPacienteEdicao, idUsuario: this.idUsuarioEdicao || null });
        },
        error: () => {
          this.util.closeLoading();
          this.util.toasterShowError('Erro', 'Erro ao salvar cliente.');
        }
      });
    } else {
      const msg = validacao.pendentes.length
        ? `Preencha ou corrija: ${validacao.pendentes.join(', ')}.`
        : 'Por favor, preencha todos os campos obrigatórios.';
      this.util.toasterShowError('Atenção', msg);
      this.marcarCamposInvalidos();
      this.atualizarEstadoSalvarCliente();
    }
  }

  // Método para limpar formulário
  limparFormulario(): void {
    this.formCliente.reset();
    this.definirTipoPessoa('PF');
    this.formCliente.markAsUntouched();
    this.formCliente.markAsPristine();
  }

  get rotuloDocumento(): string {
    return this.tipoPessoa === 'PJ' ? 'CNPJ' : 'CPF';
  }

  get placeholderDocumento(): string {
    return this.tipoPessoa === 'PJ' ? '00.000.000/0000-00' : '000.000.000-00';
  }

  alterarTipoPessoa(tipo: 'PF' | 'PJ'): void {
    if (tipo === this.tipoPessoa) return;
    this.formCliente?.get('cpf')?.setValue('', { emitEvent: false });
    this.definirTipoPessoa(tipo);
  }

  private definirTipoPessoa(tipo: 'PF' | 'PJ'): void {
    this.tipoPessoa = tipo;
    const control = this.formCliente?.get('cpf');
    if (!control) return;
    control.setValidators([Validators.required, Validators.pattern(this.regexDocumento)]);
    control.updateValueAndValidity({ emitEvent: false });
  }

  private get regexDocumento(): RegExp {
    return this.tipoPessoa === 'PJ' ? CadastroClienteComponent.REGEX_CNPJ : CadastroClienteComponent.REGEX_CPF;
  }

  onCpfInput(): void {
    const control = this.formCliente?.get('cpf');
    if (!control) return;

    const valorComMascara = this.aplicarMascaraDocumento(control.value);
    if (valorComMascara !== control.value) {
      control.setValue(valorComMascara, { emitEvent: false });
    }
  }

  onTelefoneInput(campo: 'telefone_celular' | 'telefone_adicional'): void {
    const control = this.formCliente?.get(campo);
    if (!control) return;

    const valorComMascara = this.aplicarMascaraTelefone(control.value);
    if (valorComMascara !== control.value) {
      control.setValue(valorComMascara, { emitEvent: false });
    }
  }

  onCepInput(): void {
    const control = this.formCliente?.get('cep');
    if (!control) return;

    const valorComMascara = this.aplicarMascaraCep(control.value);
    if (valorComMascara !== control.value) {
      control.setValue(valorComMascara, { emitEvent: false });
    }
  }

  onPaisChange(idPaisForcado?: number): void {
    const paisSelecionado = this.toText(this.formCliente?.get('pais')?.value);
    const idPais = idPaisForcado && idPaisForcado > 0
      ? idPaisForcado
      : (paisSelecionado === 'Italia' ? 2 : 1);
    if (this.isCarregandoEstados) {
      this.idPaisPendente = idPais;
      return;
    }

    this.cidadeBuscaTexto = '';
    this.mostrarListaCidades = false;
    this.carregarEstadosPorPais(idPais);
  }

  onEstadoChange(): void {
    if (this.isCarregandoCidades) return;
    this.formCliente?.get('cidade')?.setValue(null, { emitEvent: true });
    this.cidadeBuscaTexto = '';
    const idEstado = Number(this.formCliente?.get('estado')?.value || 0);
    this.carregarCidadesPorEstado(idEstado);
    this.atualizarEstadoSalvarCliente();
  }

  onCidadeInputChange(): void {
    this.mostrarListaCidades = true;
    this.aplicarFiltroCidades();
    if (this.tentarResolverCidadePeloTexto(false)) {
      this.atualizarEstadoSalvarCliente();
      return;
    }
    const cidadeAtual = Number(this.formCliente?.get('cidade')?.value || 0);
    if (cidadeAtual > 0) {
      const atual = this.cidadesDisponiveis.find((c) => c.id === cidadeAtual);
      const termo = this.normalizarTextoComparacao(this.cidadeBuscaTexto);
      if (atual && this.normalizarTextoComparacao(atual.text) === termo) {
        this.atualizarEstadoSalvarCliente();
        return;
      }
    }
    this.formCliente?.get('cidade')?.setValue(null, { emitEvent: false });
    this.atualizarEstadoSalvarCliente();
  }

  onCidadeBlur(): void {
    this.fecharListaCidadesComDelay();
    this.tentarResolverCidadePeloTexto(true);
    this.formCliente?.get('cidade')?.updateValueAndValidity({ emitEvent: false });
    this.atualizarEstadoSalvarCliente();
  }

  /** Associa o texto digitado ao ID da cidade quando houver correspondência na lista. */
  private tentarResolverCidadePeloTexto(forcarUnicaParcial: boolean): boolean {
    const termo = this.normalizarTextoComparacao(this.cidadeBuscaTexto);
    if (!termo) {
      return false;
    }

    const cidadeAtual = Number(this.formCliente?.get('cidade')?.value || 0);
    if (cidadeAtual > 0) {
      const atual = this.cidadesDisponiveis.find((c) => c.id === cidadeAtual);
      if (atual && this.normalizarTextoComparacao(atual.text) === termo) {
        return true;
      }
    }

    const exata = this.cidadesDisponiveis.find(
      (c) => this.normalizarTextoComparacao(c.text) === termo
    );
    if (exata) {
      this.definirCidadeSelecionada(exata.id, exata.text);
      return true;
    }

    if (!forcarUnicaParcial) {
      return false;
    }

    const parciais = this.cidadesDisponiveis.filter((c) => {
      const nome = this.normalizarTextoComparacao(c.text);
      return nome.includes(termo) || termo.includes(nome);
    });
    if (parciais.length === 1) {
      this.definirCidadeSelecionada(parciais[0].id, parciais[0].text);
      return true;
    }

    const comecaCom = parciais.filter((c) =>
      this.normalizarTextoComparacao(c.text).startsWith(termo)
    );
    if (comecaCom.length === 1) {
      this.definirCidadeSelecionada(comecaCom[0].id, comecaCom[0].text);
      return true;
    }

    return false;
  }

  private definirCidadeSelecionada(id: number, texto: string): void {
    const ctrl = this.formCliente?.get('cidade');
    if (!ctrl) return;
    ctrl.setValue(id, { emitEvent: true });
    ctrl.setErrors(null);
    ctrl.markAsDirty();
    this.cidadeBuscaTexto = texto;
  }

  private validarCamposClienteParaSalvar(): { ok: boolean; pendentes: string[] } {
    const pendentes: string[] = [];
    if (!this.formCliente) {
      return { ok: false, pendentes: ['Formulário'] };
    }

    if (this.idPacienteEdicao > 0) {
      this.atualizarValidacaoSenha(true);
    }

    const v = this.formCliente.getRawValue();
    const nome = this.toText(v.nome);
    const cpf = this.toText(v.cpf);
    const email = this.toText(v.email);
    const senha = this.toText(v.senha);
    const isEdicao = this.idPacienteEdicao > 0;

    if (nome.length < 3) pendentes.push('Nome');
    if (!this.regexDocumento.test(cpf)) pendentes.push(this.rotuloDocumento);
    if (!this.emailValido(email)) pendentes.push('Email');
    if (!isEdicao && senha.length < 6) pendentes.push('Senha');
    if (isEdicao && senha && senha.length < 6) pendentes.push('Senha (mín. 6 caracteres)');
    if (!this.toText(v.telefone_celular)) pendentes.push('Telefone celular');
    if (!this.toText(v.rua)) pendentes.push('Logradouro');
    if (!this.toText(v.numero)) pendentes.push('Número');
    if (!this.toText(v.bairro)) pendentes.push('Bairro');
    if (!/^\d{5}-\d{3}$/.test(this.toText(v.cep))) pendentes.push('CEP');
    if (!this.toText(v.pais)) pendentes.push('País');

    const idEstado = Number(v.estado);
    if (!idEstado || idEstado <= 0) {
      pendentes.push('Estado');
    } else if (!this.cidadesDisponiveis.length && !this.isCarregandoCidades) {
      this.carregarCidadesPorEstado(idEstado);
    }

    if (this.toText(this.cidadeBuscaTexto)) {
      this.tentarResolverCidadePeloTexto(true);
    }
    const idCidade = Number(this.formCliente.get('cidade')?.value || 0);
    if (!idCidade || idCidade <= 0) {
      pendentes.push(this.toText(this.cidadeBuscaTexto)
        ? 'Cidade (clique na lista ao digitar)'
        : 'Cidade');
    }

    return { ok: pendentes.length === 0, pendentes };
  }

  atualizarEstadoSalvarCliente(): void {
    const emailCtrl = this.formCliente.get('email');
    if (emailCtrl) {
      emailCtrl.updateValueAndValidity({ emitEvent: false });
    }

    const { ok, pendentes } = this.validarCamposClienteParaSalvar();
    this.formClientePodeSalvar = ok;
    this.camposPendentesSalvarCliente = pendentes;
    this.cdr.detectChanges();
  }

  abrirListaCidades(): void {
    this.mostrarListaCidades = true;
    this.aplicarFiltroCidades();
  }

  fecharListaCidadesComDelay(): void {
    setTimeout(() => {
      this.mostrarListaCidades = false;
    }, 150);
  }

  selecionarCidade(cidade: IdValueItem): void {
    this.definirCidadeSelecionada(cidade.id, cidade.text);
    this.mostrarListaCidades = false;
    this.atualizarEstadoSalvarCliente();
  }

  // Método para salvar naturalização (USU_NATURALIZACAO)
  salvarNaturalizacao(event?: Event): void {
    event?.preventDefault();
    event?.stopPropagation();

    const idPac = Number(this.idPacienteEdicao || 0);
    if (idPac <= 0) {
      this.util.toasterShowWarning('Atenção', 'Salve o cliente antes de gravar a naturalização.');
      return;
    }

    const v = this.formNaturalizacao.getRawValue();
    const idStatus = Number(v.idStatusGeral ?? 0);
    if (idStatus <= 0) {
      this.util.toasterShowWarning('Atenção', 'Selecione o status do serviço.');
      this.marcarCamposInvalidosNaturalizacao();
      return;
    }

    if (!this.formNaturalizacao.valid) {
      this.util.toasterShowWarning('Atenção', 'Preencha os campos obrigatórios da naturalização.');
      this.marcarCamposInvalidosNaturalizacao();
      return;
    }

    const payload: Record<string, unknown> = {
      ID_USU_NATURALIZACAO: Number(v.idUsuNaturalizacao || 0),
      COMUNE_TRANSCRICAO: this.toText(v.comuneTranscricao),
      DADOS_TRANSCRICAO: this.toText(v.dadosTranscricao),
      NOME_CONJUGE_ITALIANA: this.toText(v.nomeConjugeItaliana) || null,
      USUARIO: this.toText(v.usuario),
      SENHA: this.toText(v.senha),
      INVIO_DIGITALE: this.dataLocalParaPayloadApi(v.invioDigitale),
      ACCETTAZIONE: this.dataLocalParaPayloadApi(v.accettazione),
      PRATICA_K10: this.toText(v.praticaK10) || null,
      CONSEGNA_ORIGINALI: this.dataLocalParaPayloadApi(v.consegnaOriginali),
      NOTIFICA_DECRETO: this.dataLocalParaPayloadApi(v.notificaDecreto),
      GUIRAMENTO: this.dataLocalParaPayloadApi(v.giuramento),
      ID_PACIENTE_CLINICA: idPac,
      ID_STATUS_GERAL: idStatus
    };

    const url = `${API}empresa/UsuNaturalizacao/SaveAsync`;
    this.util.showLoading();
    this.ajaxService.post(url, payload).subscribe({
      next: (response) => {
        this.util.closeLoading();
        if (response?.hasErrors || response?.HasErrors) {
          this.util.toasterShowError(
            'Erro',
            response?.message || response?.Message || 'Não foi possível salvar a naturalização.',
          );
          return;
        }
        const dados = this.desempacotarResponse(response);
        this.aplicarNaturalizacaoDoBackend(dados);

        const idPacAtual = Number(this.idPacienteEdicao || 0);
        const idNl = Number(this.formNaturalizacao.getRawValue()?.idUsuNaturalizacao || 0);

        /**
         * Resposta SaveAsync às vezes vem só no envelope PascalCase/Data ou camelCase incomum nos campos;
         * não marcar cache se o PATCH não conseguiu o ID do registro gravado — força novo GET pela API.
         */
        if (!(idNl > 0)) {
          if (idPacAtual > 0) {
            this.invalidarCacheNaturalizacaoPaciente();
            this.carregarDadosNaturalizacaoDoPaciente(idPacAtual);
          }
        } else if (idPacAtual === idPac) {
          this.naturalizacaoDadosPacienteCarregados = idPac;
        }

        this.cdr.detectChanges();
        this.util.toasterShowSuccess('Sucesso', 'Naturalização salva.');
        this.formNaturalizacao.markAsPristine();
      },
      error: () => {
        this.util.closeLoading();
        this.util.toasterShowError('Erro', 'Falha ao salvar naturalização.');
      }
    });
  }

  // Método para limpar formulário de naturalização
  limparFormularioNaturalizacao(): void {
    this.naturalizacaoSenhaVisivel = false;
    this.invalidarCacheNaturalizacaoPaciente();
    this.inicializarFormularioNaturalizacao();
    this.formNaturalizacao.markAsUntouched();
    this.formNaturalizacao.markAsPristine();
    this.cdr.detectChanges();
  }

  /** Corpo USU_CIDADANIA alinhado ao backend (inclui HABILITAR_APELO). */
  private buildPayloadUsuCidadaniaJudIta(): Record<string, unknown> {
    const idPac = Number(this.idPacienteEdicao || 0);
    const v = this.formJudIta.getRawValue();
    return {
      ID_USU_CIDADANIA: Number(v.idUsuCidadania || 0),
      MODALIDADE: this.normalizarModalidadeCidadania(v.modalidade),
      DANTE_CAUSA: this.toText(v.danteCausa) || null,
      COMUNE: this.toText(v.comune) || null,
      STATUS_ADMINISTRATIVO: this.toText(v.statusAdministrativo) || null,
      AG: this.toText(v.ag) || null,
      AG_VFS: this.toText(v.agVfs) || null,
      DATA_AG: this.dataLocalParaPayloadApi(v.dataAg),
      DATA_CONVOCACAO: this.dataLocalParaPayloadApi(v.dataConvocacao),
      DATA_ENTREGA_CONSULADO: this.dataLocalParaPayloadApi(v.dataEntregaConsulado),
      PATERNA_MATERNA: this.montarPaternaMaternaPayloadJudIta(v),
      REMESSA_ONLINE: this.dataLocalParaPayloadApi(v.remessaOnline),
      REMESSA_FISICA: this.dataLocalParaPayloadApi(v.remessaFisica),
      AJUIZAMENTO: this.dataLocalParaPayloadApi(v.ajuizamento),
      NRG: this.toText(v.nrg) || null,
      AUDIENCIA: this.dataLocalParaPayloadApi(v.audiencia),
      SENTENCA: this.dataLocalParaPayloadApi(v.sentenca),
      PIG_RICHIESTO: this.dataLocalParaPayloadApi(v.richiesto),
      PIG_RITIRATO: this.dataLocalParaPayloadApi(v.ritirato),
      INVIO_DOC_ADEMP: this.dataLocalParaPayloadApi(v.invioDocAdemp),
      TRANSCRITAS_RECEBIDAS: this.dataLocalParaPayloadApi(v.transcritasRecebidas),
      APELO_NOTIFICADO: this.dataLocalParaPayloadApi(v.apeloNotificado),
      APELO_INSCRITO: this.dataLocalParaPayloadApi(v.apeloInscrito),
      APELO_1_AUDIENCIA: this.dataLocalParaPayloadApi(v.primeiraAudiencia),
      APELO_2_AUDIENCIA: this.dataLocalParaPayloadApi(v.segundaAudiencia),
      APELO_SENTENCA: this.dataLocalParaPayloadApi(v.sentencaApelo),
      TRIBUNAL: this.toText(v.tribunal) || null,
      HABILITAR_APELO: this.judItaSecaoApeloVisivel ? 1 : 0,
      ID_PACIENTE_CLINICA: idPac,
    };
  }

  /** MINISTERIAL (padrão) | ADMINISTRATIVO */
  normalizarModalidadeCidadania(valor: unknown): 'MINISTERIAL' | 'ADMINISTRATIVO' {
    const v = String(valor ?? '')
      .trim()
      .toUpperCase();
    return v === 'ADMINISTRATIVO' ? 'ADMINISTRATIVO' : 'MINISTERIAL';
  }

  isJudItaModalidadeMinisterial(): boolean {
    return this.normalizarModalidadeCidadania(this.formJudIta?.get('modalidade')?.value) === 'MINISTERIAL';
  }

  setJudItaModalidade(modalidade: 'MINISTERIAL' | 'ADMINISTRATIVO'): void {
    if (!this.formJudIta) {
      return;
    }
    this.formJudIta.patchValue({ modalidade: this.normalizarModalidadeCidadania(modalidade) }, { emitEvent: false });
    this.formJudIta.markAsDirty();
    this.cdr.detectChanges();
  }

  // USU_CIDADANIA (aba Cidadania / Jud Ita)
  salvarJudIta(event?: Event): void {
    event?.preventDefault();
    event?.stopPropagation();

    const idPac = Number(this.idPacienteEdicao || 0);
    if (idPac <= 0) {
      this.util.toasterShowWarning('Atenção', 'Salve o cliente antes de gravar a cidadania.');
      return;
    }

    const payload = this.buildPayloadUsuCidadaniaJudIta();
    const url = `${API}empresa/UsuCidadania/SaveAsync`;
    this.util.showLoading();
    this.ajaxService.post(url, payload).subscribe({
      next: (response) => {
        this.util.closeLoading();
        if (response?.hasErrors || response?.HasErrors) {
          this.util.toasterShowError(
            'Erro',
            response?.message || response?.Message || 'Não foi possível salvar a cidadania.',
          );
          return;
        }
        const dados = this.desempacotarResponse(response);
        this.aplicarCidadaniaDoBackend(dados);

        const idPacAtual = Number(this.idPacienteEdicao || 0);
        const idRow = Number(this.formJudIta.getRawValue()?.idUsuCidadania || 0);
        if (!(idRow > 0)) {
          if (idPacAtual > 0) {
            this.invalidarCacheCidadaniaPaciente();
            this.carregarDadosCidadaniaDoPaciente(idPacAtual);
          }
        } else if (idPacAtual === idPac) {
          this.cidadaniaDadosPacienteCarregados = idPac;
        }

        this.cdr.detectChanges();
        this.util.toasterShowSuccess('Sucesso', 'Cidadania salva.');
        this.formJudIta.markAsPristine();
      },
      error: () => {
        this.util.closeLoading();
        this.util.toasterShowError('Erro', 'Falha ao salvar cidadania.');
      },
    });
  }

  limparFormularioJudIta(): void {
    this.judItaSecaoApeloVisivel = false;
    this.invalidarCacheCidadaniaPaciente();
    this.inicializarFormularioJudIta();
    this.formJudIta.markAsUntouched();
    this.formJudIta.markAsPristine();
    this.cdr.detectChanges();
  }

  salvarAire(event?: Event): void {
    event?.preventDefault();
    event?.stopPropagation();

    const idPac = Number(this.idPacienteEdicao || 0);
    if (idPac <= 0) {
      this.util.toasterShowWarning('Atenção', 'Salve o cliente antes de gravar o AIRE.');
      return;
    }

    const v = this.formAire.getRawValue();
    const idStatus = Number(v.idStatusGeral ?? 0);
    if (idStatus <= 0) {
      this.util.toasterShowWarning('Atenção', 'Selecione o status do serviço.');
      this.marcarCamposInvalidosAire();
      return;
    }

    if (!this.formAire.valid) {
      this.util.toasterShowWarning('Atenção', 'Preencha os campos obrigatórios do AIRE.');
      this.marcarCamposInvalidosAire();
      return;
    }

    const payload: Record<string, unknown> = {
      ID_USU_AIRE: Number(v.idUsuAire || 0),
      SERVICO_PAGO: this.dataLocalParaPayloadApi(v.servicoPago),
      CONSULADO: this.toText(v.consulado) || null,
      COMUNE: this.toText(v.comune) || null,
      USUARIO: this.toText(v.usuario) || null,
      SENHA: this.toText(v.senha) || null,
      INSCRICAO_SOLICITADA: this.dataLocalParaPayloadApi(v.inscricaoSolicitada),
      INSCRICAO_APROVADA: this.dataLocalParaPayloadApi(v.inscricaoAprovada),
      ID_PACIENTE_CLINICA: idPac,
      ID_STATUS_GERAL: idStatus,
    };

    const url = `${API}empresa/UsuAire/SaveAsync`;
    this.util.showLoading();
    this.ajaxService.post(url, payload).subscribe({
      next: (response) => {
        this.util.closeLoading();
        if (response?.hasErrors || response?.HasErrors) {
          this.util.toasterShowError(
            'Erro',
            response?.message || response?.Message || 'Não foi possível salvar o AIRE.',
          );
          return;
        }
        const dados = this.desempacotarResponse(response);
        this.aplicarAireDoBackend(dados);

        const idPacAtual = Number(this.idPacienteEdicao || 0);
        const idRow = Number(this.formAire.getRawValue()?.idUsuAire || 0);
        if (!(idRow > 0)) {
          if (idPacAtual > 0) {
            this.invalidarCacheAirePaciente();
            this.carregarDadosAireDoPaciente(idPacAtual);
          }
        } else if (idPacAtual === idPac) {
          this.aireDadosPacienteCarregados = idPac;
        }

        this.cdr.detectChanges();
        this.util.toasterShowSuccess('Sucesso', 'AIRE salvo.');
        this.formAire.markAsPristine();
      },
      error: () => {
        this.util.closeLoading();
        this.util.toasterShowError('Erro', 'Falha ao salvar AIRE.');
      },
    });
  }

  limparFormularioAire(): void {
    this.aireSenhaVisivel = false;
    this.invalidarCacheAirePaciente();
    this.inicializarFormularioAire();
    this.formAire.markAsUntouched();
    this.formAire.markAsPristine();
    this.cdr.detectChanges();
  }

  salvarFastIt(event?: Event): void {
    event?.preventDefault();
    event?.stopPropagation();

    const idPac = Number(this.idPacienteEdicao || 0);
    if (idPac <= 0) {
      this.util.toasterShowWarning('Atenção', 'Salve o cliente antes de gravar o Fast-It.');
      return;
    }

    const v = this.formFastIt.getRawValue();
    const idStatus = Number(v.idStatusGeral ?? 0);
    if (idStatus <= 0) {
      this.util.toasterShowWarning('Atenção', 'Selecione o status do serviço.');
      this.marcarCamposInvalidosFastIt();
      return;
    }

    if (!this.formFastIt.valid) {
      this.util.toasterShowWarning('Atenção', 'Preencha os campos obrigatórios do Fast-It.');
      this.marcarCamposInvalidosFastIt();
      return;
    }

    const payload: Record<string, unknown> = {
      ID_USU_FAST_IT: Number(v.idUsuFastIt || 0),
      SERVICO_PAGO: this.dataLocalParaPayloadApi(v.servicoPago),
      CONSULADO: this.toText(v.consulado) || null,
      COMUNE: this.toText(v.comune) || null,
      USUARIO: this.toText(v.usuario) || null,
      SENHA: this.toText(v.senha) || null,
      ID_PACIENTE_CLINICA: idPac,
      ID_STATUS_GERAL: idStatus,
    };

    const url = `${API}empresa/UsuFastIt/SaveAsync`;
    this.util.showLoading();
    this.ajaxService.post(url, payload).subscribe({
      next: (response) => {
        this.util.closeLoading();
        if (response?.hasErrors || response?.HasErrors) {
          this.util.toasterShowError(
            'Erro',
            response?.message || response?.Message || 'Não foi possível salvar o Fast-It.',
          );
          return;
        }
        const dados = this.desempacotarResponse(response);
        this.aplicarFastItDoBackend(dados);

        const idPacAtual = Number(this.idPacienteEdicao || 0);
        const idRow = Number(this.formFastIt.getRawValue()?.idUsuFastIt || 0);
        if (!(idRow > 0)) {
          if (idPacAtual > 0) {
            this.invalidarCacheFastItPaciente();
            this.carregarDadosFastItDoPaciente(idPacAtual);
          }
        } else if (idPacAtual === idPac) {
          this.fastItDadosPacienteCarregados = idPac;
        }

        this.cdr.detectChanges();
        this.util.toasterShowSuccess('Sucesso', 'Fast-It salvo.');
        this.formFastIt.markAsPristine();
      },
      error: () => {
        this.util.closeLoading();
        this.util.toasterShowError('Erro', 'Falha ao salvar Fast-It.');
      },
    });
  }

  limparFormularioFastIt(): void {
    this.fastItSenhaVisivel = false;
    this.invalidarCacheFastItPaciente();
    this.inicializarFormularioFastIt();
    this.formFastIt.markAsUntouched();
    this.formFastIt.markAsPristine();
    this.cdr.detectChanges();
  }

  salvarTraducao(event?: Event): void {
    event?.preventDefault();
    event?.stopPropagation();

    const idPac = Number(this.idPacienteEdicao || 0);
    if (idPac <= 0) {
      this.util.toasterShowWarning('Atenção', 'Salve o cliente antes de gravar a tradução.');
      return;
    }

    const v = this.formTraducao.getRawValue();
    const idStatus = Number(v.idStatusGeral ?? 0);
    if (idStatus <= 0) {
      this.util.toasterShowWarning('Atenção', 'Selecione o status do serviço.');
      this.marcarCamposInvalidosTraducao();
      return;
    }

    if (!this.formTraducao.valid) {
      this.util.toasterShowWarning('Atenção', 'Preencha os campos obrigatórios da tradução.');
      this.marcarCamposInvalidosTraducao();
      return;
    }

    const itensPayload = (this.traducaoItens || [])
      .filter((linha) => Number(linha.idTipoDocumento || 0) > 0)
      .map((linha) => ({
        ID_DOCUMENTOS_PROVIDENCIADO: Number(linha.idDocumentosProvidenciado || 0),
        ID_TIPO_DOCUMENTO: Number(linha.idTipoDocumento),
        NOME_ABA: this.chaveTraducao,
        TITULAR: (linha.titular || '').trim(),
        ESTADO: (linha.estado || '').trim(),
        CIDADE: (linha.cidade || '').trim(),
        QUANTIDADE: Number(linha.quantidade || 0) > 0 ? Number(linha.quantidade) : 1,
        SOLICITADO: this.dataLocalParaPayloadApi(linha.solicitado),
        RECEBIDO: this.dataLocalParaPayloadApi(linha.recebido),
        TRADUTOR: this.toText(linha.tradutor) || null,
        REVISOR: this.toText(linha.revisor) || null,
        APOSTILAR_DOCUMENTO: this.simNaoToggleParaByte(!!linha.apostilarDocumento),
        APOSTILAR_TRADUCAO: this.simNaoToggleParaByte(!!linha.apostilarTraducao),
      }));

    const payload: Record<string, unknown> = {
      ID_USU_TRADUCAO: Number(v.idUsuTraducao || 0),
      DATA_DEMANDA: this.dataLocalParaPayloadApi(v.dataDemanda),
      PRAZO_LIMITE: this.dataLocalParaPayloadApi(v.prazoLimite),
      APOSTILAR_DOCUMENTO: null,
      QTD_DOCUMENTOS_APOSTILAR: null,
      APOSTILAR_TRADUCAO: null,
      NECESSIDADE_DOBRADURA: this.simNaoToggleParaByte(v.necessidadeDobradura),
      SEDEX: this.simNaoToggleParaByte(v.sedex),
      CODIGO_RASTREIO: this.toText(v.codigoRastreio) || null,
      ENVIAR_PARA: this.toText(v.enviarPara) || null,
      ID_PACIENTE_CLINICA: idPac,
      ID_STATUS_GERAL: idStatus,
      ITENS: itensPayload,
    };

    const url = `${API}empresa/UsuTraducao/SaveAsync`;
    this.util.showLoading();
    this.ajaxService.post(url, payload).subscribe({
      next: (response) => {
        this.util.closeLoading();
        if (response?.hasErrors || response?.HasErrors) {
          this.util.toasterShowError(
            'Erro',
            response?.message || response?.Message || 'Não foi possível salvar a tradução.',
          );
          return;
        }
        const dados = this.desempacotarResponse(response);
        this.aplicarTraducaoDoBackend(dados);

        const idPacAtual = Number(this.idPacienteEdicao || 0);
        if (idPacAtual > 0) {
          this.carregarItensTraducao(idPacAtual);
          this.traducaoDadosPacienteCarregados = idPac;
        }

        this.cdr.detectChanges();
        this.util.toasterShowSuccess('Sucesso', 'Tradução salva.');
        this.formTraducao.markAsPristine();
      },
      error: () => {
        this.util.closeLoading();
        this.util.toasterShowError('Erro', 'Falha ao salvar tradução.');
      },
    });
  }

  limparFormularioTraducao(): void {
    this.invalidarCacheTraducaoPaciente();
    this.inicializarFormularioTraducao();
    this.traducaoItens = [];
    this.formTraducao.markAsUntouched();
    this.formTraducao.markAsPristine();
    this.cdr.detectChanges();
  }

  adicionarLinhaTraducao(): void {
    this.traducaoItens = [...(this.traducaoItens || []), this.criarLinhaBuscaBrasilVazia()];
    this.cdr.detectChanges();
  }

  removerLinhaTraducao(indice: number): void {
    if (indice < 0 || indice >= this.traducaoItens.length) {
      return;
    }
    this.traducaoItens = this.traducaoItens.filter((_, i) => i !== indice);
    this.cdr.detectChanges();
  }

  abrirModalTipoDocumentoTraducao(): void {
    this.modalTipoDocumentoTraducaoAberto = true;
    this.resetarFormTipoDocumentoTraducao();
    this.carregarTiposDocumentoTraducaoModal();
    this.cdr.detectChanges();
  }

  fecharModalTipoDocumentoTraducao(): void {
    this.modalTipoDocumentoTraducaoAberto = false;
    this.resetarFormTipoDocumentoTraducao();
    this.cdr.detectChanges();
  }

  novoTipoDocumentoTraducao(): void {
    this.resetarFormTipoDocumentoTraducao();
    this.cdr.detectChanges();
  }

  editarTipoDocumentoTraducao(item: TipoDocumentoBuscaBrasilAdmin): void {
    if (!item?.idTipoDocumento) {
      return;
    }
    this.tipoDocumentoTraducaoEditando = { ...item };
    this.tipoDocumentoTraducaoFormTitulo = item.titulo;
    this.tipoDocumentoTraducaoFormDescricao = item.descricao;
    this.cdr.detectChanges();
  }

  salvarTipoDocumentoTraducao(): void {
    const titulo = (this.tipoDocumentoTraducaoFormTitulo || '').trim();
    if (!titulo) {
      this.util.toasterShowWarning('Atenção', 'Informe o título do tipo de documento.');
      return;
    }

    const idTipo = Number(this.tipoDocumentoTraducaoEditando?.idTipoDocumento || 0);
    const payload: Record<string, unknown> = {
      ID_TIPO_DOCUMENTO: idTipo,
      TITULO: titulo,
      DESCRICAO: (this.tipoDocumentoTraducaoFormDescricao || '').trim(),
      TIPO: this.chaveTraducao,
    };

    this.salvandoTipoDocumentoTraducao = true;
    this.ajaxService.post(`${API}empresa/ServicoTipoDocumento/SaveAsync`, payload).subscribe({
      next: (response) => {
        this.salvandoTipoDocumentoTraducao = false;
        if (response?.hasErrors || response?.HasErrors) {
          this.util.toasterShowError(
            'Erro',
            response?.message || response?.Message || 'Não foi possível salvar o tipo de documento.',
          );
          this.cdr.detectChanges();
          return;
        }
        this.util.toasterShowSuccess(
          'Sucesso',
          idTipo > 0 ? 'Tipo de documento atualizado.' : 'Tipo de documento cadastrado.',
        );
        this.resetarFormTipoDocumentoTraducao();
        this.recarregarOpcoesTipoDocumentoTraducao();
        this.carregarTiposDocumentoTraducaoModal();
      },
      error: () => {
        this.salvandoTipoDocumentoTraducao = false;
        this.util.toasterShowError('Erro', 'Falha ao salvar o tipo de documento.');
        this.cdr.detectChanges();
      },
    });
  }

  excluirTipoDocumentoTraducao(item: TipoDocumentoBuscaBrasilAdmin): void {
    const idTipo = Number(item?.idTipoDocumento || 0);
    if (idTipo <= 0) {
      return;
    }
    const rotulo = (item.titulo || '').trim() || `#${idTipo}`;
    if (!confirm(`Excluir o tipo de documento "${rotulo}"?`)) {
      return;
    }

    this.util.showLoading();
    this.ajaxService.delete(`${API}empresa/ServicoTipoDocumento/DeleteAsync?id=${idTipo}`).subscribe({
      next: (response) => {
        this.util.closeLoading();
        if (response?.hasErrors || response?.HasErrors) {
          this.util.toasterShowError(
            'Erro',
            response?.message || response?.Message || 'Não foi possível excluir o tipo de documento.',
          );
          return;
        }
        if (this.tipoDocumentoTraducaoEditando?.idTipoDocumento === idTipo) {
          this.resetarFormTipoDocumentoTraducao();
        }
        this.traducaoItens = (this.traducaoItens || []).map((linha) =>
          Number(linha.idTipoDocumento || 0) === idTipo ? { ...linha, idTipoDocumento: null } : linha,
        );
        this.util.toasterShowSuccess('Sucesso', 'Tipo de documento excluído.');
        this.recarregarOpcoesTipoDocumentoTraducao();
        this.carregarTiposDocumentoTraducaoModal();
      },
      error: () => {
        this.util.closeLoading();
        this.util.toasterShowError('Erro', 'Falha ao excluir o tipo de documento.');
      },
    });
  }

  private resetarFormTipoDocumentoTraducao(): void {
    this.tipoDocumentoTraducaoEditando = null;
    this.tipoDocumentoTraducaoFormTitulo = '';
    this.tipoDocumentoTraducaoFormDescricao = '';
  }

  private carregarTiposDocumentoTraducaoModal(): void {
    this.carregandoTiposDocumentoTraducaoModal = true;
    const url = `${API}empresa/ServicoTipoDocumento/Consultar?tipo=${encodeURIComponent(this.chaveTraducao)}`;
    this.ajaxService.get(url).subscribe({
      next: (response) => {
        this.carregandoTiposDocumentoTraducaoModal = false;
        if (response?.hasErrors || response?.HasErrors) {
          this.tiposDocumentoTraducaoModalLista = [];
          this.cdr.detectChanges();
          return;
        }
        const raw = this.desempacotarResponse(response);
        const lista = Array.isArray(raw) ? raw : this.extrairListaResponse(raw);
        this.tiposDocumentoTraducaoModalLista = lista
          .map((item: Record<string, unknown>) => this.mapearTipoDocumentoBuscaBrasilAdmin(item))
          .filter((x: TipoDocumentoBuscaBrasilAdmin) => x.idTipoDocumento > 0);
        this.cdr.detectChanges();
      },
      error: () => {
        this.carregandoTiposDocumentoTraducaoModal = false;
        this.tiposDocumentoTraducaoModalLista = [];
        this.util.toasterShowError('Erro', 'Não foi possível carregar os tipos de documento.');
        this.cdr.detectChanges();
      },
    });
  }

  private recarregarOpcoesTipoDocumentoTraducao(): void {
    this.tiposDocumentoTraducaoOpcoes = [];
    this.carregarOpcoesTipoDocumentoTraducao();
  }

  salvarBuscaItalia(event?: Event): void {
    event?.preventDefault();
    event?.stopPropagation();

    const idPac = Number(this.idPacienteEdicao || 0);
    if (idPac <= 0) {
      this.util.toasterShowWarning('Atenção', 'Salve o cliente antes de gravar a busca de documentos Itália.');
      return;
    }

    const v = this.formBuscaItalia.getRawValue();
    const idStatus = Number(v.idStatusGeral);
    if (!Number.isFinite(idStatus) || idStatus <= 0) {
      this.util.toasterShowWarning('Atenção', 'Selecione o status geral do pedido.');
      this.formBuscaItalia.get('idStatusGeral')?.markAsTouched();
      return;
    }

    const nomeAbaSalvar = this.resolverNomeAbaBuscaDocumentosAtiva();

    const itensPayload = (this.buscaItaliaItens || [])
      .filter((linha) => Number(linha.idTipoDocumento || 0) > 0)
      .map((linha) => ({
        ID_DOCUMENTOS_PROVIDENCIADO: Number(linha.idDocumentosProvidenciado || 0),
        ID_TIPO_DOCUMENTO: Number(linha.idTipoDocumento),
        NOME_ABA: nomeAbaSalvar,
        TITULAR: (linha.titular || '').trim(),
        ESTADO: (linha.estado || '').trim(),
        CIDADE: (linha.cidade || '').trim(),
        QUANTIDADE: Number(linha.quantidade || 0) > 0 ? Number(linha.quantidade) : 1,
        SOLICITADO: this.dataLocalParaPayloadApi(linha.solicitado),
        RECEBIDO: this.dataLocalParaPayloadApi(linha.recebido),
      }));

    const payload: Record<string, unknown> = {
      ID_BUSCA_DOCUMENTOS_ITALIA: Number(v.idBuscaDocumentosItalia || 0),
      DATA_DEMANDA: this.dataLocalParaPayloadApi(v.dataDemanda),
      ID_PACIENTE_CLINICA: idPac,
      ID_STATUS_GERAL: idStatus,
      ITENS: itensPayload,
    };

    const url = `${API}empresa/UsuBuscaDocumentosItalia/SaveAsync`;
    this.util.showLoading();
    this.ajaxService.post(url, payload).subscribe({
      next: (response) => {
        this.util.closeLoading();
        if (response?.hasErrors || response?.HasErrors) {
          this.util.toasterShowError(
            'Erro',
            response?.message || response?.Message || 'Não foi possível salvar busca Itália.',
          );
          return;
        }
        const dados = this.desempacotarResponse(response);
        this.aplicarBuscaItaliaDoBackend(dados);

        const idPacAtual = Number(this.idPacienteEdicao || 0);
        if (idPacAtual > 0) {
          this.carregarItensBuscaItalia(idPacAtual);
          this.buscaItaliaDadosPacienteCarregados = idPac;
        }

        this.cdr.detectChanges();
        this.util.toasterShowSuccess('Sucesso', 'Busca documentos Itália salva.');
        this.formBuscaItalia.markAsPristine();
      },
      error: () => {
        this.util.closeLoading();
        this.util.toasterShowError('Erro', 'Falha ao salvar busca documentos Itália.');
      },
    });
  }

  limparFormularioBuscaItalia(): void {
    this.invalidarCacheBuscaItaliaPaciente();
    this.inicializarFormularioBuscaItalia();
    this.buscaItaliaItens = [];
    this.formBuscaItalia.markAsUntouched();
    this.formBuscaItalia.markAsPristine();
    this.cdr.detectChanges();
  }

  adicionarLinhaBuscaItalia(): void {
    this.buscaItaliaItens = [...(this.buscaItaliaItens || []), this.criarLinhaBuscaBrasilVazia()];
    this.cdr.detectChanges();
  }

  removerLinhaBuscaItalia(indice: number): void {
    if (indice < 0 || indice >= this.buscaItaliaItens.length) {
      return;
    }
    this.buscaItaliaItens = this.buscaItaliaItens.filter((_, i) => i !== indice);
    this.cdr.detectChanges();
  }

  abrirModalTipoDocumentoBuscaItalia(): void {
    this.modalTipoDocumentoBuscaItaliaAberto = true;
    this.resetarFormTipoDocumentoBuscaItalia();
    this.carregarTiposDocumentoBuscaItaliaModal();
    this.cdr.detectChanges();
  }

  fecharModalTipoDocumentoBuscaItalia(): void {
    this.modalTipoDocumentoBuscaItaliaAberto = false;
    this.resetarFormTipoDocumentoBuscaItalia();
    this.cdr.detectChanges();
  }

  novoTipoDocumentoBuscaItalia(): void {
    this.resetarFormTipoDocumentoBuscaItalia();
    this.cdr.detectChanges();
  }

  editarTipoDocumentoBuscaItalia(item: TipoDocumentoBuscaBrasilAdmin): void {
    if (!item?.idTipoDocumento) {
      return;
    }
    this.tipoDocumentoBuscaItaliaEditando = { ...item };
    this.tipoDocumentoBuscaItaliaFormTitulo = item.titulo;
    this.tipoDocumentoBuscaItaliaFormDescricao = item.descricao;
    this.cdr.detectChanges();
  }

  salvarTipoDocumentoBuscaItalia(): void {
    const titulo = (this.tipoDocumentoBuscaItaliaFormTitulo || '').trim();
    if (!titulo) {
      this.util.toasterShowWarning('Atenção', 'Informe o título do tipo de documento.');
      return;
    }

    const idTipo = Number(this.tipoDocumentoBuscaItaliaEditando?.idTipoDocumento || 0);
    const payload: Record<string, unknown> = {
      ID_TIPO_DOCUMENTO: idTipo,
      TITULO: titulo,
      DESCRICAO: (this.tipoDocumentoBuscaItaliaFormDescricao || '').trim(),
      TIPO: 'buscaItalia',
    };

    this.salvandoTipoDocumentoBuscaItalia = true;
    this.ajaxService.post(`${API}empresa/ServicoTipoDocumento/SaveAsync`, payload).subscribe({
      next: (response) => {
        this.salvandoTipoDocumentoBuscaItalia = false;
        if (response?.hasErrors || response?.HasErrors) {
          this.util.toasterShowError(
            'Erro',
            response?.message || response?.Message || 'Não foi possível salvar o tipo de documento.',
          );
          this.cdr.detectChanges();
          return;
        }
        this.util.toasterShowSuccess(
          'Sucesso',
          idTipo > 0 ? 'Tipo de documento atualizado.' : 'Tipo de documento cadastrado.',
        );
        this.resetarFormTipoDocumentoBuscaItalia();
        this.recarregarOpcoesTipoDocumentoBuscaItalia();
        this.carregarTiposDocumentoBuscaItaliaModal();
      },
      error: () => {
        this.salvandoTipoDocumentoBuscaItalia = false;
        this.util.toasterShowError('Erro', 'Falha ao salvar o tipo de documento.');
        this.cdr.detectChanges();
      },
    });
  }

  excluirTipoDocumentoBuscaItalia(item: TipoDocumentoBuscaBrasilAdmin): void {
    const idTipo = Number(item?.idTipoDocumento || 0);
    if (idTipo <= 0) {
      return;
    }
    const rotulo = (item.titulo || '').trim() || `#${idTipo}`;
    if (!confirm(`Excluir o tipo de documento "${rotulo}"?`)) {
      return;
    }

    this.util.showLoading();
    this.ajaxService.delete(`${API}empresa/ServicoTipoDocumento/DeleteAsync?id=${idTipo}`).subscribe({
      next: (response) => {
        this.util.closeLoading();
        if (response?.hasErrors || response?.HasErrors) {
          this.util.toasterShowError(
            'Erro',
            response?.message || response?.Message || 'Não foi possível excluir o tipo de documento.',
          );
          return;
        }
        if (this.tipoDocumentoBuscaItaliaEditando?.idTipoDocumento === idTipo) {
          this.resetarFormTipoDocumentoBuscaItalia();
        }
        this.buscaItaliaItens = (this.buscaItaliaItens || []).map((linha) =>
          Number(linha.idTipoDocumento || 0) === idTipo ? { ...linha, idTipoDocumento: null } : linha,
        );
        this.util.toasterShowSuccess('Sucesso', 'Tipo de documento excluído.');
        this.recarregarOpcoesTipoDocumentoBuscaItalia();
        this.carregarTiposDocumentoBuscaItaliaModal();
      },
      error: () => {
        this.util.closeLoading();
        this.util.toasterShowError('Erro', 'Falha ao excluir o tipo de documento.');
      },
    });
  }

  private resetarFormTipoDocumentoBuscaItalia(): void {
    this.tipoDocumentoBuscaItaliaEditando = null;
    this.tipoDocumentoBuscaItaliaFormTitulo = '';
    this.tipoDocumentoBuscaItaliaFormDescricao = '';
  }

  private carregarTiposDocumentoBuscaItaliaModal(): void {
    this.carregandoTiposDocumentoBuscaItaliaModal = true;
    const url = `${API}empresa/ServicoTipoDocumento/Consultar?tipo=buscaItalia`;
    this.ajaxService.get(url).subscribe({
      next: (response) => {
        this.carregandoTiposDocumentoBuscaItaliaModal = false;
        if (response?.hasErrors || response?.HasErrors) {
          this.tiposDocumentoBuscaItaliaModalLista = [];
          this.cdr.detectChanges();
          return;
        }
        const raw = this.desempacotarResponse(response);
        const lista = Array.isArray(raw) ? raw : this.extrairListaResponse(raw);
        this.tiposDocumentoBuscaItaliaModalLista = lista
          .map((item: Record<string, unknown>) => this.mapearTipoDocumentoBuscaBrasilAdmin(item))
          .filter((x: TipoDocumentoBuscaBrasilAdmin) => x.idTipoDocumento > 0);
        this.cdr.detectChanges();
      },
      error: () => {
        this.carregandoTiposDocumentoBuscaItaliaModal = false;
        this.tiposDocumentoBuscaItaliaModalLista = [];
        this.util.toasterShowError('Erro', 'Não foi possível carregar os tipos de documento.');
        this.cdr.detectChanges();
      },
    });
  }

  private recarregarOpcoesTipoDocumentoBuscaItalia(): void {
    this.tiposDocumentoBuscaItaliaOpcoes = [];
    this.carregarOpcoesTipoDocumentoBuscaItalia();
  }

  salvarBuscaBrasil(event?: Event): void {
    event?.preventDefault();
    event?.stopPropagation();

    const idPac = Number(this.idPacienteEdicao || 0);
    if (idPac <= 0) {
      this.util.toasterShowWarning('Atenção', 'Salve o cliente antes de gravar a busca de documentos Brasil.');
      return;
    }

    const v = this.formBuscaBrasil.getRawValue();
    const idStatus = Number(v.idStatusGeral);
    if (!Number.isFinite(idStatus) || idStatus <= 0) {
      this.util.toasterShowWarning('Atenção', 'Selecione o status geral do pedido.');
      this.formBuscaBrasil.get('idStatusGeral')?.markAsTouched();
      return;
    }

    const nomeAbaSalvar = this.resolverNomeAbaBuscaDocumentosAtiva();

    const itensPayload = (this.buscaBrasilItens || [])
      .filter((linha) => Number(linha.idTipoDocumento || 0) > 0)
      .map((linha) => ({
        ID_DOCUMENTOS_PROVIDENCIADO: Number(linha.idDocumentosProvidenciado || 0),
        ID_TIPO_DOCUMENTO: Number(linha.idTipoDocumento),
        NOME_ABA: nomeAbaSalvar,
        TITULAR: (linha.titular || '').trim(),
        ESTADO: (linha.estado || '').trim(),
        CIDADE: (linha.cidade || '').trim(),
        QUANTIDADE: Number(linha.quantidade || 0) > 0 ? Number(linha.quantidade) : 1,
        SOLICITADO: this.dataLocalParaPayloadApi(linha.solicitado),
        RECEBIDO: this.dataLocalParaPayloadApi(linha.recebido),
      }));

    const payload: Record<string, unknown> = {
      ID_BUSCA_DOCUMENTOS_BRASIL: Number(v.idBuscaDocumentosBrasil || 0),
      DATA_DEMANDA: this.dataLocalParaPayloadApi(v.dataDemanda),
      ID_PACIENTE_CLINICA: idPac,
      ID_STATUS_GERAL: idStatus,
      ITENS: itensPayload,
    };

    const url = `${API}empresa/UsuBuscaDocumentosBrasil/SaveAsync`;
    this.util.showLoading();
    this.ajaxService.post(url, payload).subscribe({
      next: (response) => {
        this.util.closeLoading();
        if (response?.hasErrors || response?.HasErrors) {
          this.util.toasterShowError(
            'Erro',
            response?.message || response?.Message || 'Não foi possível salvar busca Brasil.',
          );
          return;
        }
        const dados = this.desempacotarResponse(response);
        this.aplicarBuscaBrasilDoBackend(dados);

        const idPacAtual = Number(this.idPacienteEdicao || 0);
        if (idPacAtual > 0) {
          this.carregarItensBuscaBrasil(idPacAtual);
          this.buscaBrasilDadosPacienteCarregados = idPac;
        }

        this.cdr.detectChanges();
        this.util.toasterShowSuccess('Sucesso', 'Busca documentos Brasil salva.');
        this.formBuscaBrasil.markAsPristine();
      },
      error: () => {
        this.util.closeLoading();
        this.util.toasterShowError('Erro', 'Falha ao salvar busca documentos Brasil.');
      },
    });
  }

  limparFormularioBuscaBrasil(): void {
    this.invalidarCacheBuscaBrasilPaciente();
    this.inicializarFormularioBuscaBrasil();
    this.buscaBrasilItens = [];
    this.formBuscaBrasil.markAsUntouched();
    this.formBuscaBrasil.markAsPristine();
    this.cdr.detectChanges();
  }

  adicionarLinhaBuscaBrasil(): void {
    this.buscaBrasilItens = [...(this.buscaBrasilItens || []), this.criarLinhaBuscaBrasilVazia()];
    this.cdr.detectChanges();
  }

  removerLinhaBuscaBrasil(indice: number): void {
    if (indice < 0 || indice >= this.buscaBrasilItens.length) {
      return;
    }
    this.buscaBrasilItens = this.buscaBrasilItens.filter((_, i) => i !== indice);
    this.cdr.detectChanges();
  }

  abrirModalTipoDocumentoBuscaBrasil(): void {
    this.modalTipoDocumentoBuscaBrasilAberto = true;
    this.resetarFormTipoDocumentoBuscaBrasil();
    this.carregarTiposDocumentoBuscaBrasilModal();
    this.cdr.detectChanges();
  }

  fecharModalTipoDocumentoBuscaBrasil(): void {
    this.modalTipoDocumentoBuscaBrasilAberto = false;
    this.resetarFormTipoDocumentoBuscaBrasil();
    this.cdr.detectChanges();
  }

  novoTipoDocumentoBuscaBrasil(): void {
    this.resetarFormTipoDocumentoBuscaBrasil();
    this.cdr.detectChanges();
  }

  editarTipoDocumentoBuscaBrasil(item: TipoDocumentoBuscaBrasilAdmin): void {
    if (!item?.idTipoDocumento) {
      return;
    }
    this.tipoDocumentoBuscaBrasilEditando = { ...item };
    this.tipoDocumentoBuscaBrasilFormTitulo = item.titulo;
    this.tipoDocumentoBuscaBrasilFormDescricao = item.descricao;
    this.cdr.detectChanges();
  }

  salvarTipoDocumentoBuscaBrasil(): void {
    const titulo = (this.tipoDocumentoBuscaBrasilFormTitulo || '').trim();
    if (!titulo) {
      this.util.toasterShowWarning('Atenção', 'Informe o título do tipo de documento.');
      return;
    }

    const idTipo = Number(this.tipoDocumentoBuscaBrasilEditando?.idTipoDocumento || 0);
    const payload: Record<string, unknown> = {
      ID_TIPO_DOCUMENTO: idTipo,
      TITULO: titulo,
      DESCRICAO: (this.tipoDocumentoBuscaBrasilFormDescricao || '').trim(),
      TIPO: 'buscaBrasil',
    };

    this.salvandoTipoDocumentoBuscaBrasil = true;
    this.ajaxService.post(`${API}empresa/ServicoTipoDocumento/SaveAsync`, payload).subscribe({
      next: (response) => {
        this.salvandoTipoDocumentoBuscaBrasil = false;
        if (response?.hasErrors || response?.HasErrors) {
          this.util.toasterShowError(
            'Erro',
            response?.message || response?.Message || 'Não foi possível salvar o tipo de documento.',
          );
          this.cdr.detectChanges();
          return;
        }
        this.util.toasterShowSuccess(
          'Sucesso',
          idTipo > 0 ? 'Tipo de documento atualizado.' : 'Tipo de documento cadastrado.',
        );
        this.resetarFormTipoDocumentoBuscaBrasil();
        this.recarregarOpcoesTipoDocumentoBuscaBrasil();
        this.carregarTiposDocumentoBuscaBrasilModal();
      },
      error: () => {
        this.salvandoTipoDocumentoBuscaBrasil = false;
        this.util.toasterShowError('Erro', 'Falha ao salvar o tipo de documento.');
        this.cdr.detectChanges();
      },
    });
  }

  excluirTipoDocumentoBuscaBrasil(item: TipoDocumentoBuscaBrasilAdmin): void {
    const idTipo = Number(item?.idTipoDocumento || 0);
    if (idTipo <= 0) {
      return;
    }
    const rotulo = (item.titulo || '').trim() || `#${idTipo}`;
    if (!confirm(`Excluir o tipo de documento "${rotulo}"?`)) {
      return;
    }

    this.util.showLoading();
    this.ajaxService.delete(`${API}empresa/ServicoTipoDocumento/DeleteAsync?id=${idTipo}`).subscribe({
      next: (response) => {
        this.util.closeLoading();
        if (response?.hasErrors || response?.HasErrors) {
          this.util.toasterShowError(
            'Erro',
            response?.message || response?.Message || 'Não foi possível excluir o tipo de documento.',
          );
          return;
        }
        if (this.tipoDocumentoBuscaBrasilEditando?.idTipoDocumento === idTipo) {
          this.resetarFormTipoDocumentoBuscaBrasil();
        }
        this.buscaBrasilItens = (this.buscaBrasilItens || []).map((linha) =>
          Number(linha.idTipoDocumento || 0) === idTipo ? { ...linha, idTipoDocumento: null } : linha,
        );
        this.util.toasterShowSuccess('Sucesso', 'Tipo de documento excluído.');
        this.recarregarOpcoesTipoDocumentoBuscaBrasil();
        this.carregarTiposDocumentoBuscaBrasilModal();
      },
      error: () => {
        this.util.closeLoading();
        this.util.toasterShowError('Erro', 'Falha ao excluir o tipo de documento.');
      },
    });
  }

  private resetarFormTipoDocumentoBuscaBrasil(): void {
    this.tipoDocumentoBuscaBrasilEditando = null;
    this.tipoDocumentoBuscaBrasilFormTitulo = '';
    this.tipoDocumentoBuscaBrasilFormDescricao = '';
  }

  private carregarTiposDocumentoBuscaBrasilModal(): void {
    this.carregandoTiposDocumentoBuscaBrasilModal = true;
    const url = `${API}empresa/ServicoTipoDocumento/Consultar?tipo=buscaBrasil`;
    this.ajaxService.get(url).subscribe({
      next: (response) => {
        this.carregandoTiposDocumentoBuscaBrasilModal = false;
        if (response?.hasErrors || response?.HasErrors) {
          this.tiposDocumentoBuscaBrasilModalLista = [];
          this.cdr.detectChanges();
          return;
        }
        const raw = this.desempacotarResponse(response);
        const lista = Array.isArray(raw) ? raw : this.extrairListaResponse(raw);
        this.tiposDocumentoBuscaBrasilModalLista = lista
          .map((item: Record<string, unknown>) => this.mapearTipoDocumentoBuscaBrasilAdmin(item))
          .filter((x: TipoDocumentoBuscaBrasilAdmin) => x.idTipoDocumento > 0);
        this.cdr.detectChanges();
      },
      error: () => {
        this.carregandoTiposDocumentoBuscaBrasilModal = false;
        this.tiposDocumentoBuscaBrasilModalLista = [];
        this.util.toasterShowError('Erro', 'Não foi possível carregar os tipos de documento.');
        this.cdr.detectChanges();
      },
    });
  }

  private mapearTipoDocumentoBuscaBrasilAdmin(item: Record<string, unknown>): TipoDocumentoBuscaBrasilAdmin {
    const idTd = Number(this.lerValorRegistroApi(item, ['ID_TIPO_DOCUMENTO']) ?? 0);
    const tituloBruto = this.lerValorRegistroApi(item, ['TITULO', 'titulo']);
    const descricaoBruta = this.lerValorRegistroApi(item, ['DESCRICAO', 'descricao']);
    const titulo = this.toText(tituloBruto) || `#${idTd}`;
    return {
      idTipoDocumento: idTd,
      titulo,
      descricao: this.toText(descricaoBruta),
    };
  }

  private recarregarOpcoesTipoDocumentoBuscaBrasil(): void {
    this.tiposDocumentoBuscaBrasilOpcoes = [];
    this.carregarOpcoesTipoDocumentoBuscaBrasil();
  }

  /** Chave NOME_ABA em USU_DOCUMENTOS_PROVIDENCIADO (não exibida na grade). */
  private resolverNomeAbaBuscaDocumentosAtiva(): string {
    if (this.subAbaBuscaAtiva === 'italia') {
      return 'buscaItalia';
    }
    if (this.subAbaBuscaAtiva === 'brasil') {
      return 'buscaBrasil';
    }
    return 'buscaBrasil';
  }

  private criarLinhaBuscaBrasilVazia(): BuscaBrasilItemLinha {
    return {
      idDocumentosProvidenciado: 0,
      idTipoDocumento: null,
      titular: '',
      estado: '',
      cidade: '',
      quantidade: 1,
      solicitado: '',
      recebido: '',
      tradutor: '',
      revisor: '',
      apostilarDocumento: false,
      apostilarTraducao: false,
    };
  }

  private mapearItensBuscaBrasilDoBackend(lista: unknown[]): BuscaBrasilItemLinha[] {
    return (lista || []).map((raw) => {
      const item = raw as Record<string, unknown>;
      const idItem = Number(
        this.lerValorRegistroApi(item, ['ID_DOCUMENTOS_PROVIDENCIADO', 'ID_BUSCA_DOCUMENTOS_BRASIL_ITEM']) ?? 0,
      );
      const idTipo = Number(this.lerValorRegistroApi(item, ['ID_TIPO_DOCUMENTO']) ?? 0);
      const qtd = Number(this.lerValorRegistroApi(item, ['QUANTIDADE']) ?? 1);
      const solicitadoRaw = this.lerValorRegistroApi(item, ['SOLICITADO']);
      const recebidoRaw = this.lerValorRegistroApi(item, ['RECEBIDO']);
      return {
        idDocumentosProvidenciado: idItem,
        idTipoDocumento: idTipo > 0 ? idTipo : null,
        titular: String(this.lerValorRegistroApi(item, ['TITULAR']) ?? '').trim(),
        estado: String(this.lerValorRegistroApi(item, ['ESTADO']) ?? '').trim(),
        cidade: String(this.lerValorRegistroApi(item, ['CIDADE']) ?? '').trim(),
        quantidade: qtd > 0 ? qtd : 1,
        solicitado: this.converterDataDocumentoItemProvidenciado(solicitadoRaw),
        recebido: this.converterDataDocumentoItemProvidenciado(recebidoRaw),
        tradutor: this.toText(this.lerValorRegistroApi(item, ['TRADUTOR'])),
        revisor: this.toText(this.lerValorRegistroApi(item, ['REVISOR'])),
        apostilarDocumento: this.byteParaSimNaoBoolean(
          this.lerValorRegistroApi(item, ['APOSTILAR_DOCUMENTO', 'apostilarDocumento']),
        ),
        apostilarTraducao: this.byteParaSimNaoBoolean(
          this.lerValorRegistroApi(item, ['APOSTILAR_TRADUCAO', 'apostilarTraducao']),
        ),
      };
    });
  }

  // Método para marcar campos inválidos
  marcarCamposInvalidos(): void {
    Object.keys(this.formCliente.controls).forEach(key => {
      const control = this.formCliente.get(key);
      if (control?.invalid) {
        control.markAsTouched();
      }
    });
  }

  // Método para marcar campos inválidos do formulário de naturalização
  marcarCamposInvalidosNaturalizacao(): void {
    Object.keys(this.formNaturalizacao.controls).forEach(key => {
      const control = this.formNaturalizacao.get(key);
      if (control?.invalid) {
        control.markAsTouched();
      }
    });
  }

  // Método para marcar campos inválidos do formulário de Jud Ita
  marcarCamposInvalidosJudIta(): void {
    Object.keys(this.formJudIta.controls).forEach(key => {
      const control = this.formJudIta.get(key);
      if (control?.invalid) {
        control.markAsTouched();
      }
    });
  }

  // Método para marcar campos inválidos do formulário de AIRE
  marcarCamposInvalidosAire(): void {
    Object.keys(this.formAire.controls).forEach(key => {
      const control = this.formAire.get(key);
      if (control?.invalid) {
        control.markAsTouched();
      }
    });
  }

  // Método para marcar campos inválidos do formulário de Fast-It
  marcarCamposInvalidosFastIt(): void {
    Object.keys(this.formFastIt.controls).forEach(key => {
      const control = this.formFastIt.get(key);
      if (control?.invalid) {
        control.markAsTouched();
      }
    });
  }

  // Método para marcar campos inválidos do formulário de Tradução
  marcarCamposInvalidosTraducao(): void {
    Object.keys(this.formTraducao.controls).forEach(key => {
      const control = this.formTraducao.get(key);
      if (control?.invalid) {
        control.markAsTouched();
      }
    });
  }

  // Método para marcar campos inválidos do formulário de Busca Itália
  marcarCamposInvalidosBuscaItalia(): void {
    Object.keys(this.formBuscaItalia.controls).forEach(key => {
      const control = this.formBuscaItalia.get(key);
      if (control?.invalid) {
        control.markAsTouched();
      }
    });
  }

  // Método para marcar campos inválidos do formulário de Busca Brasil
  marcarCamposInvalidosBuscaBrasil(): void {
    Object.keys(this.formBuscaBrasil.controls).forEach(key => {
      const control = this.formBuscaBrasil.get(key);
      if (control?.invalid) {
        control.markAsTouched();
      }
    });
  }

  // ===== MÉTODOS DO CHAT =====

  // Método para inicializar o chat
  inicializarChat(): void {
    // Simular cliente selecionado
    this.clienteSelecionado = {
      nome: 'João Silva',
      email: 'joao.silva@email.com',
      telefone: '(11) 99999-9999'
    };
    
    // Simular status online
    this.clienteOnline = true;
    
    // Inicializar mensagens de exemplo
    this.mensagens = [
      {
        id: 1,
        texto: 'Olá! Como posso ajudá-lo hoje?',
        remetente: 'empresa',
        timestamp: new Date(Date.now() - 600000), // 10 minutos atrás
        lida: true
      },
      {
        id: 2,
        texto: 'Gostaria de saber sobre o status do meu processo de cidadania italiana.',
        remetente: 'cliente',
        timestamp: new Date(Date.now() - 580000), // 9 minutos atrás
        lida: true
      },
      {
        id: 3,
        texto: 'Claro! Vou verificar o status do seu processo. Um momento, por favor.',
        remetente: 'empresa',
        timestamp: new Date(Date.now() - 550000), // 8 minutos atrás
        lida: true
      },
      {
        id: 4,
        texto: 'Seu processo está em andamento na fase de documentação. Precisamos de alguns documentos adicionais que já enviamos por email.',
        remetente: 'empresa',
        timestamp: new Date(Date.now() - 530000), // 7 minutos atrás
        lida: true
      },
      {
        id: 5,
        texto: 'Perfeito! Vou enviar os documentos solicitados ainda hoje. Obrigado pela informação!',
        remetente: 'cliente',
        timestamp: new Date(Date.now() - 500000), // 5 minutos atrás
        lida: true
      },
      {
        id: 6,
        texto: 'Excelente! Assim que recebermos os documentos, daremos continuidade ao processo. Qualquer dúvida, estou à disposição!',
        remetente: 'empresa',
        timestamp: new Date(Date.now() - 480000), // 3 minutos atrás
        lida: true
      }
    ];
    
    // Iniciar simulação de status
    this.simularStatusCliente();
  }

  // Método para enviar mensagem
  enviarMensagem(event?: KeyboardEvent): void {
    if (event && event.shiftKey) {
      return; // Permite quebra de linha com Shift+Enter
    }
    
    if (event) {
      event.preventDefault();
    }
    
    if (this.novaMensagem?.trim()) {
      const mensagem = {
        id: Date.now(),
        texto: this.novaMensagem.trim(),
        remetente: 'empresa',
        timestamp: new Date(),
        lida: false
      };
      
      this.mensagens.push(mensagem);
      this.novaMensagem = '';
      
      // Simular resposta do cliente após 2 segundos
      setTimeout(() => {
        this.simularRespostaCliente();
      }, 2000);
      
      // Scroll para a última mensagem
      setTimeout(() => {
        this.scrollParaUltimaMensagem();
      }, 100);
    }
  }

  // Método para simular resposta do cliente
  private simularRespostaCliente(): void {
    const respostas = [
      'Obrigado pela informação!',
      'Entendi, vou verificar isso.',
      'Perfeito! Quando posso esperar uma resposta?',
      'Tenho uma dúvida sobre isso...',
      'Muito obrigado pelo atendimento!',
      'Posso enviar os documentos por email?',
      'Qual é o próximo passo?',
      'Entendi perfeitamente!'
    ];
    
    const respostaAleatoria = respostas[Math.floor(Math.random() * respostas.length)];
    
    const mensagem = {
      id: Date.now(),
      texto: respostaAleatoria,
      remetente: 'cliente',
      timestamp: new Date(),
      lida: true
    };
    
    this.mensagens.push(mensagem);
    
    // Scroll para a última mensagem
    setTimeout(() => {
      this.scrollParaUltimaMensagem();
    }, 100);
  }

  // Método para scroll automático para a última mensagem
  private scrollParaUltimaMensagem(): void {
    const chatMessages = document.querySelector('.chat-messages');
    if (chatMessages) {
      chatMessages.scrollTop = chatMessages.scrollHeight;
    }
  }

  // Método para anexar arquivo
  anexarArquivo(): void {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.pdf,.doc,.docx,.jpg,.jpeg,.png';
    input.onchange = (event: any) => {
      const file = event.target.files[0];
      if (file) {
        const mensagem = {
          id: Date.now(),
          texto: `📎 Anexo: ${file.name}`,
          remetente: 'empresa',
          timestamp: new Date(),
          lida: false,
          anexo: {
            nome: file.name,
            tamanho: file.size,
            tipo: file.type
          }
        };
        
        this.mensagens.push(mensagem);
        
        // Scroll para a última mensagem
        setTimeout(() => {
          this.scrollParaUltimaMensagem();
        }, 100);
      }
    };
    input.click();
  }

  // Método para enviar emoji
  enviarEmoji(): void {
    const emojis = ['😊', '👍', '❤️', '🎉', '😢', '😮', '😡', '🤔', '👏', '🔥'];
    const emojiAleatorio = emojis[Math.floor(Math.random() * emojis.length)];
    
    const mensagem = {
      id: Date.now(),
      texto: emojiAleatorio,
      remetente: 'empresa',
      timestamp: new Date(),
      lida: false
    };
    
    this.mensagens.push(mensagem);
    
    // Scroll para a última mensagem
    setTimeout(() => {
      this.scrollParaUltimaMensagem();
    }, 100);
  }

  // Método para limpar chat
  limparChat(): void {
    if (confirm('Tem certeza que deseja limpar todo o histórico do chat?')) {
      this.mensagens = [];
    }
  }

  // Método para exportar chat
  exportarChat(): void {
    if (this.mensagens.length === 0) {
      alert('Não há mensagens para exportar.');
      return;
    }
    
    let conteudo = `Chat com ${this.clienteSelecionado?.nome || 'Cliente'}\n`;
    conteudo += `Data: ${new Date().toLocaleDateString('pt-BR')}\n`;
    conteudo += '='.repeat(50) + '\n\n';
    
    this.mensagens.forEach(msg => {
      const data = new Date(msg.timestamp).toLocaleString('pt-BR');
      const remetente = msg.remetente === 'empresa' ? 'Empresa' : 'Cliente';
      conteudo += `[${data}] ${remetente}: ${msg.texto}\n`;
    });
    
    const blob = new Blob([conteudo], { type: 'text/plain' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `chat-${this.clienteSelecionado?.nome || 'cliente'}-${new Date().toISOString().split('T')[0]}.txt`;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  // Método para simular status online/offline do cliente
  simularStatusCliente(): void {
    // Simular mudança de status a cada 30 segundos
    setInterval(() => {
      this.clienteOnline = Math.random() > 0.5;
    }, 30000);
  }

  // ===== MÉTODOS DO EDITOR SHAREPOINT =====

  // Método para executar comandos de formatação
  executarComando(comando: string): void {
    document.execCommand(comando, false);
    this.atualizarStatus();
  }

  // Método para alterar tamanho da fonte
  alterarTamanhoFonte(event: any): void {
    const tamanho = event.target.value;
    const tamanhos = { '1': 8, '2': 10, '3': 12, '4': 14, '5': 16, '6': 18, '7': 24 };
    this.tamanhoFonteAtual = tamanhos[tamanho as keyof typeof tamanhos];
    document.execCommand('fontSize', false, tamanho);
    this.atualizarStatus();
  }

  // Método para alterar fonte
  alterarFonte(event: any): void {
    const fonte = event.target.value;
    this.fonteAtual = fonte;
    document.execCommand('fontName', false, fonte);
    this.atualizarStatus();
  }

  // Método para alterar cor do texto
  alterarCorTexto(event: any): void {
    const cor = event.target.value;
    this.corTextoAtual = cor;
    document.execCommand('foreColor', false, cor);
    this.atualizarStatus();
  }

  // Método para inserir link
  inserirLink(): void {
    const url = prompt('Digite a URL do link:');
    if (url) {
      document.execCommand('createLink', false, url);
    }
  }

  // Método para inserir imagem
  inserirImagem(): void {
    const url = prompt('Digite a URL da imagem:');
    if (url) {
      document.execCommand('insertImage', false, url);
    }
  }

  // Método para inserir tabela
  inserirTabela(): void {
    const linhas = prompt('Número de linhas:', '3');
    const colunas = prompt('Número de colunas:', '3');
    
    if (linhas && colunas) {
      let tabela = '<table border="1" style="border-collapse: collapse; width: 100%;">';
      
      for (let i = 0; i < parseInt(linhas); i++) {
        tabela += '<tr>';
        for (let j = 0; j < parseInt(colunas); j++) {
          tabela += '<td style="padding: 8px; border: 1px solid #ccc;">&nbsp;</td>';
        }
        tabela += '</tr>';
      }
      
      tabela += '</table>';
      document.execCommand('insertHTML', false, tabela);
    }
  }

  // Método para inserir linha horizontal
  inserirLinhaHorizontal(): void {
    document.execCommand('insertHorizontalRule', false);
  }

  // Método para desfazer
  desfazer(): void {
    document.execCommand('undo', false);
  }

  // Método para refazer
  refazer(): void {
    document.execCommand('redo', false);
  }

  // Método para limpar formatação
  limparFormatacao(): void {
    document.execCommand('removeFormat', false);
    this.atualizarStatus();
  }

  // Método para atualizar status da barra
  atualizarStatus(): void {
    // Atualizar informações da fonte atual
    const selection = window.getSelection();
    if (selection && selection.rangeCount > 0) {
      const range = selection.getRangeAt(0);
      const container = range.commonAncestorContainer;
      
      if (container.nodeType === Node.TEXT_NODE) {
        const element = container.parentElement;
        if (element) {
          const computedStyle = window.getComputedStyle(element);
          this.fonteAtual = computedStyle.fontFamily.split(',')[0].replace(/['"]/g, '');
          this.tamanhoFonteAtual = parseInt(computedStyle.fontSize);
          this.corTextoAtual = computedStyle.color;
        }
      }
    }
  }

  // Método para capturar mudanças no conteúdo
  onContentChange(): void {
    this.conteudoEditor = this.getEditorContent();
  }

  // Método para capturar colagem
  onPaste(event: ClipboardEvent): void {
    event.preventDefault();
    const text = event.clipboardData?.getData('text/plain');
    if (text) {
      document.execCommand('insertText', false, text);
    }
  }

  // Método para capturar teclas
  onKeyDown(event: KeyboardEvent): void {
    // Ctrl+Z para desfazer
    if (event.ctrlKey && event.key === 'z' && !event.shiftKey) {
      event.preventDefault();
      this.desfazer();
    }
    
    // Ctrl+Y ou Ctrl+Shift+Z para refazer
    if ((event.ctrlKey && event.key === 'y') || (event.ctrlKey && event.shiftKey && event.key === 'z')) {
      event.preventDefault();
      this.refazer();
    }
    
    // Ctrl+B para negrito
    if (event.ctrlKey && event.key === 'b') {
      event.preventDefault();
      this.executarComando('bold');
    }
    
    // Ctrl+I para itálico
    if (event.ctrlKey && event.key === 'i') {
      event.preventDefault();
      this.executarComando('italic');
    }
    
    // Ctrl+U para sublinhado
    if (event.ctrlKey && event.key === 'u') {
      event.preventDefault();
      this.executarComando('underline');
    }
  }

  // Método para obter conteúdo do editor
  getEditorContent(): string {
    const editor = document.querySelector('.editor-content') as HTMLElement;
    return editor ? editor.innerHTML : '';
  }

  // Método para definir conteúdo do editor
  setEditorContent(content: string): void {
    const editor = document.querySelector('.editor-content') as HTMLElement;
    if (editor) {
      editor.innerHTML = content;
      this.conteudoEditor = content;
    }
  }

  // Método para salvar conteúdo
  salvarConteudo(): void {
    const conteudo = this.getEditorContent();
    localStorage.setItem('sharepoint-editor-content', conteudo);
    alert('Conteúdo salvo com sucesso!');
  }

  // Método para carregar conteúdo
  carregarConteudo(): void {
    const conteudo = localStorage.getItem('sharepoint-editor-content');
    if (conteudo) {
      this.setEditorContent(conteudo);
      alert('Conteúdo carregado com sucesso!');
    } else {
      alert('Nenhum conteúdo salvo encontrado.');
    }
  }

  // Método para limpar conteúdo
  limparConteudo(): void {
    if (confirm('Tem certeza que deseja limpar todo o conteúdo?')) {
      this.setEditorContent('');
    }
  }

  // Método para exportar conteúdo
  exportarConteudo(): void {
    const conteudo = this.getEditorContent();
    if (!conteudo.trim()) {
      alert('Não há conteúdo para exportar.');
      return;
    }
    
    // Criar arquivo HTML
    const htmlContent = `
<!DOCTYPE html>
<html>
<head>
    <meta charset="UTF-8">
    <title>Documento Sharepoint</title>
    <style>
        body { font-family: Arial, sans-serif; margin: 40px; line-height: 1.6; }
        h1, h2, h3 { color: #978443; }
        table { border-collapse: collapse; width: 100%; margin: 20px 0; }
        td, th { border: 1px solid #ddd; padding: 8px; text-align: left; }
        th { background-color: #f2f2f2; }
    </style>
</head>
<body>
    ${conteudo}
</body>
</html>`;
    
    const blob = new Blob([htmlContent], { type: 'text/html' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `documento-sharepoint-${new Date().toISOString().split('T')[0]}.html`;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  // ===== MÉTODOS DO MODAL DE CADASTRO DE CLIENTE =====

  // Método para abrir modal de cadastro de cliente
  abrirModalCadastroCliente(): void {
    this.modalCadastroClienteVisible = true;
    this.clienteParaEdicao = null; // Para novo cliente
  }

  // Método para fechar modal de cadastro de cliente
  fecharModalCadastroCliente(): void {
    this.modalCadastroClienteVisible = false;
    this.clienteParaEdicao = null;
  }

  // Método para quando cliente é salvo
  onClienteSalvo(cliente: any): void {
    console.log('Cliente salvo:', cliente);
    // Aqui você pode implementar lógica adicional após salvar o cliente
    // Por exemplo, atualizar uma lista de clientes, mostrar mensagem de sucesso, etc.
    this.fecharModalCadastroCliente();
  }

  // ===== MÉTODOS DE VALIDAÇÃO =====

  // Método para verificar se um campo é inválido
  isCampoInvalido(campo: string): boolean {
    const control = this.formCliente.get(campo);
    return !!(control && control.invalid && (control.dirty || control.touched));
  }

  // Método para obter mensagem de erro
  getMensagemErro(campo: string): string {
    const control = this.formCliente.get(campo);
    if (control && control.errors) {
      if (control.errors['required']) {
        if (campo === 'cidade' && this.toText(this.cidadeBuscaTexto)) {
          return 'Selecione a cidade na lista ou confira a grafia';
        }
        return `${this.getNomeCampo(campo)} é obrigatório`;
      }
      if (control.errors['email']) {
        return 'Email inválido';
      }
      if (control.errors['minlength']) {
        return `${this.getNomeCampo(campo)} deve ter pelo menos ${control.errors['minlength'].requiredLength} caracteres`;
      }
      if (control.errors['maxlength']) {
        return `${this.getNomeCampo(campo)} deve ter no máximo ${control.errors['maxlength'].requiredLength} caracteres`;
      }
      if (control.errors['pattern']) {
        if (campo === 'cpf') {
          return `${this.rotuloDocumento} inválido (formato: ${this.placeholderDocumento})`;
        }
        if (campo === 'cep') {
          return 'CEP inválido (formato: 00000-000)';
        }
        return 'Formato inválido';
      }
    }
    return '';
  }

  // Método para obter nome amigável do campo
  private getNomeCampo(campo: string): string {
    const nomes: { [key: string]: string } = {
      'dante_causa': 'Dante Causa',
      'carteira': 'Sobrenome Italiano da Família',
      'sobrenome': 'Sobrenome',
      'nome': 'Nome',
      'cpf': this.rotuloDocumento,
      'senha': 'Senha',
      'email': 'Email',
      'telefone_celular': 'Telefone Celular',
      'rua': 'Logradouro',
      'numero': 'Número',
      'bairro': 'Bairro',
      'cep': 'CEP',
      'pais': 'País',
      'estado': 'Estado',
      'cidade': 'Cidade'
    };
    return nomes[campo] || campo;
  }

  // ===== MÉTODOS PARA EDIÇÃO VIA QUERY PARAMETERS =====

  // Verificar se há dados de cliente para edição
  verificarDadosEdicao(): void {
    this.route.queryParams.subscribe(params => {
      const isModoEdicao = params['modo'] === 'edicao';
      this.atualizarValidacaoSenha(isModoEdicao);

      if (this.somenteAbaCliente) {
        this.selecionarAba('cliente');
      }

      const tabSolicitada = this.toText(params['tab']).toLowerCase();
      if (!this.somenteAbaCliente && tabSolicitada && this.abasValidas.includes(tabSolicitada)) {
        this.selecionarAba(tabSolicitada);
      }

      
      if (isModoEdicao && params['clienteData']) {
        try {
          const clienteData = JSON.parse(params['clienteData']);
          console.log('Dados do cliente recebidos:', clienteData);
          this.idPacienteEdicao = Number(clienteData.id_paciente_clinica || clienteData.id || 0);
          this.idEmpresaEdicao = Number(clienteData.id_empresa || 1);
          this.idUsuarioEdicao = Number(clienteData.id_usuario || 0) || null;
          this.idCidadeEdicao = Number(clienteData.id_cidade || 0) || null;
          this.idEstadoEdicao = Number(clienteData.id_estado || 0) || null;
          this.idPaisEdicao = Number(clienteData.id_pais || 0) || null;
          this.estadoEdicaoNome = this.toText(clienteData.estado);
          
          // Preencher o formulário com os dados do cliente
          this.preencherFormularioComDadosCliente(clienteData);
          this.carregarClienteEdicaoPorId();
          
          // Mantém comportamento legado: quando não vier "tab", cai na aba cliente.
          if (!tabSolicitada) {
            this.selecionarAba('cliente');
          }
          
        } catch (error) {
          console.error('Erro ao processar dados do cliente:', error);
          this.carregarClienteEdicaoPorId();
        }
      } else {
        this.idPacienteEdicao = Number(params['idPaciente'] || 0);
        this.idCidadeEdicao = null;
        this.idEstadoEdicao = null;
        this.idPaisEdicao = null;
        this.estadoEdicaoNome = '';

        if (this.idPacienteEdicao > 0) {
          this.atualizarValidacaoSenha(true);
        }

        if (isModoEdicao && this.idPacienteEdicao > 0) {
          this.carregarClienteEdicaoPorId();
        }
      }
    });
  }

  // Preencher formulário com dados do cliente
  preencherFormularioComDadosCliente(cliente: any): void {
    if (cliente && this.formCliente) {
      const idPais = Number(cliente.id_pais || cliente.idpais || 0) || this.idPaisEdicao || null;
      const idEstado = Number(cliente.id_estado || cliente.idestado || 0) || this.idEstadoEdicao || null;
      const idCidade = Number(cliente.id_cidade || cliente.idcidade || 0) || this.idCidadeEdicao || null;
      const paisTexto = this.toText(cliente.pais || cliente.nome_pais || cliente.pais_nome);
      const paisNormalizado = (idPais === 2 || paisTexto.toLowerCase() === 'italia') ? 'Italia' : 'Brasil';

      this.idPaisEdicao = idPais;
      this.idEstadoEdicao = idEstado;
      this.idCidadeEdicao = idCidade;
      this.estadoEdicaoNome = this.toText(cliente.estado || cliente.nome_estado || cliente.uf);

      const digitosDocumento = this.toText(cliente.cpf).replace(/\D/g, '');
      this.definirTipoPessoa(digitosDocumento.length === 14 ? 'PJ' : 'PF');

      // Mapear os dados do cliente para o formulário
      const dadosFormulario = {
        dante_causa: cliente.dante_causa || cliente.danteCausa || cliente['dante causa'] || '',
        carteira: cliente.carteira || '',
        sobrenome: cliente.sobrenome || '',
        nome: cliente.nome || '',
        cpf: this.aplicarMascaraDocumento(cliente.cpf || ''),
        senha: '',
        email: cliente.email || '',
        telefone_celular: this.aplicarMascaraTelefone(cliente.telefone_celular || ''),
        telefone_adicional: this.aplicarMascaraTelefone(cliente.telefone_adicional || ''),
        rua: cliente.rua || '',
        numero: cliente.numero || '',
        complemento: cliente.complemento || '',
        bairro: cliente.bairro || '',
        cep: this.aplicarMascaraCep(cliente.cep || ''),
        pais: paisNormalizado,
        estado: '',
        cidade: this.idCidadeEdicao || '',
        link_pasta: cliente.link_pasta || cliente.linkPasta || cliente.link_pasta_virtual || '',
        apelido_pasta_virtual: cliente.apelido_pasta_virtual || cliente.apelidoPastaVirtual || '',
        pasta_fisica: this.parseBoolean(cliente.pasta_fisica ?? cliente.pastaFisica),
        observacoes: cliente.observacoes || ''
      };

      // Aplicar os dados ao formulário
      this.formCliente.patchValue(dadosFormulario);
      this.onPaisChange(this.idPaisEdicao || (paisNormalizado === 'Italia' ? 2 : 1));

      this.aplicarSubAbasServicosDesdeCliente(cliente);

      if (this.idPacienteEdicao > 0) {
        this.atualizarValidacaoSenha(true);
        this.formCliente.get('senha')?.setValue('', { emitEvent: false });
      }

      this.atualizarEstadoSalvarCliente();
      console.log('Formulário preenchido com dados do cliente:', dadosFormulario);
    }
  }

  /**
   * Lê HABILITAR_* do registro da API. Suporta UPPER, snake_lower e camelCase
   * (ex.: `habilitarNaturalizacao` vira `habilitarnaturalizacao` após converterParaLowercase).
   */
  private valorCampoHabilitarCliente(cliente: any, coluna: string): any {
    if (!cliente || typeof cliente !== 'object') return undefined;
    const snakeLower = coluna.toLowerCase();
    let v = cliente[snakeLower];
    if (v !== undefined && v !== null) return v;
    v = cliente[coluna];
    if (v !== undefined && v !== null) return v;
    const parts = snakeLower.split('_').filter(Boolean);
    const camel = parts
      .map((p, i) => (i === 0 ? p : p.charAt(0).toUpperCase() + p.slice(1)))
      .join('');
    v = cliente[camel.toLowerCase()];
    if (v !== undefined && v !== null) return v;
    return undefined;
  }

  /** Sincroniza checkboxes «Habilitar Abas» com TINYINT (1/0) vindos da PACIENTE_CLINICA. */
  private aplicarSubAbasServicosDesdeCliente(cliente: any): void {
    if (!cliente || typeof cliente !== 'object') {
      this.subAbasServicosSelecionadas = [];
      this.garantirSubAbaServicoAtivaVisivel();
      return;
    }
    const pares: [string, string][] = [
      ['naturalizacao', 'HABILITAR_NATURALIZACAO'],
      ['jud-ita', 'HABILITAR_CIDADANIA'],
      ['aire', 'HABILITAR_AIRE'],
      ['fast-it', 'HABILITAR_FAST_IT'],
      ['traducao', 'HABILITAR_TRADUCAO'],
      ['busca-documentos', 'HABILITAR_BUSCA_DOCUMENTOS'],
    ];
    const selecionadas: string[] = [];
    for (const [idSub, coluna] of pares) {
      const v = this.valorCampoHabilitarCliente(cliente, coluna);
      if (this.parseBoolean(v)) {
        selecionadas.push(idSub);
      }
    }
    this.subAbasServicosSelecionadas = selecionadas;
    this.garantirSubAbaServicoAtivaVisivel();
  }

  private toText(value: any): string {
    if (value === null || value === undefined) return '';
    return String(value).trim();
  }

  private normalizarTribunalCidadania(valor: any): string {
    const texto = this.toText(valor);
    if (!texto) return '';
    const legado: Record<string, string> = {
      'tribunal-roma': 'ROMA',
      'tribunal-milano': 'MILANO',
      'tribunal-napoli': 'NAPOLI',
      'tribunal-torino': 'TORINO',
      'tribunal-firenze': 'FIRENZE',
    };
    const chave = texto.toLowerCase();
    if (legado[chave]) return legado[chave];
    const upper = texto.toUpperCase();
    const encontrado = this.tribunaisCidadaniaOpcoes.find((t) => t.toUpperCase() === upper);
    return encontrado || upper;
  }

  private aplicarMascaraDocumento(value: any): string {
    return this.tipoPessoa === 'PJ' ? this.aplicarMascaraCnpj(value) : this.aplicarMascaraCpf(value);
  }

  private aplicarMascaraCnpj(value: any): string {
    const numeros = this.toText(value).replace(/\D/g, '').slice(0, 14);
    const parte1 = numeros.slice(0, 2);
    const parte2 = numeros.slice(2, 5);
    const parte3 = numeros.slice(5, 8);
    const parte4 = numeros.slice(8, 12);
    const parte5 = numeros.slice(12, 14);

    if (numeros.length <= 2) return parte1;
    if (numeros.length <= 5) return `${parte1}.${parte2}`;
    if (numeros.length <= 8) return `${parte1}.${parte2}.${parte3}`;
    if (numeros.length <= 12) return `${parte1}.${parte2}.${parte3}/${parte4}`;
    return `${parte1}.${parte2}.${parte3}/${parte4}-${parte5}`;
  }

  private aplicarMascaraCpf(value: any): string {
    const numeros = this.toText(value).replace(/\D/g, '').slice(0, 11);
    const parte1 = numeros.slice(0, 3);
    const parte2 = numeros.slice(3, 6);
    const parte3 = numeros.slice(6, 9);
    const parte4 = numeros.slice(9, 11);

    if (numeros.length <= 3) return parte1;
    if (numeros.length <= 6) return `${parte1}.${parte2}`;
    if (numeros.length <= 9) return `${parte1}.${parte2}.${parte3}`;
    return `${parte1}.${parte2}.${parte3}-${parte4}`;
  }

  private aplicarMascaraTelefone(value: any): string {
    const numeros = this.toText(value).replace(/\D/g, '').slice(0, 11);
    const ddd = numeros.slice(0, 2);
    const parte1 = numeros.length > 10 ? numeros.slice(2, 7) : numeros.slice(2, 6);
    const parte2 = numeros.length > 10 ? numeros.slice(7, 11) : numeros.slice(6, 10);

    if (numeros.length <= 2) return ddd;
    if (numeros.length <= 6) return `(${ddd}) ${parte1}`;
    return `(${ddd}) ${parte1}-${parte2}`;
  }

  private aplicarMascaraCep(value: any): string {
    const numeros = this.toText(value).replace(/\D/g, '').slice(0, 8);
    if (numeros.length <= 5) return numeros;
    return `${numeros.slice(0, 5)}-${numeros.slice(5, 8)}`;
  }

  private carregarEstadosPorPais(idPais: number): void {
    const url = API + `empresa/Clinica/GetEstados?idPais=${idPais}`;
    this.isCarregandoEstados = true;

    this.ajaxService.get(url).subscribe({
      next: (response) => {
        const lista = response?.data && Array.isArray(response.data) ? response.data : [];
        this.estadosDisponiveis = lista
          .filter((item: any) => item && typeof item === 'object')
          .map((item: any) => this.util.converterParaLowercase(item))
          .map((item: any) => ({
            id: Number(item.id || 0),
            text: this.toText(item.text)
          }))
          .filter((item: IdValueItem) => item.id > 0 && !!item.text);

        const estadoSelecionado = this.selecionarEstadoPreferencial(idPais);
        this.formCliente?.get('estado')?.setValue(estadoSelecionado?.id || null, { emitEvent: true });
        this.carregarCidadesPorEstado(estadoSelecionado?.id || 0);
        this.isCarregandoEstados = false;
        this.processarPaisPendente();
        this.atualizarEstadoSalvarCliente();
      },
      error: () => {
        this.estadosDisponiveis = [];
        this.formCliente?.get('estado')?.setValue(null, { emitEvent: false });
        this.isCarregandoEstados = false;
        this.processarPaisPendente();
      }
    });
  }

  private selecionarEstadoPreferencial(idPais: number): IdValueItem | null {
    if (this.estadosDisponiveis.length === 0) return null;

    if (this.idEstadoEdicao && this.idEstadoEdicao > 0) {
      const encontradoPorId = this.estadosDisponiveis.find((e) => e.id === this.idEstadoEdicao);
      if (encontradoPorId) return encontradoPorId;
    }

    const nomeEdicao = this.toText(this.estadoEdicaoNome);
    const nomeEdicaoNorm = this.normalizarTextoComparacao(nomeEdicao);
    if (nomeEdicaoNorm) {
      // Se vier UF (ex.: SP), tenta converter para nome completo primeiro.
      if (idPais === 1 && nomeEdicaoNorm.length === 2) {
        const ufParaNome: { [key: string]: string } = {
          ac: 'acre', al: 'alagoas', ap: 'amapa', am: 'amazonas', ba: 'bahia',
          ce: 'ceara', df: 'distritofederal', es: 'espiritosanto', go: 'goias',
          ma: 'maranhao', mt: 'matogrosso', ms: 'matogrossodosul', mg: 'minasgerais',
          pa: 'para', pb: 'paraiba', pr: 'parana', pe: 'pernambuco', pi: 'piaui',
          rj: 'riodejaneiro', rn: 'riograndedonorte', rs: 'riograndedosul', ro: 'rondonia',
          rr: 'roraima', sc: 'santacatarina', sp: 'saopaulo', se: 'sergipe', to: 'tocantins'
        };
        const nomeUf = ufParaNome[nomeEdicaoNorm];
        if (nomeUf) {
          const encontradoPorUf = this.estadosDisponiveis.find((e) =>
            this.normalizarTextoComparacao(e.text).includes(nomeUf)
          );
          if (encontradoPorUf) return encontradoPorUf;
        }
      }

      const encontradoPorNome = this.estadosDisponiveis.find((e) => {
        const estadoNorm = this.normalizarTextoComparacao(e.text);
        return estadoNorm === nomeEdicaoNorm ||
          estadoNorm.includes(nomeEdicaoNorm) ||
          nomeEdicaoNorm.includes(estadoNorm);
      });
      if (encontradoPorNome) return encontradoPorNome;
    }

    return null;
  }

  private carregarCidadesPorEstado(idEstado: number): void {
    this.mostrarListaCidades = false;
    if (!idEstado || idEstado <= 0) {
      this.cidadesDisponiveis = [];
      this.cidadesFiltradas = [];
      this.formCliente?.get('cidade')?.setValue(null, { emitEvent: false });
      return;
    }

    const url = API + `empresa/Clinica/GetCidades?idEstado=${idEstado}`;
    this.isCarregandoCidades = true;

    this.ajaxService.get(url).subscribe({
      next: (response) => {
        const lista = response?.data && Array.isArray(response.data) ? response.data : [];
        this.cidadesDisponiveis = lista
          .filter((item: any) => item && typeof item === 'object')
          .map((item: any) => this.util.converterParaLowercase(item))
          .map((item: any) => ({
            id: Number(item.id || 0),
            text: this.toText(item.text)
          }))
          .filter((item: IdValueItem) => item.id > 0 && !!item.text);
        this.cidadesFiltradas = [...this.cidadesDisponiveis];

        const cidadeAtual = Number(this.formCliente?.get('cidade')?.value || 0);
        const cidadeExiste = this.cidadesDisponiveis.some((c) => c.id === cidadeAtual);
        const cidadeEdicaoExiste = this.idCidadeEdicao
          ? this.cidadesDisponiveis.some((c) => c.id === this.idCidadeEdicao)
          : false;

        if (cidadeExiste) {
          const cidadeSelecionada = this.cidadesDisponiveis.find((c) => c.id === cidadeAtual);
          if (cidadeSelecionada) {
            this.definirCidadeSelecionada(cidadeSelecionada.id, cidadeSelecionada.text);
          }
        } else if (cidadeEdicaoExiste && this.idCidadeEdicao) {
          const cidadeSelecionada = this.cidadesDisponiveis.find((c) => c.id === this.idCidadeEdicao);
          if (cidadeSelecionada) {
            this.definirCidadeSelecionada(cidadeSelecionada.id, cidadeSelecionada.text);
          }
        } else if (this.cidadeBuscaTexto) {
          this.tentarResolverCidadePeloTexto(true);
        } else {
          this.formCliente?.get('cidade')?.setValue(null, { emitEvent: false });
          this.cidadeBuscaTexto = '';
        }

        this.isCarregandoCidades = false;
        this.atualizarEstadoSalvarCliente();
      },
      error: () => {
        this.cidadesDisponiveis = [];
        this.cidadesFiltradas = [];
        this.formCliente?.get('cidade')?.setValue(null, { emitEvent: false });
        this.cidadeBuscaTexto = '';
        this.isCarregandoCidades = false;
        this.atualizarEstadoSalvarCliente();
      }
    });
  }

  private aplicarFiltroCidades(): void {
    const termo = this.toText(this.cidadeBuscaTexto).toLowerCase();
    if (!termo) {
      this.cidadesFiltradas = [...this.cidadesDisponiveis];
      return;
    }

    this.cidadesFiltradas = this.cidadesDisponiveis.filter((cidade) =>
      cidade.text.toLowerCase().includes(termo)
    );
  }

  private parseBoolean(value: any): boolean {
    if (typeof value === 'boolean') return value;
    if (typeof value === 'number') return value === 1;
    const text = this.toText(value).toLowerCase();
    return text === '1' || text === 'true' || text === 'sim' || text === 'yes';
  }

  private atualizarValidacaoSenha(isModoEdicao: boolean): void {
    const senhaControl = this.formCliente?.get('senha');
    if (!senhaControl) return;

    if (isModoEdicao) {
      // Na edição a senha é opcional; vazio mantém a senha já cadastrada no servidor.
      senhaControl.setValidators([]);
    } else {
      senhaControl.setValidators([Validators.required, Validators.minLength(6)]);
    }

    senhaControl.updateValueAndValidity({ emitEvent: false });
  }

  /** Aceita e-mails com TLD composto (ex.: usuario@outlook.com.br). */
  private emailValido(valor: any): boolean {
    const e = this.toText(valor);
    if (!e) return false;
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i.test(e);
  }

  private validadorEmail(control: { value: any }): { email: boolean } | null {
    const v = this.toText(control?.value);
    if (!v) return null;
    return this.emailValido(v) ? null : { email: true };
  }

  private normalizarTextoComparacao(value: any): string {
    return this.toText(value)
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-zA-Z0-9]/g, '')
      .toLowerCase();
  }

  private processarPaisPendente(): void {
    if (!this.idPaisPendente || this.idPaisPendente <= 0) return;
    const idPais = this.idPaisPendente;
    this.idPaisPendente = null;
    this.carregarEstadosPorPais(idPais);
  }

  private carregarClienteEdicaoPorId(): void {
    if (!this.idPacienteEdicao || this.idPacienteEdicao <= 0) return;

    const url = API + 'empresa/Paciente/ConsultarClienteUsuario';
    this.ajaxService.get(url).subscribe({
      next: (response) => {
        const lista = response?.data && Array.isArray(response.data) ? response.data : [];
        const cliente = lista
          .filter((item: any) => item && typeof item === 'object')
          .map((item: any) => this.util.converterParaLowercase(item))
          .find((item: any) => Number(item.id_paciente_clinica || item.id || 0) === this.idPacienteEdicao);

        if (!cliente) return;
        this.preencherFormularioComDadosCliente(cliente);
        this.invalidarCacheNaturalizacaoPaciente();
        this.invalidarCacheCidadaniaPaciente();
        this.invalidarCacheAirePaciente();
        this.invalidarCacheFastItPaciente();
        this.invalidarCacheTraducaoPaciente();
        this.invalidarCacheBuscaItaliaPaciente();
        this.invalidarCacheBuscaBrasilPaciente();
        if (this.abaAtiva === 'servicos' && this.subAbaAtiva === 'naturalizacao') {
          this.carregarOpcoesStatusNaturalizacaoSeNecessario();
          this.garantirDadosNaturalizacaoCarregados(true);
        }
        if (this.abaAtiva === 'servicos' && this.subAbaAtiva === 'jud-ita') {
          this.garantirDadosCidadaniaCarregados(true);
        }
        if (this.abaAtiva === 'servicos' && this.subAbaAtiva === 'aire') {
          this.carregarOpcoesStatusNaturalizacaoSeNecessario();
          this.garantirDadosAireCarregados(true);
        }
        if (this.abaAtiva === 'servicos' && this.subAbaAtiva === 'fast-it') {
          this.carregarOpcoesStatusNaturalizacaoSeNecessario();
          this.garantirDadosFastItCarregados(true);
        }
        if (this.abaAtiva === 'servicos' && this.subAbaAtiva === 'traducao') {
          this.carregarOpcoesStatusTraducaoSeNecessario();
          this.carregarOpcoesTipoDocumentoTraducaoSeNecessario();
          this.garantirDadosTraducaoCarregados(true);
        }
        if (this.abaAtiva === 'servicos' && this.subAbaAtiva === 'busca-documentos') {
          this.garantirOpcoesStatusBuscaDocumentos();
          if (this.subAbaBuscaAtiva === 'italia') {
            this.carregarOpcoesTipoDocumentoBuscaItaliaSeNecessario();
            this.garantirDadosBuscaItaliaCarregados(true);
          }
          if (this.subAbaBuscaAtiva === 'brasil') {
            this.carregarOpcoesTipoDocumentoBuscaBrasilSeNecessario();
            this.garantirDadosBuscaBrasilCarregados(true);
          }
        }
      },
      error: () => {
        // Mantém dados já carregados por query string quando a consulta falhar.
      }
    });
  }

  get idClienteOrcamentoAtual(): number {
    return Number(this.idPacienteEdicao || 0);
  }

  carregarDadosIniciaisOrcamento(): void {
    if (this.idClienteOrcamentoAtual <= 0) return;
    this.carregarMicroservicosLookup();
    this.carregarConsultasOrcamento();
    this.buscarOrcamentosConsulta();
  }

  get orcamentosConsultaFiltrados(): OrcamentoConsultaItem[] {
    const termo = this.toText(this.filtroTituloOrcamentoExistente).toLowerCase();
    if (!termo) return this.orcamentosConsulta;
    return this.orcamentosConsulta.filter((item) =>
      this.toText(item.titulo).toLowerCase().includes(termo)
    );
  }

  abrirModalCadastroOrcamento(): void {
    this.carregandoDetalheOrcamento = false;
    this.modoVisualizacaoOrcamento = false;
    this.modalCadastroOrcamentoAberto = true;
    this.idOrcamentoEdicao = 0;
    this.tituloOrcamento = '';
    this.descontoOrcamento = 0;
    this.acrescimoOrcamento = 0;
    this.observacaoGeralOrcamento = '';
    this.observacaoImpressaoOrcamento = '';
    this.exibirParaCliente = false;
    this.orcamentoAprovado = false;
    this.financeiroGeradoOrcamento = false;
    this.dataGeracaoFinanceiroOrcamento = '';
    this.idConsultaOrcamentoSelecionada = this.resolverIdConsultaOrcamentoAtual();
    this.idTabelaPrecoSelecionada = 0;
    this.orcamentoItensGrid = [];
    this.totalOrcamentoGrid = 0;
    this.carregarConsultasOrcamento();
    this.sincronizarObservacaoImpressaoEditor();
  }

  fecharModalCadastroOrcamento(): void {
    this.modalCadastroOrcamentoAberto = false;
    this.modoVisualizacaoOrcamento = false;
  }

  private carregarConsultasOrcamento(): void {
    if (this.idClienteOrcamentoAtual <= 0) {
      this.consultasOrcamento = [];
      this.idConsultaOrcamentoSelecionada = 0;
      return;
    }

    const url = `${API}empresa/Consulta/ConsultarConsultasLookup?id_paciente=${this.idClienteOrcamentoAtual}`;
    this.ajaxService.get(url).subscribe({
      next: (response) => {
        const lista = this.extrairListaResponse(this.desempacotarResponse(response))
          .map((item: any) => this.util.converterParaLowercase(item || {}))
          .map((item: any) => ({
            idConsulta: Number(item.id || item.idconsulta || 0),
            descricao: this.toText(item.descricao || item.text || item.nome || item.idconsulta)
          }))
          .filter((item: ConsultaOrcamentoLookupItem) => item.idConsulta > 0);

        this.consultasOrcamento = lista;
        if (this.idConsultaOrcamentoSelecionada <= 0 && lista.length > 0) {
          this.idConsultaOrcamentoSelecionada = lista[0].idConsulta;
          this.buscarOrcamentosConsulta();
        }
      },
      error: () => {
        this.consultasOrcamento = [];
      }
    });
  }

  private carregarMicroservicosLookup(): void {
    const url = `${API}empresa/Consulta/ConsultarMicroservicosLookup`;
    this.ajaxService.get(url).subscribe({
      next: (response) => {
        const lista = this.extrairListaResponse(this.desempacotarResponse(response))
          .map((item: any) => this.util.converterParaLowercase(item || {}))
          .map((item: any) => ({
            idTabelaFin: Number(item.id || item.idtabelafin || 0),
            itemMicroservico: this.toText(item.itemmicroservico || item.item || item.descricao),
            descricaoMicroservico: this.toText(item.descricaomicroservico || item.descricao || ''),
            nomeFornecedor: this.toText(item.nomefornecedor || item.parceiro || item.finDocumento || ''),
            valor: Number(item.valor || 0)
          }))
          .filter((item: MicroservicoLookupItem) => item.idTabelaFin > 0);

        this.microservicosLookup = lista;
      },
      error: () => {
        this.microservicosLookup = [];
      }
    });
  }

  adicionarMicroservicoSelecionado(): void {
    if (this.isEdicaoItensOrcamentoBloqueada()) {
      this.util.toasterShowWarning('Atenção', 'Com o financeiro gerado, os itens do orçamento não podem ser alterados.');
      return;
    }

    if (this.idTabelaPrecoSelecionada <= 0) {
      this.util.toasterShowError('Atenção', 'Selecione um microserviço para adicionar.');
      return;
    }

    const jaExisteSelecionado = this.orcamentoItensGrid.some(
      (x) => Number(x.idTabelaFin || 0) === Number(this.idTabelaPrecoSelecionada || 0)
    );
    if (jaExisteSelecionado) {
      this.util.toasterShowError('Atenção', 'Este microserviço já foi adicionado ao orçamento.');
      return;
    }

    const url = `${API}empresa/Consulta/PegarLinhaMicroservicosLookup?id=${this.idTabelaPrecoSelecionada}`;
    this.ajaxService.get(url).subscribe({
      next: (response) => {
        const lista = this.extrairListaResponse(this.desempacotarResponse(response))
          .map((item: any) => this.util.converterParaLowercase(item || {}));
        const item = lista[0];
        if (!item) return;

        const idTabelaFin = Number(item.idtabelafin || item.id || this.idTabelaPrecoSelecionada || 0);
        const jaExiste = this.orcamentoItensGrid.some(
          (x) => Number(x.idTabelaFin || 0) === idTabelaFin
        );
        if (jaExiste) {
          this.util.toasterShowError('Atenção', 'Este microserviço já foi adicionado ao orçamento.');
          return;
        }

        this.orcamentoItensGrid.push({
          selecionado: false,
          idTabelaFin,
          item: this.toText(item.itemmicroservico || item.item || item.descricao),
          descricao: this.toText(item.descricaomicroservico || item.descricao || ''),
          parceiro: this.toText(item.nomefornecedor || item.parceiro || ''),
          quantidade: 1,
          valor: Number(item.valor || 0),
          observacao: ''
        });

        this.recalcularTotalOrcamento();
      },
      error: () => {
        this.util.toasterShowError('Erro', 'Não foi possível carregar o microserviço selecionado.');
      }
    });
  }

  onQuantidadeOrcamentoChange(item: OrcamentoItemGrid): void {
    if (this.isEdicaoItensOrcamentoBloqueada()) {
      this.util.toasterShowWarning('Atenção', 'Com o financeiro gerado, os itens do orçamento não podem ser alterados.');
      return;
    }
    const qtd = Number(item.quantidade || 0);
    item.quantidade = qtd > 0 ? Math.floor(qtd) : 1;
    this.recalcularTotalOrcamento();
  }

  removerItensSelecionadosOrcamento(): void {
    if (this.isEdicaoItensOrcamentoBloqueada()) {
      this.util.toasterShowWarning('Atenção', 'Com o financeiro gerado, os itens do orçamento não podem ser alterados.');
      return;
    }
    this.orcamentoItensGrid = this.orcamentoItensGrid.filter((item) => !item.selecionado);
    this.recalcularTotalOrcamento();
  }

  abrirModalObservacao(indice: number): void {
    if (this.isEdicaoItensOrcamentoBloqueada()) {
      this.util.toasterShowWarning('Atenção', 'Com o financeiro gerado, os itens do orçamento não podem ser alterados.');
      return;
    }
    this.indiceObservacaoAtual = indice;
    this.observacaoModalTexto = this.orcamentoItensGrid[indice]?.observacao || '';
    this.modalObservacaoAberto = true;
  }

  salvarObservacaoModal(): void {
    if (this.indiceObservacaoAtual < 0 || this.indiceObservacaoAtual >= this.orcamentoItensGrid.length) {
      this.fecharModalObservacao();
      return;
    }

    this.orcamentoItensGrid[this.indiceObservacaoAtual].observacao = this.toText(this.observacaoModalTexto);
    this.fecharModalObservacao();
  }

  onObservacaoImpressaoInput(event: Event): void {
    const target = event.target as HTMLElement | null;
    this.observacaoImpressaoOrcamento = target?.innerHTML || '';
  }

  executarComandoObservacaoImpressao(comando: string): void {
    const editor = this.observacaoImpressaoEditor?.nativeElement;
    if (!editor) return;
    editor.focus();
    document.execCommand(comando, false);
    this.observacaoImpressaoOrcamento = this.orcamentoImpressaoOrcamentoAtual();
  }

  onObservacaoImpressaoPaste(event: ClipboardEvent): void {
    if (!event) return;
    event.preventDefault();

    const clipboard = event.clipboardData;
    if (!clipboard) return;

    const html = clipboard.getData('text/html');
    const text = clipboard.getData('text/plain');
    const conteudo = this.toText(html) ? html : this.escaparHtmlParaEditor(text);

    // Mantém o HTML colado (ex.: Word) para preservar a formatação.
    document.execCommand('insertHTML', false, conteudo);
    setTimeout(() => {
      this.observacaoImpressaoOrcamento = this.orcamentoImpressaoOrcamentoAtual();
    }, 0);
  }

  gerarFinanceiroOrcamentoFake(): void {
    const idConsulta = this.resolverIdConsultaOrcamentoAtual();
    if (idConsulta > 0) {
      this.idConsultaOrcamentoSelecionada = idConsulta;
    }

    if (this.financeiroGeradoOrcamento) {
      this.util.toasterShowError('Atenção', 'O financeiro deste orçamento já foi gerado e continua ativo.');
      return;
    }

    if (idConsulta <= 0 && this.idOrcamentoEdicao <= 0) {
      this.util.toasterShowError('Atenção', 'Não foi possível identificar o orçamento para gerar o financeiro.');
      return;
    }

    this.dataVencimentoFinanceiro = '';
    this.idTipoRecebimentoFinanceiro = 0;
    this.qtdParcelasFinanceiro = 1;
    this.modalGerarFinanceiroAberto = true;
    this.carregarTiposRecebimentoFinanceiro();
  }

  private carregarTiposRecebimentoFinanceiro(): void {
    this.carregandoTiposRecebimentoFinanceiro = true;
    this.ajaxService.get(`${API}financeiro/FinContaReceber/ConsultarOpcoes`).subscribe({
      next: (response) => {
        this.carregandoTiposRecebimentoFinanceiro = false;
        if (response?.hasErrors) {
          this.util.toasterShowError('Erro', response?.message || 'Não foi possível carregar os tipos de recebimento.');
          return;
        }

        const data = this.desempacotarResponse(response);
        const tipos = this.extrairListaResponse(
          data?.tiposRecebimento || data?.tiposrecebimento || data?.tipoPagamento || data?.tipopagamento
        );

        this.tiposRecebimentoFinanceiro = tipos
          .filter((item: any) => item && typeof item === 'object')
          .map((item: any) => this.util.converterParaLowercase(item))
          .map((item: any) => ({
            id: Number(item.id || 0),
            descricao: this.toText(item.descricao)
          }))
          .filter((item: TipoRecebimentoOpcao) => item.id > 0 && !!item.descricao);
      },
      error: () => {
        this.carregandoTiposRecebimentoFinanceiro = false;
        this.tiposRecebimentoFinanceiro = [];
        this.util.toasterShowError('Erro', 'Não foi possível carregar os tipos de recebimento.');
      }
    });
  }

  confirmarGeracaoFinanceiroOrcamento(): void {
    const idConsulta = this.resolverIdConsultaOrcamentoAtual();
    if (idConsulta > 0) {
      this.idConsultaOrcamentoSelecionada = idConsulta;
    }

    if (idConsulta <= 0 && this.idOrcamentoEdicao <= 0) {
      this.util.toasterShowError('Atenção', 'Orçamento não identificado para gerar o financeiro.');
      return;
    }

    if (!this.dataVencimentoFinanceiro) {
      this.util.toasterShowError('Atenção', 'Informe a data de vencimento.');
      return;
    }

    if (this.idTipoRecebimentoFinanceiro <= 0) {
      this.util.toasterShowError('Atenção', 'Selecione o tipo de recebimento.');
      return;
    }

    const qtd = Math.floor(Number(this.qtdParcelasFinanceiro));
    if (!Number.isFinite(qtd) || qtd < 1) {
      this.util.toasterShowError('Atenção', 'Informe a quantidade de parcelas (mínimo 1).');
      return;
    }
    if (qtd > 120) {
      this.util.toasterShowError('Atenção', 'Quantidade de parcelas máxima: 120.');
      return;
    }

    const payload = {
      idConsulta: idConsulta > 0 ? idConsulta.toString() : '0',
      idOrcamento: this.idOrcamentoEdicao > 0 ? this.idOrcamentoEdicao.toString() : '0',
      dataVencimento: this.dataVencimentoFinanceiro,
      idTipoRecebimento: this.idTipoRecebimentoFinanceiro,
      quantidadeParcelas: qtd
    };

    this.util.showLoading();
    this.ajaxService.post(`${API}empresa/Consulta/GerarFinanceiroOrcamento`, payload).subscribe({
      next: (response) => {
        this.util.closeLoading();
        if (response?.hasErrors) {
          this.util.toasterShowError('Erro', response?.message || 'Não foi possível gerar o financeiro.');
          return;
        }

        this.util.toasterShowSuccess('Sucesso', response?.message || 'Financeiro gerado com sucesso!');
        this.financeiroGeradoOrcamento = true;
        this.dataGeracaoFinanceiroOrcamento = new Date().toISOString();
        const orcamentoLista = this.orcamentosConsulta.find((item) => item.idOrcamento === this.idOrcamentoEdicao);
        if (orcamentoLista) {
          orcamentoLista.financeiroGerado = true;
          orcamentoLista.dataGeracaoFinanceiro = this.dataGeracaoFinanceiroOrcamento;
        }
        this.fecharModalGerarFinanceiro();
      },
      error: () => {
        this.util.closeLoading();
        this.util.toasterShowError('Erro', 'Erro ao gerar o financeiro.');
      }
    });
  }

  fecharModalObservacao(): void {
    this.modalObservacaoAberto = false;
    this.observacaoModalTexto = '';
    this.indiceObservacaoAtual = -1;
  }

  fecharModalGerarFinanceiro(): void {
    this.modalGerarFinanceiroAberto = false;
    this.dataVencimentoFinanceiro = '';
    this.idTipoRecebimentoFinanceiro = 0;
    this.qtdParcelasFinanceiro = 1;
  }

  abrirModalObservacaoContextoGlobal(): void {
    const valorAtual = String(this.formCliente?.get('observacoes')?.value || '');
    this.observacaoContextoGlobalHtml = this.normalizarHtmlObservacaoContexto(valorAtual);
    this.modalObservacaoContextoGlobalAberto = true;
    this.sincronizarObservacaoContextoGlobalEditor();
  }

  fecharModalObservacaoContextoGlobal(): void {
    this.modalObservacaoContextoGlobalAberto = false;
  }

  salvarObservacaoContextoGlobal(): void {
    if (!this.podeEditarObservacaoContextoGlobal) {
      return;
    }

    if (!this.idPacienteEdicao || this.idPacienteEdicao <= 0) {
      this.util.toasterShowError(
        'Atenção',
        'Salve o cadastro do cliente antes de gravar a observação.'
      );
      return;
    }

    const editor = this.observacaoContextoGlobalEditor?.nativeElement;
    const observacoes = String(editor?.innerHTML ?? this.observacaoContextoGlobalHtml ?? '');
    this.observacaoContextoGlobalHtml = observacoes;
    this.formCliente?.get('observacoes')?.setValue(observacoes, { emitEvent: false });

    const payload = {
      ID_PACIENTE_CLINICA: this.idPacienteEdicao,
      OBSERVACOES: observacoes
    };

    this.salvandoObservacaoContextoGlobal = true;
    this.util.showLoading();
    this.ajaxService.post(API + 'empresa/Paciente/SalvarObservacao', payload).subscribe({
      next: (response) => {
        this.util.closeLoading();
        this.salvandoObservacaoContextoGlobal = false;
        if (response?.hasErrors) {
          this.util.toasterShowError(
            'Erro',
            response?.message || 'Não foi possível salvar a observação.'
          );
          return;
        }
        this.formCliente?.get('observacoes')?.markAsPristine();
        this.util.toasterShowSuccess('Sucesso', 'Observação salva com sucesso.');
        this.fecharModalObservacaoContextoGlobal();
      },
      error: () => {
        this.util.closeLoading();
        this.salvandoObservacaoContextoGlobal = false;
        this.util.toasterShowError('Erro', 'Não foi possível salvar a observação.');
      }
    });
  }

  /** Modal de observação editável em qualquer aba (salva via API dedicada). */
  get podeEditarObservacaoContextoGlobal(): boolean {
    return true;
  }

  get podeSalvarObservacaoContextoGlobal(): boolean {
    return this.idPacienteEdicao > 0 && !this.salvandoObservacaoContextoGlobal;
  }

  get clienteJaCadastrado(): boolean {
    return this.idPacienteEdicao > 0;
  }

  getObservacaoContextoPreview(): string {
    const valorAtual = String(this.formCliente?.get('observacoes')?.value || '');
    const html = this.normalizarHtmlObservacaoContexto(valorAtual);
    return this.toText(html) ? html : '<span class="text-muted">Sem observações.</span>';
  }

  onObservacaoContextoGlobalInput(event: Event): void {
    if (!this.podeEditarObservacaoContextoGlobal) {
      return;
    }
    const target = event.target as HTMLElement | null;
    this.observacaoContextoGlobalHtml = target?.innerHTML || '';
    this.atualizarObservacaoContextoGlobalDoEditor();
  }

  onObservacaoContextoGlobalKeydown(event: KeyboardEvent): void {
    if (!this.podeEditarObservacaoContextoGlobal) {
      return;
    }
    if (event.key !== 'Enter' || event.isComposing) {
      return;
    }
    if (event.shiftKey || event.ctrlKey || event.altKey || event.metaKey) {
      return;
    }

    event.preventDefault();

    const editor = this.observacaoContextoGlobalEditor?.nativeElement;
    if (!editor) {
      return;
    }

    editor.focus();
    const prefixoData = `${this.formatarDataObservacaoHoje()} `;

    document.execCommand('insertParagraph', false);
    document.execCommand('insertText', false, prefixoData);

    this.observacaoContextoGlobalHtml = editor.innerHTML || '';
    this.atualizarObservacaoContextoGlobalDoEditor();
  }

  private formatarDataObservacaoHoje(): string {
    const hoje = new Date();
    const dia = String(hoje.getDate()).padStart(2, '0');
    const mes = String(hoje.getMonth() + 1).padStart(2, '0');
    const ano = hoje.getFullYear();
    return `${dia}/${mes}/${ano}`;
  }

  private atualizarObservacaoContextoGlobalDoEditor(): void {
    this.formCliente?.get('observacoes')?.setValue(this.observacaoContextoGlobalHtml, { emitEvent: false });
    this.formCliente?.get('observacoes')?.markAsDirty();
  }

  executarComandoObservacaoContextoGlobal(comando: string): void {
    if (!this.podeEditarObservacaoContextoGlobal) {
      return;
    }
    const editor = this.observacaoContextoGlobalEditor?.nativeElement;
    if (!editor) return;
    editor.focus();
    document.execCommand(comando, false);
    this.observacaoContextoGlobalHtml = editor.innerHTML || '';
    this.atualizarObservacaoContextoGlobalDoEditor();
  }

  onObservacaoContextoGlobalPaste(event: ClipboardEvent): void {
    if (!this.podeEditarObservacaoContextoGlobal) {
      return;
    }
    if (!event) return;
    event.preventDefault();

    const clipboard = event.clipboardData;
    if (!clipboard) return;

    const html = clipboard.getData('text/html');
    const text = clipboard.getData('text/plain');
    const conteudo = this.toText(html) ? html : this.escaparHtmlParaEditor(text);
    document.execCommand('insertHTML', false, conteudo);

    setTimeout(() => {
      const editor = this.observacaoContextoGlobalEditor?.nativeElement;
      this.observacaoContextoGlobalHtml = editor?.innerHTML || '';
      this.atualizarObservacaoContextoGlobalDoEditor();
    }, 0);
  }

  private recalcularTotalOrcamento(): void {
    this.totalOrcamentoGrid = this.orcamentoItensGrid.reduce((acc, item) => {
      return acc + (Number(item.valor || 0) * Number(item.quantidade || 0));
    }, 0);
  }

  salvarOrcamentoCadastroGeral(): void {
    const idConsulta = this.resolverIdConsultaOrcamentoAtual();
    this.idConsultaOrcamentoSelecionada = idConsulta;

    if (!this.toText(this.tituloOrcamento)) {
      this.util.toasterShowError('Atenção', 'Informe o título do orçamento!');
      return;
    }

    if (this.orcamentoItensGrid.length <= 0) {
      this.util.toasterShowError('Atenção', 'Entre com pelo menos um microserviço!');
      return;
    }

    const idUsuarioOrcamento = Number(this.idUsuarioEdicao || 0);
    if (idUsuarioOrcamento <= 0) {
      this.util.toasterShowError('Atenção', 'Usuário do cliente não identificado para salvar o orçamento.');
      return;
    }

    const payload = {
      idOrcamento: this.idOrcamentoEdicao > 0 ? this.idOrcamentoEdicao.toString() : '0',
      idConsulta: idConsulta.toString(),
      titulo: this.toText(this.tituloOrcamento),
      desconto: Number(this.descontoOrcamento || 0),
      acrescimo: Number(this.acrescimoOrcamento || 0),
      observacaoGeral: this.toText(this.observacaoGeralOrcamento),
      observacaoImpressao: String(this.observacaoImpressaoOrcamento || ''),
      idUsuario: idUsuarioOrcamento,
      CLIENTE_VER: this.exibirParaCliente,
      ORCAMENTO_APROVADO: this.orcamentoAprovado,
      itens: this.orcamentoItensGrid.map((item) => ({
        idTabelaValor: Number(item.idTabelaFin || 0),
        quantidade: Number(item.quantidade || 1),
        observacao: this.toText(item.observacao || '')
      }))
    };

    this.util.showLoading();
    this.ajaxService.post(`${API}empresa/Consulta/SalvarOrcamento`, payload).subscribe({
      next: (response) => {
        this.util.closeLoading();
        if (response?.hasErrors) {
          this.util.toasterShowError('Erro', response?.message || 'Não foi possível salvar o orçamento.');
          return;
        }

        this.idOrcamentoEdicao = Number(response?.data?.idOrcamento || 0);
        this.util.toasterShowSuccess('Sucesso', response?.message || 'Orçamento salvo com sucesso.');
        this.buscarOrcamentosConsulta();
        this.fecharModalCadastroOrcamento();
      },
      error: () => {
        this.util.closeLoading();
        this.util.toasterShowError('Erro', 'Erro ao salvar orçamento.');
      }
    });
  }

  editarOrcamentoConsulta(item: OrcamentoConsultaItem): void {
    this.carregarOrcamentoNoModal(item, false);
  }

  buscarOrcamentosConsulta(): void {
    if (this.idClienteOrcamentoAtual <= 0) {
      this.orcamentosConsulta = [];
      return;
    }

    const idUsuarioLista = Number(this.idUsuarioEdicao || 0);

    this.carregandoOrcamento = true;
    this.ajaxService
      .get(
        `${API}empresa/Consulta/ListarOrcamentos?id_paciente=${encodeURIComponent(String(this.idClienteOrcamentoAtual))}&id_usuario=${encodeURIComponent(String(idUsuarioLista))}`
      )
      .subscribe({
        next: (response) => {
          this.carregandoOrcamento = false;
          const data = this.desempacotarResponse(response);
          const lista = this.extrairListaResponse(data?.orcamentos || data)
            .map((item: any) => this.util.converterParaLowercase(item || {}))
            .map((item: any) => ({
              idOrcamento: Number(item.idorcamento || 0),
              idConsulta: Number(item.idconsulta || 0),
              titulo: this.toText(item.titulo),
              data: this.toText(item.data),
              observacao: this.toText(item.observacao),
              clienteVer: this.parseBoolean(item.clientever),
              orcamentoAprovado: this.parseBoolean(item.orcamentoaprovado),
              financeiroGerado: this.parseBoolean(item.financeirogerado),
              dataGeracaoFinanceiro: this.toText(item.datageracaofinanceiro)
            }))
            .filter((item: OrcamentoConsultaItem) => item.idOrcamento > 0);
          this.orcamentosConsulta = lista;
        },
        error: () => {
          this.carregandoOrcamento = false;
          this.orcamentosConsulta = [];
        }
      });
  }

  visualizarOrcamentoConsulta(item: OrcamentoConsultaItem): void {
    this.carregarOrcamentoNoModal(item, true);
  }

  imprimirOrcamentoConsulta(item: OrcamentoConsultaItem): void {
    if (!item || item.idOrcamento <= 0) return;
    const id = encodeURIComponent(String(item.idOrcamento));
    window.open(`${API}empresa/Consulta/imprimirOrcamentoGeral?id_orcamento=${id}`, '_blank');
  }

  imprimirOrcamentoConsultaDetalhe(item: OrcamentoConsultaItem): void {
    if (!item || item.idOrcamento <= 0) return;
    const id = encodeURIComponent(String(item.idOrcamento));
    window.open(`${API}empresa/Consulta/imprimirOrcamentoGeralDetalhe?id_orcamento=${id}`, '_blank');
  }

  private carregarOrcamentoNoModal(item: OrcamentoConsultaItem, somenteLeitura: boolean): void {
    if (!item || item.idOrcamento <= 0) return;
    this.carregandoDetalheOrcamento = true;
    this.modoVisualizacaoOrcamento = somenteLeitura;
    this.modalCadastroOrcamentoAberto = true;
    this.idOrcamentoEdicao = item.idOrcamento;

    this.ajaxService
      .get(`${API}empresa/Consulta/ObterOrcamento?idOrcamento=${item.idOrcamento}`)
      .subscribe({
        next: (response) => {
          this.carregandoDetalheOrcamento = false;
          const data = this.desempacotarResponse(response);
          const orcamento = this.util.converterParaLowercase(data?.orcamento || {});
          const itensApi = this.extrairListaResponse(data?.orcamentoItens || data?.orcamentoitens)
            .map((x: any) => this.util.converterParaLowercase(x || {}))
            .map((x: any) => ({
              idTabelaValor: Number(x.idtabelavalor || 0),
              quantidade: Number(x.quantidade || 1),
              observacao: this.toText(x.observacao)
            } as OrcamentoDetalheItemApi))
            .filter((x: OrcamentoDetalheItemApi) => x.idTabelaValor > 0);

          this.idConsultaOrcamentoSelecionada = Number(orcamento?.idconsulta || item.idConsulta || 0);
          this.tituloOrcamento = this.toText(orcamento?.titulo || item.titulo);
          this.descontoOrcamento = Number(orcamento?.desconto || 0);
          this.acrescimoOrcamento = Number(orcamento?.acrescimo || 0);
          this.observacaoGeralOrcamento = this.toText(orcamento?.observacaogeral || item.observacao);
          this.observacaoImpressaoOrcamento = String(orcamento?.observacaoimpressao || '');
          this.exibirParaCliente = !!orcamento?.clientever;
          this.orcamentoAprovado = !!orcamento?.orcamentoaprovado;
          this.financeiroGeradoOrcamento = !!orcamento?.financeirogerado;
          this.dataGeracaoFinanceiroOrcamento = this.toText(orcamento?.datageracaofinanceiro);

          this.orcamentoItensGrid = itensApi.map((detalhe) => {
            const micro = this.microservicosLookup.find((m) => m.idTabelaFin === detalhe.idTabelaValor);
            return {
              selecionado: false,
              idTabelaFin: detalhe.idTabelaValor,
              item: this.toText(micro?.itemMicroservico || `Item #${detalhe.idTabelaValor}`),
              descricao: this.toText(micro?.descricaoMicroservico || ''),
              parceiro: this.toText(micro?.nomeFornecedor || ''),
              quantidade: detalhe.quantidade > 0 ? detalhe.quantidade : 1,
              valor: Number(micro?.valor || 0),
              observacao: detalhe.observacao
            } as OrcamentoItemGrid;
          });
          this.recalcularTotalOrcamento();
          this.sincronizarObservacaoImpressaoEditor();
        },
        error: () => {
          this.carregandoDetalheOrcamento = false;
          this.util.toasterShowError('Erro', 'Não foi possível carregar o orçamento.');
          this.fecharModalCadastroOrcamento();
        }
      });
  }

  private orcamentoImpressaoOrcamentoAtual(): string {
    return this.observacaoImpressaoEditor?.nativeElement?.innerHTML || '';
  }

  private sincronizarObservacaoImpressaoEditor(): void {
    setTimeout(() => {
      const editor = this.observacaoImpressaoEditor?.nativeElement;
      if (!editor || this.modoVisualizacaoOrcamento) return;
      const html = String(this.observacaoImpressaoOrcamento || '');
      if (editor.innerHTML !== html) {
        editor.innerHTML = html;
      }
    }, 0);
  }

  private sincronizarObservacaoContextoGlobalEditor(): void {
    setTimeout(() => {
      const editor = this.observacaoContextoGlobalEditor?.nativeElement;
      if (!editor) return;
      const html = String(this.observacaoContextoGlobalHtml || '');
      if (editor.innerHTML !== html) {
        editor.innerHTML = html;
      }
    }, 0);
  }

  private normalizarHtmlObservacaoContexto(valor: string): string {
    const texto = String(valor || '');
    if (!texto.trim()) {
      return '';
    }
    const temTagHtml = /<\/?[a-z][\s\S]*>/i.test(texto);
    return temTagHtml ? texto : this.escaparHtmlParaEditor(texto);
  }

  private escaparHtmlParaEditor(value: string): string {
    return this.toText(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/\n/g, '<br>');
  }

  excluirOrcamentoConsulta(item: OrcamentoConsultaItem): void {
    if (!item || item.idOrcamento <= 0) return;
    if (!confirm('Tem certeza que deseja excluir este item?')) return;

    const payload = { id_orcamento: item.idOrcamento.toString() };
    this.util.showLoading();
    this.ajaxService.post(`${API}empresa/Consulta/deletarOrcamento`, payload).subscribe({
      next: (response) => {
        this.util.closeLoading();
        if (response?.hasErrors) {
          this.util.toasterShowError('Erro', response?.message || 'Não foi possível excluir o orçamento.');
          return;
        }
        this.util.toasterShowSuccess('Sucesso', 'Item excluído com sucesso!');
        this.buscarOrcamentosConsulta();
      },
      error: () => {
        this.util.closeLoading();
        this.util.toasterShowError('Erro', 'Erro ao excluir orçamento.');
      }
    });
  }

  formatMoneyBRL(valor: number): string {
    return (Number(valor || 0)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  formatDataHoraMin(value: string): string {
    const texto = this.toText(value);
    if (!texto) return '';

    const data = new Date(texto);
    if (!Number.isNaN(data.getTime())) {
      const dia = String(data.getDate()).padStart(2, '0');
      const mes = String(data.getMonth() + 1).padStart(2, '0');
      const ano = String(data.getFullYear());
      const hora = String(data.getHours()).padStart(2, '0');
      const minuto = String(data.getMinutes()).padStart(2, '0');
      return `${dia}/${mes}/${ano} ${hora}:${minuto}`;
    }

    const matchIso = texto.match(/^(\d{4}-\d{2}-\d{2})[ T](\d{2}):(\d{2})/);
    if (matchIso) {
      const [ano, mes, dia] = matchIso[1].split('-');
      return `${dia}/${mes}/${ano} ${matchIso[2]}:${matchIso[3]}`;
    }

    const matchBr = texto.match(/^(\d{2}\/\d{2}\/\d{4})[ T](\d{2}):(\d{2})/);
    if (matchBr) {
      return `${matchBr[1]} ${matchBr[2]}:${matchBr[3]}`;
    }

    return texto;
  }

  private resolverIdConsultaOrcamentoAtual(): number {
    if (this.idConsultaOrcamentoSelecionada > 0) {
      return this.idConsultaOrcamentoSelecionada;
    }

    if (this.idOrcamentoEdicao > 0) {
      const orcamentoAtual = this.orcamentosConsulta.find((item) => item.idOrcamento === this.idOrcamentoEdicao);
      const idConsultaOrcamento = Number(orcamentoAtual?.idConsulta || 0);
      if (idConsultaOrcamento > 0) {
        return idConsultaOrcamento;
      }
    }

    if (this.consultasOrcamento.length > 0) {
      return Number(this.consultasOrcamento[0]?.idConsulta || 0);
    }

    return 0;
  }

  isEdicaoItensOrcamentoBloqueada(): boolean {
    return !this.modoVisualizacaoOrcamento && this.idOrcamentoEdicao > 0 && this.financeiroGeradoOrcamento;
  }

  private carregarOpcoesStatusNaturalizacaoSeNecessario(): void {
    this.carregarOpcoesStatusPorTipoSeNecessario(
      'STATUS_SERVICO',
      () => this.statusNaturalizacaoOpcoes,
      (opcoes) => {
        this.statusNaturalizacaoOpcoes = opcoes;
      },
      () => this.carregandoStatusNaturalizacao,
      (v) => {
        this.carregandoStatusNaturalizacao = v;
      },
    );
  }

  private carregarOpcoesStatusTraducaoSeNecessario(): void {
    this.carregarOpcoesStatusPorTipoSeNecessario(
      this.tipoStatusTraducao,
      () => this.statusTraducaoOpcoes,
      (opcoes) => {
        this.statusTraducaoOpcoes = opcoes;
      },
      () => this.carregandoStatusTraducao,
      (v) => {
        this.carregandoStatusTraducao = v;
      },
    );
  }

  private carregarOpcoesStatusBuscaBrasilSeNecessario(): void {
    this.carregarOpcoesStatusPorTipoSeNecessario(
      this.tipoStatusBuscaBrasil,
      () => this.statusBuscaBrasilOpcoes,
      (opcoes) => {
        this.statusBuscaBrasilOpcoes = opcoes;
      },
      () => this.carregandoStatusBuscaBrasil,
      (v) => {
        this.carregandoStatusBuscaBrasil = v;
      },
    );
  }

  private carregarOpcoesStatusBuscaItaliaSeNecessario(): void {
    this.carregarOpcoesStatusPorTipoSeNecessario(
      this.tipoStatusBuscaItalia,
      () => this.statusBuscaItaliaOpcoes,
      (opcoes) => {
        this.statusBuscaItaliaOpcoes = opcoes;
      },
      () => this.carregandoStatusBuscaItalia,
      (v) => {
        this.carregandoStatusBuscaItalia = v;
      },
    );
  }

  private garantirOpcoesStatusBuscaDocumentos(): void {
    if (this.subAbaBuscaAtiva === 'italia') {
      this.carregarOpcoesStatusBuscaItaliaSeNecessario();
    } else {
      this.carregarOpcoesStatusBuscaBrasilSeNecessario();
    }
  }

  private carregarOpcoesStatusPorTipoSeNecessario(
    tipo: string,
    getOpcoes: () => StatusGeralServicoOpcao[],
    setOpcoes: (opcoes: StatusGeralServicoOpcao[]) => void,
    getCarregando: () => boolean,
    setCarregando: (valor: boolean) => void,
  ): void {
    if (getCarregando() || getOpcoes().length > 0) {
      return;
    }
    setCarregando(true);
    const url = `${API}empresa/StatusGeralServicos/Consultar?tipo=${encodeURIComponent(tipo)}`;
    this.ajaxService.get(url).subscribe({
      next: (response) => {
        setCarregando(false);
        if (response?.hasErrors) {
          setOpcoes([]);
          this.cdr.detectChanges();
          return;
        }
        const raw = this.desempacotarResponse(response);
        const lista = Array.isArray(raw) ? raw : this.extrairListaResponse(raw);
        setOpcoes(this.mapearListaStatusGeralServicos(lista));
        this.cdr.detectChanges();
      },
      error: () => {
        setCarregando(false);
        setOpcoes([]);
        this.util.toasterShowError('Erro', 'Não foi possível carregar os status do serviço.');
        this.cdr.detectChanges();
      },
    });
  }

  private mapearListaStatusGeralServicos(lista: unknown[]): StatusGeralServicoOpcao[] {
    return (lista || [])
      .map((raw) => {
        const item = raw as Record<string, unknown>;
        const idSg = Number(
          this.lerValorRegistroApi(item, ['ID_STATUS_GERAL', 'id_STATUS_GERAL', 'id_status_geral', 'idStatusGeral']) ?? 0,
        );
        const tituloBruto = this.lerValorRegistroApi(item, ['TITULO', 'titulo', 'tITULO', 'Titulo']);
        const titulo = this.toText(tituloBruto) || `#${idSg}`;
        return { idStatusGeral: idSg, titulo };
      })
      .filter((x: StatusGeralServicoOpcao) => x.idStatusGeral > 0);
  }

  garantirDadosResponsavelClienteCarregados(forcar = false): void {
    const idPac = Number(this.idPacienteEdicao || 0);
    if (idPac <= 0) {
      this.responsavelClienteLinhas = [];
      this.responsavelClienteCarregadoParaPaciente = -1;
      this.cdr.detectChanges();
      return;
    }
    if (!forcar && this.responsavelClienteCarregadoParaPaciente === idPac && !this.carregandoResponsavelCliente) {
      return;
    }
    this.carregarResponsavelCliente(idPac);
  }

  salvarResponsavelCliente(): void {
    const idPac = Number(this.idPacienteEdicao || 0);
    if (idPac <= 0) {
      this.util.toasterShowWarning('Atenção', 'Salve o cliente antes de vincular responsáveis.');
      return;
    }

    const linhas = (this.responsavelClienteLinhas || [])
      .filter((x) => x.idCadResponsavel > 0)
      .map((x) => ({
        ID_USU_RESPONSAVEL: Number(x.idUsuResponsavel || 0),
        ID_CAD_RESPONSAVEL: x.idCadResponsavel,
        DATA: this.dataLocalParaPayloadApi(x.data),
        SETAR: !!x.setar,
      }));

    const payload = {
      ID_PACIENTE_CLINICA: idPac,
      Linhas: linhas,
    };

    this.salvandoResponsavelCliente = true;
    this.util.showLoading();
    this.ajaxService.post(`${API}empresa/UsuResponsavel/SaveAsync`, payload).subscribe({
      next: (response) => {
        this.salvandoResponsavelCliente = false;
        this.util.closeLoading();
        if (response?.hasErrors || response?.HasErrors) {
          this.util.toasterShowError(
            'Erro',
            response?.message || response?.Message || 'Não foi possível salvar os responsáveis do cliente.',
          );
          this.cdr.detectChanges();
          return;
        }
        this.util.toasterShowSuccess('Sucesso', 'Responsáveis do cliente salvos.');
        this.responsavelClienteCarregadoParaPaciente = -1;
        this.carregarResponsavelCliente(idPac);
      },
      error: () => {
        this.salvandoResponsavelCliente = false;
        this.util.closeLoading();
        this.util.toasterShowError('Erro', 'Falha ao salvar responsáveis do cliente.');
        this.cdr.detectChanges();
      },
    });
  }

  private carregarResponsavelCliente(idPacienteClinica: number): void {
    this.carregandoResponsavelCliente = true;
    const url = `${API}empresa/UsuResponsavel/ConsultarPorPaciente?idPacienteClinica=${idPacienteClinica}`;
    this.ajaxService.get(url).subscribe({
      next: (response) => {
        this.carregandoResponsavelCliente = false;
        if (response?.hasErrors || response?.HasErrors) {
          this.responsavelClienteLinhas = [];
          this.responsavelClienteCarregadoParaPaciente = idPacienteClinica;
          this.util.toasterShowError(
            'Erro',
            response?.message || response?.Message || 'Não foi possível carregar os responsáveis.',
          );
          this.cdr.detectChanges();
          return;
        }
        const raw = this.desempacotarResponse(response);
        const lista = Array.isArray(raw) ? raw : this.extrairListaResponse(raw);
        this.responsavelClienteLinhas = this.mapearLinhasResponsavelCliente(lista);
        this.responsavelClienteCarregadoParaPaciente = idPacienteClinica;
        this.cdr.detectChanges();
      },
      error: () => {
        this.carregandoResponsavelCliente = false;
        this.responsavelClienteLinhas = [];
        this.responsavelClienteCarregadoParaPaciente = idPacienteClinica;
        this.util.toasterShowError('Erro', 'Não foi possível carregar os responsáveis.');
        this.cdr.detectChanges();
      },
    });
  }

  private mapearLinhasResponsavelCliente(lista: unknown[]): ResponsavelClienteLinha[] {
    return (lista || [])
      .map((raw) => {
        const item = raw as Record<string, unknown>;
        const idUsu = Number(
          this.lerValorRegistroApi(item, [
            'ID_USU_RESPONSAVEL',
            'id_USU_RESPONSAVEL',
            'id_usu_responsavel',
            'idUsuResponsavel',
          ]) ?? 0,
        );
        const idCad = Number(
          this.lerValorRegistroApi(item, [
            'ID_CAD_RESPONSAVEL',
            'id_CAD_RESPONSAVEL',
            'id_cad_responsavel',
            'idCadResponsavel',
          ]) ?? 0,
        );
        const responsavel = this.toText(
          this.lerValorRegistroApi(item, ['RESPONSAVEL', 'responsavel', 'Responsavel']),
        );
        const sigla = this.toText(this.lerValorRegistroApi(item, ['SIGLA', 'sigla', 'Sigla']));
        const ordem = Math.max(0, Math.trunc(Number(this.lerValorRegistroApi(item, ['ORDEM', 'ordem', 'Ordem']) ?? 0) || 0));
        const dataBruta = this.lerValorRegistroApi(item, ['DATA', 'data', 'Data']);
        const data = this.converterDataApiParaInputLocal(dataBruta);
        const setar = this.util.parseBoolean(this.lerValorRegistroApi(item, ['SETAR', 'setar', 'Setar']));
        return {
          idUsuResponsavel: idUsu,
          idCadResponsavel: idCad,
          responsavel,
          sigla,
          ordem,
          data,
          setar,
        };
      })
      .filter((x) => x.idCadResponsavel > 0)
      .sort(
        (a, b) =>
          a.ordem - b.ordem ||
          a.responsavel.localeCompare(b.responsavel, 'pt-BR', { sensitivity: 'base' }) ||
          a.sigla.localeCompare(b.sigla, 'pt-BR', { sensitivity: 'base' }),
      );
  }

  private carregarOpcoesTipoDocumentoTraducaoSeNecessario(): void {
    if (this.carregandoTiposDocumentoTraducao || this.tiposDocumentoTraducaoOpcoes.length > 0) {
      return;
    }
    this.carregarOpcoesTipoDocumentoTraducao();
  }

  private carregarOpcoesTipoDocumentoBuscaBrasilSeNecessario(): void {
    if (this.carregandoTiposDocumentoBuscaBrasil || this.tiposDocumentoBuscaBrasilOpcoes.length > 0) {
      return;
    }
    this.carregarOpcoesTipoDocumentoBuscaBrasil();
  }

  private carregarOpcoesTipoDocumentoBuscaItaliaSeNecessario(): void {
    if (this.carregandoTiposDocumentoBuscaItalia || this.tiposDocumentoBuscaItaliaOpcoes.length > 0) {
      return;
    }
    this.carregarOpcoesTipoDocumentoBuscaItalia();
  }

  private carregarOpcoesTipoDocumentoBuscaItalia(): void {
    this.carregandoTiposDocumentoBuscaItalia = true;
    const url = `${API}empresa/ServicoTipoDocumento/Consultar?tipo=buscaItalia`;
    this.ajaxService.get(url).subscribe({
      next: (response) => {
        this.carregandoTiposDocumentoBuscaItalia = false;
        if (response?.hasErrors || response?.HasErrors) {
          this.tiposDocumentoBuscaItaliaOpcoes = [];
          this.cdr.detectChanges();
          return;
        }
        const raw = this.desempacotarResponse(response);
        const lista = Array.isArray(raw) ? raw : this.extrairListaResponse(raw);
        this.tiposDocumentoBuscaItaliaOpcoes = lista
          .map((item: Record<string, unknown>) => {
            const idTd = Number(this.lerValorRegistroApi(item, ['ID_TIPO_DOCUMENTO']) ?? 0);
            const tituloBruto = this.lerValorRegistroApi(item, ['TITULO', 'titulo', 'DESCRICAO', 'descricao']);
            const titulo = this.toText(tituloBruto) || `#${idTd}`;
            return { idTipoDocumento: idTd, titulo };
          })
          .filter((x: TipoDocumentoServicoOpcao) => x.idTipoDocumento > 0);
        this.cdr.detectChanges();
      },
      error: () => {
        this.carregandoTiposDocumentoBuscaItalia = false;
        this.tiposDocumentoBuscaItaliaOpcoes = [];
        this.util.toasterShowError('Erro', 'Não foi possível carregar os tipos de documento (busca Itália).');
        this.cdr.detectChanges();
      },
    });
  }

  private carregarOpcoesTipoDocumentoBuscaBrasil(): void {
    this.carregandoTiposDocumentoBuscaBrasil = true;
    const url = `${API}empresa/ServicoTipoDocumento/Consultar?tipo=buscaBrasil`;
    this.ajaxService.get(url).subscribe({
      next: (response) => {
        this.carregandoTiposDocumentoBuscaBrasil = false;
        if (response?.hasErrors || response?.HasErrors) {
          this.tiposDocumentoBuscaBrasilOpcoes = [];
          this.cdr.detectChanges();
          return;
        }
        const raw = this.desempacotarResponse(response);
        const lista = Array.isArray(raw) ? raw : this.extrairListaResponse(raw);
        this.tiposDocumentoBuscaBrasilOpcoes = lista
          .map((item: Record<string, unknown>) => {
            const idTd = Number(this.lerValorRegistroApi(item, ['ID_TIPO_DOCUMENTO']) ?? 0);
            const tituloBruto = this.lerValorRegistroApi(item, ['TITULO', 'titulo', 'DESCRICAO', 'descricao']);
            const titulo = this.toText(tituloBruto) || `#${idTd}`;
            return { idTipoDocumento: idTd, titulo };
          })
          .filter((x: TipoDocumentoServicoOpcao) => x.idTipoDocumento > 0);
        this.cdr.detectChanges();
      },
      error: () => {
        this.carregandoTiposDocumentoBuscaBrasil = false;
        this.tiposDocumentoBuscaBrasilOpcoes = [];
        this.util.toasterShowError('Erro', 'Não foi possível carregar os tipos de documento (busca Brasil).');
        this.cdr.detectChanges();
      },
    });
  }

  private carregarItensTraducao(idPacienteClinica: number, tentarSemFiltroAba = false): void {
    if (idPacienteClinica <= 0) {
      this.traducaoItens = [];
      this.cdr.detectChanges();
      return;
    }

    let url = `${API}empresa/UsuTraducao/ConsultarItens?idPacienteClinica=${idPacienteClinica}`;
    if (!tentarSemFiltroAba) {
      url += `&nomeAba=${encodeURIComponent(this.chaveTraducao)}`;
    }

    this.ajaxService.get(url).subscribe({
      next: (response) => {
        if (response?.hasErrors || response?.HasErrors) {
          this.traducaoItens = [];
          const msg =
            response?.message ||
            response?.Message ||
            'Não foi possível carregar os documentos da tradução.';
          this.util.toasterShowError('Erro', msg);
          this.cdr.detectChanges();
          return;
        }
        const raw = this.desempacotarResponse(response);
        const lista = Array.isArray(raw) ? raw : [];
        this.traducaoItens = this.mapearItensBuscaBrasilDoBackend(lista);
        this.cdr.detectChanges();
      },
      error: (err) => {
        if (!tentarSemFiltroAba) {
          this.carregarItensTraducao(idPacienteClinica, true);
          return;
        }
        this.traducaoItens = [];
        const msgApi =
          err?.error?.message ||
          err?.error?.Message ||
          err?.message ||
          'Não foi possível carregar os documentos da tradução.';
        this.util.toasterShowError('Erro', msgApi);
        this.cdr.detectChanges();
      },
    });
  }

  private carregarOpcoesTipoDocumentoTraducao(): void {
    this.carregandoTiposDocumentoTraducao = true;
    const url = `${API}empresa/ServicoTipoDocumento/Consultar?tipo=${encodeURIComponent(this.chaveTraducao)}`;
    this.ajaxService.get(url).subscribe({
      next: (response) => {
        this.carregandoTiposDocumentoTraducao = false;
        if (response?.hasErrors || response?.HasErrors) {
          this.tiposDocumentoTraducaoOpcoes = [];
          this.cdr.detectChanges();
          return;
        }
        const raw = this.desempacotarResponse(response);
        const lista = Array.isArray(raw) ? raw : this.extrairListaResponse(raw);
        this.tiposDocumentoTraducaoOpcoes = lista
          .map((item: Record<string, unknown>) => {
            const idTd = Number(this.lerValorRegistroApi(item, ['ID_TIPO_DOCUMENTO']) ?? 0);
            const tituloBruto = this.lerValorRegistroApi(item, ['TITULO', 'titulo', 'DESCRICAO', 'descricao']);
            const titulo = this.toText(tituloBruto) || `#${idTd}`;
            return { idTipoDocumento: idTd, titulo };
          })
          .filter((x: TipoDocumentoServicoOpcao) => x.idTipoDocumento > 0);
        this.cdr.detectChanges();
      },
      error: () => {
        this.carregandoTiposDocumentoTraducao = false;
        this.tiposDocumentoTraducaoOpcoes = [];
        this.util.toasterShowError('Erro', 'Não foi possível carregar os tipos de documento.');
        this.cdr.detectChanges();
      },
    });
  }

  /** Serviços → Busca documentos: status; Itália (+ tipos traducão) ou Brasil conforme sub-aba. */
  private garantirOpcoesEBuscaDocumentos(): void {
    this.garantirOpcoesStatusBuscaDocumentos();
    if (this.subAbaBuscaAtiva === 'italia') {
      this.carregarOpcoesTipoDocumentoBuscaItaliaSeNecessario();
      this.garantirDadosBuscaItaliaCarregados();
    } else if (this.subAbaBuscaAtiva === 'brasil') {
      this.carregarOpcoesTipoDocumentoBuscaBrasilSeNecessario();
      this.garantirDadosBuscaBrasilCarregados();
    }
  }

  private invalidarCacheNaturalizacaoPaciente(): void {
    this.naturalizacaoDadosPacienteCarregados = -1;
  }

  private garantirDadosNaturalizacaoCarregados(force = false): void {
    const idPac = Number(this.idPacienteEdicao || 0);
    if (idPac <= 0) {
      return;
    }
    if (!force && this.naturalizacaoDadosPacienteCarregados === idPac) {
      return;
    }
    this.carregarOpcoesStatusNaturalizacaoSeNecessario();
    this.carregarDadosNaturalizacaoDoPaciente(idPac);
  }

  private carregarDadosNaturalizacaoDoPaciente(idPaciente: number): void {
    const url = `${API}empresa/UsuNaturalizacao/Consultar?idPacienteClinica=${idPaciente}`;
    this.ajaxService.get(url).subscribe({
      next: (response) => {
        if (response?.hasErrors) {
          this.util.toasterShowError('Erro', response?.message || 'Não foi possível consultar naturalização.');
          return;
        }
        const raw = this.desempacotarResponse(response);
        const lista = Array.isArray(raw) ? raw : [];
        if (lista.length === 0) {
          if (Number(this.idPacienteEdicao || 0) === idPaciente) {
            this.formNaturalizacao.patchValue(
              {
                idUsuNaturalizacao: 0,
                comuneTranscricao: '',
                dadosTranscricao: '',
                nomeConjugeItaliana: '',
                idStatusGeral: null,
                usuario: '',
                senha: '',
                invioDigitale: '',
                accettazione: '',
                praticaK10: '',
                consegnaOriginali: '',
                notificaDecreto: '',
                giuramento: '',
              },
              { emitEvent: false },
            );
            this.naturalizacaoSenhaVisivel = false;
          }
          this.naturalizacaoDadosPacienteCarregados = idPaciente;
          this.formNaturalizacao.markAsPristine();
          this.cdr.detectChanges();
          return;
        }
        const primeiro = lista[0];
        if (Number(this.idPacienteEdicao || 0) === idPaciente) {
          this.aplicarNaturalizacaoDoBackend(primeiro);
        }
        this.naturalizacaoDadosPacienteCarregados = idPaciente;
        this.cdr.detectChanges();
      },
      error: () => {
        this.util.toasterShowError('Erro', 'Não foi possível carregar a naturalização.');
      },
    });
  }

  private aplicarNaturalizacaoDoBackend(ent: unknown): void {
    this.naturalizacaoSenhaVisivel = false;
    if (!ent || typeof ent !== 'object') {
      return;
    }
    const e = ent as Record<string, unknown>;
    const idRow = Number(this.lerValorRegistroApi(e, ['ID_USU_NATURALIZACAO']) ?? 0);
    const idStatus = Number(this.lerValorRegistroApi(e, ['ID_STATUS_GERAL']) ?? 0);

    this.formNaturalizacao.patchValue(
      {
        idUsuNaturalizacao: idRow,
        comuneTranscricao: this.toText(this.lerValorRegistroApi(e, ['COMUNE_TRANSCRICAO'])),
        dadosTranscricao: this.toText(this.lerValorRegistroApi(e, ['DADOS_TRANSCRICAO'])),
        nomeConjugeItaliana: this.toText(this.lerValorRegistroApi(e, ['NOME_CONJUGE_ITALIANA'])),
        idStatusGeral: idStatus > 0 ? idStatus : null,
        usuario: this.toText(this.lerValorRegistroApi(e, ['USUARIO'])),
        senha: this.toText(this.lerValorRegistroApi(e, ['SENHA'])),
        invioDigitale: this.converterDataApiParaInputLocal(this.lerValorRegistroApi(e, ['INVIO_DIGITALE'])),
        accettazione: this.converterDataApiParaInputLocal(this.lerValorRegistroApi(e, ['ACCETTAZIONE'])),
        praticaK10: this.toText(this.lerValorRegistroApi(e, ['PRATICA_K10'])),
        consegnaOriginali: this.converterDataApiParaInputLocal(this.lerValorRegistroApi(e, ['CONSEGNA_ORIGINALI'])),
        notificaDecreto: this.converterDataApiParaInputLocal(this.lerValorRegistroApi(e, ['NOTIFICA_DECRETO'])),
        giuramento: this.converterDataApiParaInputLocal(
          this.lerValorRegistroApi(e, ['GUIRAMENTO', 'GIURAMENTO', 'giuramento']),
        ),
      },
      { emitEvent: false },
    );
    this.formNaturalizacao.markAsPristine();
  }

  private montarPaternaMaternaPayloadJudIta(v: Record<string, unknown>): string | null {
    const p = !!v.viaPaterna;
    const m = !!v.viaMaterna;
    if (!p && !m) {
      return null;
    }
    if (p && m) {
      return 'PM';
    }
    if (p) {
      return 'P';
    }
    return 'M';
  }

  private aplicarViaPaternaMaternaDoPm(pm: unknown): { viaPaterna: boolean; viaMaterna: boolean } {
    const s = this.toText(pm).toUpperCase().replace(/\s+/g, '');
    return {
      viaPaterna: s.includes('P'),
      viaMaterna: s.includes('M'),
    };
  }

  private aplicarCidadaniaDoBackend(ent: unknown): void {
    if (!ent || typeof ent !== 'object') {
      return;
    }
    const e = ent as Record<string, unknown>;
    const idRow = Number(this.lerValorRegistroApi(e, ['ID_USU_CIDADANIA']) ?? 0);
    const { viaPaterna, viaMaterna } = this.aplicarViaPaternaMaternaDoPm(this.lerValorRegistroApi(e, ['PATERNA_MATERNA']));

    const danteCausaNovo = this.toText(this.lerValorRegistroApi(e, ['DANTE_CAUSA']));
    const nome = this.toText(this.lerValorRegistroApi(e, ['NOME']));
    const sobrenome = this.toText(this.lerValorRegistroApi(e, ['SOBRENOME']));
    const danteCausa =
      danteCausaNovo || [nome, sobrenome].filter((p) => !!p).join(' ').trim();

    this.formJudIta.patchValue(
      {
        idUsuCidadania: idRow,
        modalidade: this.normalizarModalidadeCidadania(this.lerValorRegistroApi(e, ['MODALIDADE', 'modalidade'])),
        danteCausa,
        comune: this.toText(this.lerValorRegistroApi(e, ['COMUNE'])),
        statusAdministrativo: this.toText(this.lerValorRegistroApi(e, ['STATUS_ADMINISTRATIVO'])),
        ag: this.toText(this.lerValorRegistroApi(e, ['AG'])),
        agVfs: this.toText(this.lerValorRegistroApi(e, ['AG_VFS'])),
        dataAg: this.converterDataApiParaInputLocal(this.lerValorRegistroApi(e, ['DATA_AG'])),
        dataConvocacao: this.converterDataApiParaInputLocal(this.lerValorRegistroApi(e, ['DATA_CONVOCACAO'])),
        dataEntregaConsulado: this.converterDataApiParaInputLocal(this.lerValorRegistroApi(e, ['DATA_ENTREGA_CONSULADO'])),
        viaPaterna,
        viaMaterna,
        remessaOnline: this.converterDataApiParaInputLocal(this.lerValorRegistroApi(e, ['REMESSA_ONLINE'])),
        remessaFisica: this.converterDataApiParaInputLocal(this.lerValorRegistroApi(e, ['REMESSA_FISICA'])),
        ajuizamento: this.converterDataApiParaInputLocal(this.lerValorRegistroApi(e, ['AJUIZAMENTO'])),
        tribunal: this.normalizarTribunalCidadania(this.lerValorRegistroApi(e, ['TRIBUNAL'])),
        nrg: this.toText(this.lerValorRegistroApi(e, ['NRG'])),
        audiencia: this.converterDataApiParaInputLocal(this.lerValorRegistroApi(e, ['AUDIENCIA'])),
        sentenca: this.converterDataApiParaInputLocal(this.lerValorRegistroApi(e, ['SENTENCA'])),
        richiesto: this.converterDataApiParaInputLocal(this.lerValorRegistroApi(e, ['PIG_RICHIESTO'])),
        ritirato: this.converterDataApiParaInputLocal(this.lerValorRegistroApi(e, ['PIG_RITIRATO'])),
        invioDocAdemp: this.converterDataApiParaInputLocal(this.lerValorRegistroApi(e, ['INVIO_DOC_ADEMP'])),
        transcritasRecebidas: this.converterDataApiParaInputLocal(this.lerValorRegistroApi(e, ['TRANSCRITAS_RECEBIDAS'])),
        apeloNotificado: this.converterDataApiParaInputLocal(this.lerValorRegistroApi(e, ['APELO_NOTIFICADO'])),
        apeloInscrito: this.converterDataApiParaInputLocal(this.lerValorRegistroApi(e, ['APELO_INSCRITO'])),
        primeiraAudiencia: this.converterDataApiParaInputLocal(this.lerValorRegistroApi(e, ['APELO_1_AUDIENCIA'])),
        segundaAudiencia: this.converterDataApiParaInputLocal(this.lerValorRegistroApi(e, ['APELO_2_AUDIENCIA'])),
        sentencaApelo: this.converterDataApiParaInputLocal(this.lerValorRegistroApi(e, ['APELO_SENTENCA'])),
      },
      { emitEvent: false },
    );
    this.judItaSecaoApeloVisivel = this.parseBoolean(
      this.lerValorRegistroApi(e, ['HABILITAR_APELO', 'habilitar_apelo']),
    );
    this.formJudIta.markAsPristine();
  }

  alternarJudItaToggleSecaoApelo(event: Event): void {
    const el = event.target as HTMLInputElement;
    this.judItaSecaoApeloVisivel = !!el?.checked;
    this.persistirToggleHabilitarApeloJudIta();
  }

  /** Grava HABILITAR_APELO (e o restante do formulário atual) ao alterar o toggle Apelo. */
  private persistirToggleHabilitarApeloJudIta(): void {
    const idPac = Number(this.idPacienteEdicao || 0);
    if (idPac <= 0) {
      return;
    }
    const payload = this.buildPayloadUsuCidadaniaJudIta();
    const url = `${API}empresa/UsuCidadania/SaveAsync`;
    this.ajaxService.post(url, payload).subscribe({
      next: (response) => {
        if (response?.hasErrors || response?.HasErrors) {
          this.util.toasterShowError(
            'Erro',
            response?.message ||
              response?.Message ||
              'Não foi possível salvar o toggle de Apelo.',
          );
          return;
        }
        const dados = this.desempacotarResponse(response);
        this.aplicarCidadaniaDoBackend(dados);
        this.cdr.detectChanges();
      },
      error: () => {
        this.util.toasterShowError('Erro', 'Não foi possível salvar o toggle de Apelo.');
      },
    });
  }

  private invalidarCacheCidadaniaPaciente(): void {
    this.cidadaniaDadosPacienteCarregados = -1;
  }

  private garantirDadosCidadaniaCarregados(force = false): void {
    const idPac = Number(this.idPacienteEdicao || 0);
    if (idPac <= 0) {
      return;
    }
    if (!force && this.cidadaniaDadosPacienteCarregados === idPac) {
      return;
    }
    this.carregarDadosCidadaniaDoPaciente(idPac);
  }

  private carregarDadosCidadaniaDoPaciente(idPaciente: number): void {
    const url = `${API}empresa/UsuCidadania/Consultar?idPacienteClinica=${idPaciente}`;
    this.ajaxService.get(url).subscribe({
      next: (response) => {
        if (response?.hasErrors || response?.HasErrors) {
          this.util.toasterShowError(
            'Erro',
            response?.message || response?.Message || 'Não foi possível consultar cidadania.',
          );
          return;
        }
        const raw = this.desempacotarResponse(response);
        const lista = Array.isArray(raw) ? raw : [];
        if (lista.length === 0) {
          if (Number(this.idPacienteEdicao || 0) === idPaciente) {
            this.judItaSecaoApeloVisivel = false;
            this.inicializarFormularioJudIta();
            this.cidadaniaDadosPacienteCarregados = idPaciente;
            this.formJudIta.markAsPristine();
            this.cdr.detectChanges();
          }
          return;
        }
        const primeiro = lista[0];
        if (Number(this.idPacienteEdicao || 0) === idPaciente) {
          this.aplicarCidadaniaDoBackend(primeiro);
        }
        this.cidadaniaDadosPacienteCarregados = idPaciente;
        this.cdr.detectChanges();
      },
      error: () => {
        this.util.toasterShowError('Erro', 'Não foi possível carregar cidadania.');
      },
    });
  }

  private aplicarAireDoBackend(ent: unknown): void {
    this.aireSenhaVisivel = false;
    if (!ent || typeof ent !== 'object') {
      return;
    }
    const e = ent as Record<string, unknown>;
    const idRow = Number(this.lerValorRegistroApi(e, ['ID_USU_AIRE']) ?? 0);
    const idStatus = Number(this.lerValorRegistroApi(e, ['ID_STATUS_GERAL']) ?? 0);

    this.formAire.patchValue(
      {
        idUsuAire: idRow,
        servicoPago: this.converterDataApiParaInputLocal(this.lerValorRegistroApi(e, ['SERVICO_PAGO'])),
        idStatusGeral: idStatus > 0 ? idStatus : null,
        consulado: this.toText(this.lerValorRegistroApi(e, ['CONSULADO'])),
        comune: this.toText(this.lerValorRegistroApi(e, ['COMUNE'])),
        usuario: this.toText(this.lerValorRegistroApi(e, ['USUARIO'])),
        senha: this.toText(this.lerValorRegistroApi(e, ['SENHA'])),
        inscricaoSolicitada: this.converterDataApiParaInputLocal(this.lerValorRegistroApi(e, ['INSCRICAO_SOLICITADA'])),
        inscricaoAprovada: this.converterDataApiParaInputLocal(this.lerValorRegistroApi(e, ['INSCRICAO_APROVADA'])),
      },
      { emitEvent: false },
    );
    this.formAire.markAsPristine();
  }

  private invalidarCacheAirePaciente(): void {
    this.aireDadosPacienteCarregados = -1;
  }

  private garantirDadosAireCarregados(force = false): void {
    const idPac = Number(this.idPacienteEdicao || 0);
    if (idPac <= 0) {
      return;
    }
    if (!force && this.aireDadosPacienteCarregados === idPac) {
      return;
    }
    this.carregarDadosAireDoPaciente(idPac);
  }

  private carregarDadosAireDoPaciente(idPaciente: number): void {
    const url = `${API}empresa/UsuAire/Consultar?idPacienteClinica=${idPaciente}`;
    this.ajaxService.get(url).subscribe({
      next: (response) => {
        if (response?.hasErrors || response?.HasErrors) {
          this.util.toasterShowError(
            'Erro',
            response?.message || response?.Message || 'Não foi possível consultar o AIRE.',
          );
          return;
        }
        const raw = this.desempacotarResponse(response);
        const lista = Array.isArray(raw) ? raw : [];
        if (lista.length === 0) {
          if (Number(this.idPacienteEdicao || 0) === idPaciente) {
            this.aireSenhaVisivel = false;
            this.inicializarFormularioAire();
            this.aireDadosPacienteCarregados = idPaciente;
            this.formAire.markAsPristine();
            this.cdr.detectChanges();
          }
          return;
        }
        const primeiro = lista[0];
        if (Number(this.idPacienteEdicao || 0) === idPaciente) {
          this.aplicarAireDoBackend(primeiro);
        }
        this.aireDadosPacienteCarregados = idPaciente;
        this.cdr.detectChanges();
      },
      error: () => {
        this.util.toasterShowError('Erro', 'Não foi possível carregar o AIRE.');
      },
    });
  }

  private aplicarFastItDoBackend(ent: unknown): void {
    this.fastItSenhaVisivel = false;
    if (!ent || typeof ent !== 'object') {
      return;
    }
    const e = ent as Record<string, unknown>;
    const idRow = Number(this.lerValorRegistroApi(e, ['ID_USU_FAST_IT']) ?? 0);
    const idStatus = Number(this.lerValorRegistroApi(e, ['ID_STATUS_GERAL']) ?? 0);

    this.formFastIt.patchValue(
      {
        idUsuFastIt: idRow,
        servicoPago: this.converterDataApiParaInputLocal(this.lerValorRegistroApi(e, ['SERVICO_PAGO'])),
        idStatusGeral: idStatus > 0 ? idStatus : null,
        consulado: this.toText(this.lerValorRegistroApi(e, ['CONSULADO'])),
        comune: this.toText(this.lerValorRegistroApi(e, ['COMUNE'])),
        usuario: this.toText(this.lerValorRegistroApi(e, ['USUARIO'])),
        senha: this.toText(this.lerValorRegistroApi(e, ['SENHA'])),
      },
      { emitEvent: false },
    );
    this.formFastIt.markAsPristine();
  }

  private invalidarCacheFastItPaciente(): void {
    this.fastItDadosPacienteCarregados = -1;
  }

  private garantirDadosFastItCarregados(force = false): void {
    const idPac = Number(this.idPacienteEdicao || 0);
    if (idPac <= 0) {
      return;
    }
    if (!force && this.fastItDadosPacienteCarregados === idPac) {
      return;
    }
    this.carregarDadosFastItDoPaciente(idPac);
  }

  private carregarDadosFastItDoPaciente(idPaciente: number): void {
    const url = `${API}empresa/UsuFastIt/Consultar?idPacienteClinica=${idPaciente}`;
    this.ajaxService.get(url).subscribe({
      next: (response) => {
        if (response?.hasErrors || response?.HasErrors) {
          this.util.toasterShowError(
            'Erro',
            response?.message || response?.Message || 'Não foi possível consultar o Fast-It.',
          );
          return;
        }
        const raw = this.desempacotarResponse(response);
        const lista = Array.isArray(raw) ? raw : [];
        if (lista.length === 0) {
          if (Number(this.idPacienteEdicao || 0) === idPaciente) {
            this.fastItSenhaVisivel = false;
            this.inicializarFormularioFastIt();
            this.fastItDadosPacienteCarregados = idPaciente;
            this.formFastIt.markAsPristine();
            this.cdr.detectChanges();
          }
          return;
        }
        const primeiro = lista[0];
        if (Number(this.idPacienteEdicao || 0) === idPaciente) {
          this.aplicarFastItDoBackend(primeiro);
        }
        this.fastItDadosPacienteCarregados = idPaciente;
        this.cdr.detectChanges();
      },
      error: () => {
        this.util.toasterShowError('Erro', 'Não foi possível carregar o Fast-It.');
      },
    });
  }

  /** Campos byte? (0/1) nos selects sim/nao do formulário. */
  private simNaoFormParaByte(valor: unknown): number | null {
    const s = this.toText(valor).toLowerCase();
    if (!s) {
      return null;
    }
    if (s === 'sim' || s === 's' || s === '1') {
      return 1;
    }
    if (s === 'nao' || s === 'não' || s === 'n' || s === '0') {
      return 0;
    }
    return null;
  }

  /** Toggle boolean (aba Tradução) ou texto legado → byte para a API. */
  private simNaoToggleParaByte(valor: unknown): number | null {
    if (typeof valor === 'boolean') {
      return valor ? 1 : 0;
    }
    return this.simNaoFormParaByte(valor);
  }

  /** Valor byte da API → toggle Sim/Não. */
  private byteParaSimNaoBoolean(valor: unknown): boolean {
    return this.byteParaSimNaoSelect(valor) === 'sim';
  }

  private byteParaSimNaoSelect(valor: unknown): string {
    if (valor === null || valor === undefined || valor === '') {
      return '';
    }
    const n = Number(valor);
    if (Number.isNaN(n)) {
      return '';
    }
    return n !== 0 ? 'sim' : 'nao';
  }

  private aplicarTraducaoDoBackend(ent: unknown): void {
    if (!ent || typeof ent !== 'object') {
      return;
    }
    const e = ent as Record<string, unknown>;
    const idRow = Number(this.lerValorRegistroApi(e, ['ID_USU_TRADUCAO']) ?? 0);
    const idStatus = Number(this.lerValorRegistroApi(e, ['ID_STATUS_GERAL']) ?? 0);

    this.formTraducao.patchValue(
      {
        idUsuTraducao: idRow,
        dataDemanda: this.converterDataApiParaInputLocal(this.lerValorRegistroApi(e, ['DATA_DEMANDA'])),
        prazoLimite: this.converterDataApiParaInputLocal(this.lerValorRegistroApi(e, ['PRAZO_LIMITE'])),
        idStatusGeral: idStatus > 0 ? idStatus : null,
        necessidadeDobradura: this.byteParaSimNaoBoolean(this.lerValorRegistroApi(e, ['NECESSIDADE_DOBRADURA'])),
        sedex: this.byteParaSimNaoBoolean(this.lerValorRegistroApi(e, ['SEDEX'])),
        codigoRastreio: this.toText(this.lerValorRegistroApi(e, ['CODIGO_RASTREIO'])),
        enviarPara: this.toText(this.lerValorRegistroApi(e, ['ENVIAR_PARA'])),
      },
      { emitEvent: false },
    );
    this.formTraducao.markAsPristine();
  }

  private invalidarCacheTraducaoPaciente(): void {
    this.traducaoDadosPacienteCarregados = -1;
  }

  private garantirDadosTraducaoCarregados(force = false): void {
    const idPac = Number(this.idPacienteEdicao || 0);
    if (idPac <= 0) {
      return;
    }
    if (!force && this.traducaoDadosPacienteCarregados === idPac) {
      return;
    }
    this.carregarOpcoesStatusTraducaoSeNecessario();
    this.carregarOpcoesTipoDocumentoTraducaoSeNecessario();
    this.carregarDadosTraducaoDoPaciente(idPac);
  }

  private carregarDadosTraducaoDoPaciente(idPaciente: number): void {
    const url = `${API}empresa/UsuTraducao/Consultar?idPacienteClinica=${idPaciente}`;
    this.ajaxService.get(url).subscribe({
      next: (response) => {
        if (response?.hasErrors || response?.HasErrors) {
          this.util.toasterShowError(
            'Erro',
            response?.message || response?.Message || 'Não foi possível consultar a tradução.',
          );
          return;
        }
        const raw = this.desempacotarResponse(response);
        const lista = Array.isArray(raw) ? raw : [];
        if (Number(this.idPacienteEdicao || 0) === idPaciente) {
          if (lista.length === 0) {
            this.inicializarFormularioTraducao();
          } else {
            this.aplicarTraducaoDoBackend(lista[0]);
          }
          this.carregarItensTraducao(idPaciente);
          this.traducaoDadosPacienteCarregados = idPaciente;
          this.formTraducao.markAsPristine();
          this.cdr.detectChanges();
        }
      },
      error: () => {
        this.util.toasterShowError('Erro', 'Não foi possível carregar a tradução.');
      },
    });
  }

  private aplicarBuscaItaliaDoBackend(ent: unknown): void {
    if (!ent || typeof ent !== 'object') {
      return;
    }
    const e = ent as Record<string, unknown>;
    const idRow = Number(this.lerValorRegistroApi(e, ['ID_BUSCA_DOCUMENTOS_ITALIA']) ?? 0);
    const idStatus = Number(this.lerValorRegistroApi(e, ['ID_STATUS_GERAL']) ?? 0);

    this.formBuscaItalia.patchValue(
      {
        idBuscaDocumentosItalia: idRow,
        dataDemanda: this.converterDataApiParaInputLocal(this.lerValorRegistroApi(e, ['DATA_DEMANDA'])),
        idStatusGeral: idStatus > 0 ? idStatus : null,
      },
      { emitEvent: false },
    );
    this.formBuscaItalia.markAsPristine();
  }

  private invalidarCacheBuscaItaliaPaciente(): void {
    this.buscaItaliaDadosPacienteCarregados = -1;
  }

  private garantirDadosBuscaItaliaCarregados(force = false): void {
    const idPac = Number(this.idPacienteEdicao || 0);
    if (idPac <= 0) {
      return;
    }
    if (!force && this.buscaItaliaDadosPacienteCarregados === idPac) {
      return;
    }
    this.carregarOpcoesStatusBuscaItaliaSeNecessario();
    this.carregarOpcoesTipoDocumentoBuscaItaliaSeNecessario();
    this.carregarDadosBuscaItaliaDoPaciente(idPac);
  }

  private carregarDadosBuscaItaliaDoPaciente(idPaciente: number): void {
    const url = `${API}empresa/UsuBuscaDocumentosItalia/Consultar?idPacienteClinica=${idPaciente}`;
    this.ajaxService.get(url).subscribe({
      next: (response) => {
        if (response?.hasErrors || response?.HasErrors) {
          this.util.toasterShowError(
            'Erro',
            response?.message || response?.Message || 'Não foi possível consultar busca documentos Itália.',
          );
          return;
        }
        const raw = this.desempacotarResponse(response);
        const lista = Array.isArray(raw) ? raw : [];
        if (Number(this.idPacienteEdicao || 0) === idPaciente) {
          if (lista.length === 0) {
            this.inicializarFormularioBuscaItalia();
          } else {
            this.aplicarBuscaItaliaDoBackend(lista[0]);
          }
          this.carregarItensBuscaItalia(idPaciente);
          this.buscaItaliaDadosPacienteCarregados = idPaciente;
          this.formBuscaItalia.markAsPristine();
          this.cdr.detectChanges();
        }
      },
      error: () => {
        this.util.toasterShowError('Erro', 'Não foi possível carregar busca documentos Itália.');
      },
    });
  }

  private carregarItensBuscaItalia(idPacienteClinica: number, tentarSemFiltroAba = false): void {
    if (idPacienteClinica <= 0) {
      this.buscaItaliaItens = [];
      this.cdr.detectChanges();
      return;
    }

    let url = `${API}empresa/UsuBuscaDocumentosItalia/ConsultarItens?idPacienteClinica=${idPacienteClinica}`;
    if (!tentarSemFiltroAba) {
      url += `&nomeAba=${encodeURIComponent(this.resolverNomeAbaBuscaDocumentosAtiva())}`;
    }

    this.ajaxService.get(url).subscribe({
      next: (response) => {
        if (response?.hasErrors || response?.HasErrors) {
          this.buscaItaliaItens = [];
          const msg =
            response?.message ||
            response?.Message ||
            'Não foi possível carregar os documentos da busca Itália.';
          this.util.toasterShowError('Erro', msg);
          this.cdr.detectChanges();
          return;
        }
        const raw = this.desempacotarResponse(response);
        const lista = Array.isArray(raw) ? raw : [];
        this.buscaItaliaItens = this.mapearItensBuscaBrasilDoBackend(lista);
        this.cdr.detectChanges();
      },
      error: (err) => {
        if (!tentarSemFiltroAba) {
          this.carregarItensBuscaItalia(idPacienteClinica, true);
          return;
        }
        this.buscaItaliaItens = [];
        const msgApi =
          err?.error?.message ||
          err?.error?.Message ||
          err?.message ||
          'Não foi possível carregar os documentos da busca Itália.';
        this.util.toasterShowError('Erro', msgApi);
        this.cdr.detectChanges();
      },
    });
  }

  private carregarItensBuscaBrasil(idPacienteClinica: number, tentarSemFiltroAba = false): void {
    if (idPacienteClinica <= 0) {
      this.buscaBrasilItens = [];
      this.cdr.detectChanges();
      return;
    }

    let url = `${API}empresa/UsuBuscaDocumentosBrasil/ConsultarItens?idPacienteClinica=${idPacienteClinica}`;
    if (!tentarSemFiltroAba) {
      url += `&nomeAba=${encodeURIComponent(this.resolverNomeAbaBuscaDocumentosAtiva())}`;
    }

    this.ajaxService.get(url).subscribe({
      next: (response) => {
        if (response?.hasErrors || response?.HasErrors) {
          this.buscaBrasilItens = [];
          const msg =
            response?.message ||
            response?.Message ||
            'Não foi possível carregar os documentos da busca Brasil.';
          this.util.toasterShowError('Erro', msg);
          this.cdr.detectChanges();
          return;
        }
        const raw = this.desempacotarResponse(response);
        const lista = Array.isArray(raw) ? raw : [];
        this.buscaBrasilItens = this.mapearItensBuscaBrasilDoBackend(lista);
        this.cdr.detectChanges();
      },
      error: (err) => {
        if (!tentarSemFiltroAba) {
          this.carregarItensBuscaBrasil(idPacienteClinica, true);
          return;
        }
        this.buscaBrasilItens = [];
        const msgApi =
          err?.error?.message ||
          err?.error?.Message ||
          err?.message ||
          'Não foi possível carregar os documentos da busca Brasil. Verifique se a tabela USU_DOCUMENTOS_PROVIDENCIADO existe no banco.';
        this.util.toasterShowError('Erro', msgApi);
        this.cdr.detectChanges();
      },
    });
  }

  private aplicarBuscaBrasilDoBackend(ent: unknown): void {
    if (!ent || typeof ent !== 'object') {
      return;
    }
    const e = ent as Record<string, unknown>;
    const idRow = Number(this.lerValorRegistroApi(e, ['ID_BUSCA_DOCUMENTOS_BRASIL']) ?? 0);
    const idStatus = Number(this.lerValorRegistroApi(e, ['ID_STATUS_GERAL']) ?? 0);

    this.formBuscaBrasil.patchValue(
      {
        idBuscaDocumentosBrasil: idRow,
        dataDemanda: this.converterDataApiParaInputLocal(this.lerValorRegistroApi(e, ['DATA_DEMANDA'])),
        idStatusGeral: idStatus > 0 ? idStatus : null,
      },
      { emitEvent: false },
    );
    this.formBuscaBrasil.markAsPristine();
  }

  private invalidarCacheBuscaBrasilPaciente(): void {
    this.buscaBrasilDadosPacienteCarregados = -1;
  }

  private garantirDadosBuscaBrasilCarregados(force = false): void {
    const idPac = Number(this.idPacienteEdicao || 0);
    if (idPac <= 0) {
      return;
    }
    if (!force && this.buscaBrasilDadosPacienteCarregados === idPac) {
      return;
    }
    this.carregarOpcoesStatusBuscaBrasilSeNecessario();
    this.carregarOpcoesTipoDocumentoBuscaBrasilSeNecessario();
    this.carregarDadosBuscaBrasilDoPaciente(idPac);
  }

  private carregarDadosBuscaBrasilDoPaciente(idPaciente: number): void {
    const url = `${API}empresa/UsuBuscaDocumentosBrasil/Consultar?idPacienteClinica=${idPaciente}`;
    this.ajaxService.get(url).subscribe({
      next: (response) => {
        if (response?.hasErrors || response?.HasErrors) {
          this.util.toasterShowError(
            'Erro',
            response?.message || response?.Message || 'Não foi possível consultar busca documentos Brasil.',
          );
          return;
        }
        const raw = this.desempacotarResponse(response);
        const lista = Array.isArray(raw) ? raw : [];
        if (Number(this.idPacienteEdicao || 0) === idPaciente) {
          if (lista.length === 0) {
            this.inicializarFormularioBuscaBrasil();
          } else {
            this.aplicarBuscaBrasilDoBackend(lista[0]);
          }
          this.carregarItensBuscaBrasil(idPaciente);
          this.buscaBrasilDadosPacienteCarregados = idPaciente;
          this.formBuscaBrasil.markAsPristine();
          this.cdr.detectChanges();
        }
      },
      error: () => {
        this.util.toasterShowError('Erro', 'Não foi possível carregar busca documentos Brasil.');
      },
    });
  }

  private converterDataDocumentoItemProvidenciado(valor: unknown): string {
    if (valor === null || valor === undefined || valor === '') {
      return '';
    }
    if (valor === false || valor === 0 || valor === '0') {
      return '';
    }
    if (valor === true || valor === 1 || valor === '1') {
      return '';
    }
    return this.converterDataApiParaInputLocal(valor);
  }

  private converterDataApiParaInputLocal(valor: unknown): string {
    if (valor === null || valor === undefined || valor === '') {
      return '';
    }
    const d = new Date(valor as string | number | Date);
    if (Number.isNaN(d.getTime())) {
      return '';
    }
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  }

  private dataLocalParaPayloadApi(valor: unknown): string | null {
    const s = this.toText(valor);
    if (!s) {
      return null;
    }
    const trimmed = s.trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
      return `${trimmed}T00:00:00`;
    }
    const d = new Date(trimmed);
    if (Number.isNaN(d.getTime())) {
      return null;
    }
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}T00:00:00`;
  }

  /**
   * ASP.NET Core costuma serializar em camelCase (ex.: ID_STATUS_GERAL → id_STATUS_GERAL);
   * este helper cobre esse caso e nomes declarados explicitamente na API.
   */
  private lerValorRegistroApi(obj: Record<string, unknown>, nomesPossiveis: string[]): unknown {
    for (const n of nomesPossiveis) {
      if (!Object.prototype.hasOwnProperty.call(obj, n)) {
        continue;
      }
      const v = obj[n];
      if (v !== undefined) {
        return v;
      }
    }
    const chavesObj = Object.keys(obj);
    for (const n of nomesPossiveis) {
      const alvo = n.toLowerCase();
      const chaveIgual = chavesObj.find((k) => k.toLowerCase() === alvo);
      if (chaveIgual !== undefined) {
        return obj[chaveIgual];
      }
    }

    /** Ex.: INVIO_DIGITALE, invioDigitale, invio_DIGITALE → mesma forma normalizada */
    const mapaNorm = new Map<string, string>();
    for (const k of chavesObj) {
      const nk = this.normalizarNomeCampoApi(k);
      if (!mapaNorm.has(nk)) {
        mapaNorm.set(nk, k);
      }
    }
    for (const n of nomesPossiveis) {
      const nk = this.normalizarNomeCampoApi(n);
      const chaveReal = mapaNorm.get(nk);
      if (
        chaveReal !== undefined &&
        Object.prototype.hasOwnProperty.call(obj, chaveReal) &&
        obj[chaveReal] !== undefined
      ) {
        return obj[chaveReal];
      }
    }
    return undefined;
  }

  private normalizarNomeCampoApi(chave: string): string {
    return chave.toLowerCase().replace(/_/g, '').replace(/\s+/g, '');
  }

  private desempacotarResponse(response: any): any {
    if (!response || typeof response !== 'object') {
      return response;
    }
    let primeiro =
      'data' in response && response.data !== undefined && response.data !== null ? response.data : undefined;
    if (primeiro === undefined && 'Data' in response && response.Data !== undefined && response.Data !== null) {
      primeiro = response.Data;
    }
    if (primeiro === undefined) {
      return response;
    }
    if (primeiro && typeof primeiro === 'object' && !Array.isArray(primeiro)) {
      const aninhado =
        'data' in primeiro && primeiro.data !== undefined && primeiro.data !== null ? primeiro.data : undefined;
      if (aninhado !== undefined) {
        return aninhado;
      }
      if ('Data' in primeiro && primeiro.Data !== undefined && primeiro.Data !== null) {
        return primeiro.Data;
      }
    }
    return primeiro;
  }

  private extrairListaResponse(payload: any): any[] {
    if (Array.isArray(payload)) return payload;
    if (payload && typeof payload === 'object') {
      const valores: any[] = [];
      Object.keys(payload).forEach((chave) => {
        valores.push(payload[chave]);
      });
      if (valores.length > 0 && valores.every((v) => v && typeof v === 'object')) {
        return valores;
      }
    }
    return [];
  }

}
